<script>
import Multiselect from "@vueform/multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import Loader from "../components/loader";
import api from "@/axios";
import DropZone from "@/components/widgets/dropZone";
import {ref} from "vue";
import moment from "moment";
import xmlFormat from "xml-formatter";
import {GridComponent, ColumnsDirective, ColumnDirective, Sort, Filter, Toolbar, ExcelExport, PdfExport} from '@syncfusion/ej2-vue-grids';
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Editar Cliente / Fornecedor",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout, PageHeader, Loader, Multiselect, DropZone,
    'ejs-grid': GridComponent,
    'e-columns': ColumnsDirective,
    'e-column': ColumnDirective,
  },
  provide: {
    grid: [Sort, Filter, Toolbar, ExcelExport, PdfExport] // <--- Adicionados módulos de exportação
  },
  setup() {
    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0]
    };
    return { dropzoneFile, drop};
  },
  data() {
    return {

      loadingVeicFxs: false,
      submmitedVeicFxData: false,
      novaFaixaVeic: false,
      pessoaVeicFxData: {},
      pessoaVeicFxsData: {},


      showFormVeic: false,
      pessoaVeicsData: null,
      pessoaVeicData: {},
      submmitedVeicData: false,


      showFormVeiCotDed: false,
      pessoaVeiCoDedsData: null,
      pessoaVeiCoDedData: {},
      submmitedVeiCoDedData: false,

      toolbarOptions: ['ExcelExport', 'PdfExport', 'CsvExport'],
      filterSettings: { type: 'Excel' }, // Define o tipo de filtro como Excel
      loadingEmprDadPub: false,
      loadingEmprsDadPub: false,
      showModalDadosPublicos: false,
      emprElkData: {},
      empresasElkData: {},
      emprElkDataSociosData: {},
      visibleAcord1DaPub: true,
      visibleAcord2DaPub: false,

      dtListEquipesRepres: {},
      dtlistPesqFaixaRepres: {},
      faixaRepresExist: false,
      pessoaRepresData: {},
      pessoaRepresFxsData: {},
      loadingRepresFxs: false,
      loadingRepresFx: false,
      optionsRepresFx: {},

      showParamComissao: false,
      pessoaRepresComissao: {
        id: null,
        pessoa_id: null,
        codigo: null,
        descricao: null,
        contacpf: null,
        status: 'A',
        represtime_id: null,
        represfx_ids: [],
        nomefavorecido: null,
        banco_id: null,
        banco: null,
        tipo: 'TED',
        agencia: null,
        conta: null,
        tipochavepix: null,
        chavepix: null,
        lider: false,
        total_saldo_atual_retido: 0,
        inadimplencia_atual: 0,
        perc_retencao_padrao: 20,
      },
      dtListPesqConta: null,
      contaData: null,
      loadingConta: false,

      pessoaFreteAdicsData: {},
      pessoaFreteAdicData: {},
      showFormFreteAdic: false,
      dtListPesqFreteAdicBase: null,
      submmitedFreteAdic: false,

      submmitedFormula: false,
      cotaFreteInternoListData: {},
      loadingCotarFrete: false,
      pessoaMailsCotaData: {},
      pessoaMailCotaData: {},
      showFormMailCota: false,
      showFormFormulaFrete: false,
      submittedMailCota: false,

      submittedMail: false,
      pessoaEmailsData: {},
      pessoaEmailData: {},
      showFormMail: false,


      pessoaTokensData: {},
      pessoaTokenData: {},
      showFormToken: false,
      submittedToken: false,

      tabPrecoData: null,
      dtListPesqTabPreco: null,

      xmlContent: '',
      showModalConsSPC: false,
      loadingDadosSPC: false,
      spcData: null,           // JSON estruturado retornado pelo backend

      // SPC Brasil – Inclusão / Exclusão
      showModalIncExcSPC: false,
      loadingIncExcSPC: false,
      xmlIncExcSPC: '',
      spcOperacao: 'incluir',          // 'incluir' | 'excluir'
      spcNumContrato: '',
      spcValorDivida: '',
      spcDataVencimento: '',
      spcNaturezaDivida: '01',
      spcMotivoExclusao: '01',
      optionsNaturezaSPC: [
        { value: '01', label: '01 – Mercadorias / Serviços' },
        { value: '02', label: '02 – Cheques' },
        { value: '03', label: '03 – Notas Promissórias' },
        { value: '04', label: '04 – Duplicatas' },
        { value: '05', label: '05 – Cartão de Crédito' },
        { value: '06', label: '06 – Financiamento' },
        { value: '07', label: '07 – Contrato' },
        { value: '08', label: '08 – Outros' },
      ],
      optionsMotivoExclusaoSPC: [
        { value: '01', label: '01 – Pagamento' },
        { value: '02', label: '02 – Acordo' },
        { value: '03', label: '03 – Inclusão Indevida' },
        { value: '04', label: '04 – Determinação Judicial' },
        { value: '05', label: '05 – Outros' },
      ],

      showModalAuditoria: null,
      showModalConsCEP: null,
      loadingDadosCep: null,

      dtListPesqCidade: null,
      dtListPesqCidade1: null,
      dtListPesqCidade2: null,

      loadingRepres: false,
      // dtListPesqRepres: null,

      dtListFinanceiro: null,
      creceber: null,
      cpagar: null,

      dtListPesqCorreioServico: null,
      empresa:null,

      loadingDadosCnpj: false,
      showModalConsCNPJ: false,

      consCnpjImpNome: true,
      consCnpjImpFantasia: true,
      consCnpjImpEndereco: true,
      consCnpjImpNumero: true,
      consCnpjImpBairro: true,
      consCnpjImpLatLong: true,
      consCnpjImpUf: true,
      consCnpjImpCep: true,
      consCnpjImpEmail: true,
      consCnpjImpTel: true,
      consCnpjImpCnpj: true,
      consCnpjImpCompl: true,
      consCnpjImpCidade: true,
      consCnpjImpEstado: true,

      consCnpjSituacao: '',
      consCnpjDAbe: '',
      consCnpjSocio1: '',
      consCnpjSocio2: '',

      consCnpjNome: '',
      consCnpjFantasia: '',
      consCnpjEndereco: '',
      consCnpjNumero: '',
      consCnpjMunic: '',
      consCnpjBairro: '',
      consCnpjLatLong: '',
      consCnpjLat: '',
      consCnpjLong: '',
      consCnpjUf: '',
      consCnpjCep: '',
      consCnpjEmail: '',
      consCnpjTel: '',
      consCnpjCnpj: '',
      consCnpjCompl: '',
      consCnpjCidade: '',
      consCnpjEstado: '',
      consCnpjCodMun: '',


      showModalAnexo: false,
      submittedAnexo: false,
      descranexo: '',
      loadingFiles: false,

      optionsClasse:[
        {
          'cod': 'CL',
          'desc': 'Cliente',
        },
        {
          'cod': 'FO',
          'desc': 'Fornecedor',
        },
        {
          'cod': 'MO',
          'desc': 'Motorista',
        },
        {
          'cod': 'RE',
          'desc': 'Representante',
        },
        {
          'cod': 'TR',
          'desc': 'Transportadora',
        },
        {
          'cod': 'TRD',
          'desc': 'Transportadora Dedicada',
        },
      ],
      optionsIndIEDest: [
        { value: 1, label: '1 - Contribuinte ICMS' },
        { value: 2, label: '2 - Contribuinte Isento de Inscrição Estadual' },
        { value: 9, label: '9 - Não Contribuinte' }
      ],
      optionsRegimeTributario: [
        { value: 1, label: '1 - Simples Nacional' },
        { value: 2, label: '2 - Lucro Presumido' },
        { value: 3, label: '3 - Lucro Real' },
        { value: 4, label: '4 - Imune / Isento' },
        { value: 5, label: '5 - Órgão Público' },
        { value: 6, label: '6 - Pessoa Física' },
        { value: 7, label: '7 - Microempreendedor Individual (MEI)' }
      ],
      optionsCriterioISSQN: [
        { value: 'P', label: 'Local do Estabelecimento do Prestador' },
        { value: 'S', label: 'Local da Prestação do Serviço' },
        { value: 'C', label: 'Serviço de Construção Civil' },
        { value: 'O', label: 'Outros' }
      ],
      optionsStatusSUFRAMA: [
        { value: 'Ativa', label: 'Ativa' },
        { value: 'Suspensa', label: 'Suspensa' },
        { value: 'Cancelada', label: 'Cancelada' },
        { value: 'N/A', label: 'Não Aplicável' }
      ],
      optionsNaturezaOpSUFRAMA: [
        { value: 'Industrializacao', label: 'Industrialização' },
        { value: 'Comercializacao', label: 'Comercialização' },
        { value: 'Consumo', label: 'Consumo' },
        { value: 'Outros', label: 'Outros' }
      ],
      errosValid: null,
      errosValidFormula: null,
      contClickAvanc: 0,
      clienteData: {
        id: 0,
        status: 'A',
        inadimplente: 'N',
        tipo: 'PF',
        ddi_tel1: '',
        ddi_tel2: '',
        prgordcol: 'NEN'
      },
      fiscalData: {
        id: 0,
        autofinan: null,
        ind_ie_dest: null,
        regime_tributario: null,
        reter_irrf: false,
        aliquota_irrf: null,
        vlr_min_irrf: null,
        reter_csrf: false,
        aliquota_csrf: null,
        vlr_min_csrf: null,
        reter_issqn: false,
        aliquota_issqn: null,
        criterio_issqn: null,
        iss_subst_trib: false,
        reter_inss: false,
        aliquota_inss: null,
        bc_inss_perc: null,
        obs_fiscais: null,
        is_suframa: false,
        inscricao_suframa: null,
        status_suframa: 'N/A',
        gera_pin: false,
        natureza_op_suframa: null
      },
      pessoaFormulaData : {
        formula: ''
      },
      enderecosData: {},
      mediasData: {},
      // represData: {},
      cidadeData: {},
      idData: 0,
      updating: true,
      activeTab: 0,
      submitted: false,

      title: "Editar Cliente / Fornecedor",
      items: [
        {
          text: "Clientes",
          href: "/clientes/list",
        },
        {
          text: "Editar Cliente / Fornecedor",
          active: true,
        },
      ],

      colsEmprs: [

        {
          field: "cnpj",
          headerText: "CNPJ",
          textAlign: "Left",
        },
        {
          field: "nome",
          headerText: "Nome",
          textAlign: "Left",
          maxWidth: 450,
        },
        {
          field: "bairro",
          headerText: "Bairro",
          textAlign: "Left",
        },
        {
          field: "endereco",
          headerText: "Endereço",
          textAlign: "Left",
        },
        {
          field: "telefone_1",
          headerText: "Telefone",
          textAlign: "Left",
        },
        {
          field: "email",
          headerText: "E-mail",
          textAlign: "Left",
        },
        {
          field: "@timestamp",
          headerText: "Data",
          textAlign: "Right",
          format: "dd/MM/yyyy"
        },
        {
          name: "capital",
          field: "Capital",
          headerText: "Capital",
          textAlign: "Right",
          template: "templtcapital",
        }
      ],

      emailInput: '',
      showModalDataReprocessamento: false,
      dtReprocessamento: null,
      submittedPeriodo: null,

      showModalHelp: false,
      dtListHelp: [],
    };
  },

  computed: {
    pessoaRepresFxData() {
      const idsSelecteds = this.pessoaRepresComissao?.represfx_ids;

      if(!Array.isArray(idsSelecteds) || !Array.isArray(this.optionsRepresFx)) {
        return [];
      }
          return this.optionsRepresFx.filter((represFx) =>
            idsSelecteds.includes(represFx.id)
        );
    },
    parsedEmails() {
      if (!this.clienteData.mailsredir) return [];
      return this.clienteData.mailsredir
        .split(',')
        .map(email => email.trim())
        .filter(email => email.length > 0);
    },
    invalidEmails() {
      return this.parsedEmails.filter(email => !this.validEmail(email));
    }
  },

  watch: {
    'fiscalData.status_suframa'(val) {
      if (this.fiscalData.is_suframa && val === 'Ativa') {
        this.fiscalData.gera_pin = true
      } else {
        this.fiscalData.gera_pin = false
      }
    },
    'fiscalData.is_suframa'(val) {
      if (val && this.fiscalData.status_suframa === 'Ativa') {
        this.fiscalData.gera_pin = true
      } else {
        this.fiscalData.gera_pin = false
      }
    }
  },

  methods: {
    mostrarHelp(tipo) {
      switch (tipo) {
        case 'estoque':
          this.dtListHelp = [
            {
              tipo: "Padrão",
              descricao: 'Cada saída de saldo deve conter saldo disponível para o produto(Validação de saldo disponível)'
            },
            {
              tipo: 'Descritivo',
              descricao: 'Não registra valida saldo disponível ou não, apenas registra entradas e saídas'
            },
            {
              tipo: 'Negativação',
              descricao: 'Registra saldo de negativação de saldo para poder quitar posteriormente com base em entradas posteriores indicadas(ex: dropshipping)'
            }
          ]
          this.showModalHelp = true
          break
        case 'ind_ie_dest':
          this.dtListHelp = [
            { tipo: 'Contribuinte', descricao: '1 - Contribuinte ICMS (possui Inscrição Estadual).' },
            { tipo: 'Isento', descricao: '2 - Contribuinte isento de Inscrição no cadastro de Contribuintes.' },
            { tipo: 'Não Contribuinte', descricao: '9 - Não Contribuinte, que pode ou não possuir Inscrição Estadual no Cadastro de Contribuintes do ICMS.' }
          ]
          this.showModalHelp = true
          break
        case 'regime_tributario':
          this.dtListHelp = [
            { tipo: 'MEI', descricao: '1 - Simples Nacional - Microempreendedor Individual.' },
            { tipo: 'Simples', descricao: '2 - Simples Nacional.' },
            { tipo: 'Excedente', descricao: '3 - Simples Nacional - excesso de sublimite de receita bruta.' },
            { tipo: 'Normal', descricao: '4 - Regime Normal.' }
          ]
          this.showModalHelp = true
          break
        case 'retencoes':
          this.dtListHelp = [
            { tipo: 'IRRF', descricao: 'Imposto de Renda Retido na Fonte - Aplicável em serviços profissionais.' },
            { tipo: 'CSRF/PCC', descricao: 'Contribuições Sociais (PIS, COFINS, CSLL) retidas na fonte.' },
            { tipo: 'ISSQN', descricao: 'Imposto Sobre Serviços de Qualquer Natureza - Retenção conforme legislação municipal.' },
            { tipo: 'INSS', descricao: 'Retenção previdenciária em serviços mediante cessão de mão de obra ou empreitada.' }
          ]
          this.showModalHelp = true
          break
        case 'suframa':
          this.dtListHelp = [
            { tipo: 'Inscrição', descricao: 'Número de inscrição da SUFRAMA do destinatário.' },
            { tipo: 'PIN', descricao: 'Protocolo de Internamento - Obrigatório para mercadorias destinadas à ZFM.' },
            { tipo: 'Isenção', descricao: 'O status ativo garante isenção/suspensão de impostos conforme legislação.' }
          ]
          this.showModalHelp = true
          break
      }
    },

    reprocessarEmailsRedirecionamento(){
      console.log("reprocessarEmailsRedirecionamento");

      this.showModalDataReprocessamento = false
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Deseja reprocessar os e-mails de redirecionamento?",
        showConfirmButton: true,
        showCancelButton: true,
      }).then((res) => {
        if(res.isConfirmed) {
          Swal.fire({
            position: "center",
            icon: "info",
            title: "Reprocessando E-mails de redirecionamento!",
            showConfirmButton: false,
            showCancelButton: false,
            timer: 1500
          })

          this.loading = true;
          api.post(`${getBaseUrl()}api/repemailredir`, {
            data: this.dtReprocessamento,
            pessoa_id: this.idData
          }).then((res) => {
            console.log('then axios')
            console.log(res.data)
            this.loading = false;

            Swal.fire({
              position: "top-end",
              icon: res.data.success ? "success" : "error",
              title: res.data.msg,
              showConfirmButton: false,
              timer: 1500
            })
          }).then(() => {
            this.dtReprocessamento = null
          })
        } else {
          Swal.fire({
              position: "center",
              icon: "error",
              title: "Processo cancelado!",
              showConfirmButton: false,
              timer: 1500
            })
        }
      })
    },

    avisoRedirEmail(){
      if(this.clienteData.redirmail === true){
        Swal.fire({
          position: "top-end",
          icon: "info",
          title: "Ao ativar o redirecionamento de e-mail, o XML da NF-e será enviado para os e-mails informados no campo 'E-mails para redirecionamento'!",
          text: "Funcionalidade apenas inclui transportadoras!",
          showConfirmButton: false,
          timer: 5000
        });
      }
    },

    async getLatLngEntrega() {
      if (!this.clienteData.cep || !this.clienteData.rua || !this.clienteData.numero || !this.clienteData.bairro || !this.clienteData.cidadeDescricao || !this.clienteData.estado) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Preencha todos os campos de endereço (CEP, Logradouro, Número, Bairro, Cidade, Estado) para geolocalizar.",
          showConfirmButton: false,
          timer: 3000
        });
        return;
      }

      try {
        const response = await api.post(`${getBaseUrl()}api/getLatitudeLongitude`, {
          cep: this.clienteData.cep,
          rua: this.clienteData.rua,
          numero: this.clienteData.numero,
          bairro: this.clienteData.bairro,
          cidade: this.clienteData.cidadeDescricao,
          estado: this.clienteData.estado,
        });

        if (response.data.latitude && response.data.longitude) {
          this.clienteData.latitude = response.data.latitude;
          this.clienteData.longitude = response.data.longitude;
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Latitude e Longitude obtidas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          });
        } else {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: "Não foi possível obter a Latitude e Longitude. Verifique o endereço.",
            showConfirmButton: false,
            timer: 3000
          });
        }
      } catch (error) {
        console.error("Erro ao geolocalizar endereço:", error);
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Erro ao comunicar com o servidor para geolocalização.",
          showConfirmButton: false,
          timer: 3000
        });
      }
    },

    novaFaixa(){
      console.log('novaFaixa')
      this.novaFaixaVeic = true


    },

    editarVeicFx(veicFxData){
      console.log('editarVeicFx')
      this.pessoaVeicFxData = veicFxData
      this.novaFaixaVeic = true


    },



    altTipoVeic(){
      console.log('altTipoVeic')
      let restipo = ''

      // alterar funcao cotarFrete na cotar-frete-editar-dedicada
      let reseixo = '2'
      switch (this.pessoaVeiCoDedData.tipoveic) {
        case 'CAP':
          restipo = 'car'
          break
        case 'FIV':
          restipo = 'car'
          break
        case 'MOT':
          restipo = 'motorcycle'
          break
        case 'VUC':
          restipo = 'car'
          break
        case 'CT2':
          restipo = 'truck'
          break
        case 'CT3':
          restipo = 'truck'
          reseixo = '3'
          break
        case 'CAS':
          restipo = 'truck'
          break
        case 'CAL':
          restipo = 'truck'
          reseixo = '3'
          break
        case 'BIT':
          restipo = 'truck'
          reseixo = '7'
          break
        default:
          restipo = null
      }
      this.pessoaVeiCoDedData.type_vehicle = restipo
      this.pessoaVeiCoDedData.vehicle_axis = reseixo
      this.pessoaVeiCoDedData.table_axis = reseixo


    },


    novoVeiCoDed(){
      this.showFormVeiCotDed = true
      this.pessoaVeiCoDedData = {
        'tipocalc': 'INT',
        'status': 'A',
        'freight_load': 'geral',
        'table_category': 'A',
        'vehicle_axis': '2',
        'table_axis': '2'
      }
      this.submmitedVeiCoDedData = false
    },

    novoVeic(){
      this.showFormVeic = true
      this.pessoaVeicData = {
        'status': 'A',
      }
      this.submmitedVeic = false
    },

    novoParam(){
      this.showParamComissao = true
      /*this.pessoaVeicData = {
        'status': 'A',
      }
      this.submmitedVeic = false*/
    },


    atualizarVeicFxs(){
      console.log('atualizarVeicFxs')
      this.loadingVeicFxs = true
      api.get(`${getBaseUrl()}api/pesveicfxs`, {
        params: { 'iddata': this.pessoaVeicData.id},
      }).then(response => {
        console.log('response.data_0')
        console.log(response.data)
        this.pessoaVeicFxsData = response.data[0]
        // let dtList0 = []
        // response.data[0].forEach((value) => {
        //   value['_source']['@timestamp'] = moment(value['_source']['@timestamp']).format('DD/MM/YYYY')
        //   value['_source']['id'] = value['_id']
        //   dtList0.push(value['_source'])
        // })
        // this.empresasElkData = dtList0
        this.loadingVeicFxs = false
      })
    },

    editarVeiCoDed(veiculo){
      console.log('editarVeiculoCotacaoDedicada')
      this.pessoaVeiCoDedData = veiculo
      this.showFormVeiCotDed = true
    },


    editarVeic(veiculo){
      console.log('editarVeiculo')
      this.pessoaVeicData = veiculo
      this.showFormVeic = true
      this.atualizarVeicFxs()
    },

    deletarVeiCoDed(idData){
      console.log('deletarVeiculoCotacaoDedicada')
      console.log('deletar_0: ' + idData)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/pesveicoded`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
            this.carregarDados()
          })
        }
      })
    },



    deletarVeic(idData){
      console.log('deletarVeiculo')
      console.log('deletar_0: ' + idData)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/pesveic`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
            this.carregarDados()
          })
        }
      })
    },


    deletarVeicFx(idData){
      console.log('deletarVeicFx')
      console.log('deletar_0: ' + idData)
      this.novaFaixaVeic = false
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.loadingVeicFxs = true
          api.delete(`${getBaseUrl()}api/pesveicfx`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
            this.atualizarVeicFxs()
          })
        }
      })
    },

    confVeicFx(){
      console.log('confVeicFx')
      this.novaFaixaVeic = false
      this.submmitedVeicFxData = true
      this.pessoaVeicFxData.pessoaveic_id = this.pessoaVeicData.id
      if (this.pessoaVeicFxData.minimo && this.pessoaVeicFxData.maximo && this.pessoaVeicFxData.valor) {
        this.loadingVeicFxs = true
        api.post(`${getBaseUrl()}api/pesveicfx`, {
          pessoaVeicFxData: this.pessoaVeicFxData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.pessoaVeicFxData = {}
          this.novaFaixaVeic = false
          this.submmitedVeicFxData = false
          this.pessoaVeicFxsData = res.data[0]
          // this.showFormVeic = false
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.loadingVeicFxs = false
        })
      }
    },


    confVeiCotDed(){
      console.log('confVeiCotDed')
      this.submmitedVeiCoDedData = true
      this.pessoaVeiCoDedData.pessoa_id = this.idData
      if (this.pessoaVeiCoDedData.descricao && this.pessoaVeiCoDedData.status && this.pessoaVeiCoDedData.pesomax &&
          this.pessoaVeiCoDedData.type_vehicle && this.pessoaVeiCoDedData.vehicle_axis && this.pessoaVeiCoDedData.table_category &&
          this.pessoaVeiCoDedData.freight_load && this.pessoaVeiCoDedData.table_axis && this.pessoaVeiCoDedData.tipoveic &&
          ((this.pessoaVeiCoDedData.tipocalc === 'INT' && this.pessoaVeiCoDedData.valorkm > 0) || this.pessoaVeiCoDedData.tipocalc === 'QLP')

      ) {
        api.post(`${getBaseUrl()}api/pesveicoded`, {
          pessoaVeiCoDedData: this.pessoaVeiCoDedData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.showFormVeiCotDed = false
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.carregarDados()
        })
      }
    },

    confVeic(){
      console.log('confVeic')
      this.submmitedVeicData = true
      this.pessoaVeicData.pessoa_id = this.idData
      if (this.pessoaVeicData.descricao && this.pessoaVeicData.status && this.pessoaVeicData.placa) {
        api.post(`${getBaseUrl()}api/pesveic`, {
          pessoaVeicData: this.pessoaVeicData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.showFormVeic = false
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.carregarDados()
        })
      }
    },

    redirectFaixaRepres(){
      console.log('redirectFaixaRepres')

      const routeData = this.$router.resolve(`/repres/list`)
      window.open(routeData.href, '_blank')
    },

    editarFaixaRepres(){
      console.log('editarFaixaRepres')
      this.faixaRepresExist = false
    },

    editarRepres(data){
      console.log('editarRepres')
      this.pessoaRepresData = data
      this.showParamComissao = true
    },

    deletarRepres(idData){
      console.log('deletarRepres')
      console.log('deletar_0: ' + idData)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/pesrepres`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
            this.pessoaRepresComissao = {
              id: null,
              pessoa_id: null,
              codigo: null,
              descricao: null,
              contacpf: null,
              status: 'A',
              represtime_id: null,
              nomefavorecido: null,
              banco_id: null,
              banco: null,
              tipo: 'TED',
              agencia: null,
              conta: null,
              tipochavepix: null,
              chavepix: null,
              lider: false
            }
            this.carregarDados()
          })
        }
      })
    },


    /*deletarRepresFx(idData){
      console.log('deletarVeicFx')
      console.log('deletar_0: ' + idData)
      this.faixaRepresExist = false
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.loadingRepresFxs = true
          api.delete(`${getBaseUrl()}api/pesveicfx`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
            this.atualizarVeicFxs()
          })
        }
      })
    },

    confRepresFx(){
      console.log('confRepresFx')
      this.faixaRepresExist = false
      this.submmitedVeicFxData = true
      this.pessoaVeicFxData.pessoaveic_id = this.pessoaVeicData.id
      if (this.pessoaVeicFxData.minimo && this.pessoaVeicFxData.maximo && this.pessoaVeicFxData.valor) {
        this.loadingRepresFxs = true
        api.post(`${getBaseUrl()}api/pesveicfx`, {
          pessoaVeicFxData: this.pessoaVeicFxData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.pessoaVeicFxData = {}
          this.faixaRepresExist = false
          this.submmitedVeicFxData = false
          this.pessoaVeicFxsData = res.data[0]
          // this.showParamComissao = false
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.loadingRepresFxs = false
        })
      }
    },*/

    confRepres(){
      console.log('confRepres')
      this.pessoaRepresComissao.pessoa_id = this.idData
      if (this.pessoaRepresComissao.descricao && this.pessoaRepresComissao.status && this.pessoaRepresComissao.contacpf && this.pessoaRepresComissao.codigo && this.pessoaRepresComissao.represtime_id) {
        api.post(`${getBaseUrl()}api/pesrepres`, {
          pessoaRepresComissao: this.pessoaRepresComissao
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          if(res.data.success){
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: res.data.message,
              showConfirmButton: false,
              timer: 1500
            })
            this.showParamComissao = false
            this.carregarDados()
          } else {
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: "Algo deu errado, entre em contato com o suporte!",
              showConfirmButton: false,
              timer: 1500
            })
          }

        })
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: !this.pessoaRepresComissao.represtime_id ? "Campo EQUIPE é obrigatório, favor selecionar equipe." : "Não foi possivel salvar o cadastro, verifique os dados e tente novamente!",
          showConfirmButton: false,
          timer: 2500
        })
      }
    },



    toolbarClick: function(args) {
      console.log('toolbarClick')
      console.log(args)
      if (args.item.id.endsWith('excelexport')) {
        const props = {
          fileName: 'financeiro.xlsx'
        }
        this.$refs.financeiroGrid.excelExport(props);
      } else if (args.item.id.endsWith('pdfexport')) {
        const props = {
          fileName: 'financeiro.pdf'
        }
        this.$refs.financeiroGrid.pdfExport(props);
      } else if (args.item.id.endsWith('csvexport')) {
        const props = {
          fileName: 'financeiro.csv'
        }
        this.$refs.financeiroGrid.csvExport(props);
      }
    },

    dataBound: function() {
      this.$refs.dataGridEmprsElk.autoFitColumns([])
    },

    recordDoubleClick(evt){
      console.log('recordDoubleClick')
      console.log(evt.rowData);
      this.loadingEmprDadPub = true
      this.visibleAcord1DaPub = true
      this.visibleAcord2DaPub = false
      const paramsReq = {
        'cnpj': evt.rowData.cnpj
      }
      api.get(`${getBaseUrl()}api/elkempresa`, {
        params: paramsReq,
      }).then(response => {
        console.log('response.data_0')
        console.log(response.data[0][0]['_source'])
        this.emprElkData = response.data[0][0]['_source']
        this.emprElkData['id'] = response.data[0][0]['_id']
        let contItens = 0
        let sociosDt = []
        this.emprElkData['x_socio_cnpj'].forEach((socio) => {
          console.log(socio)
          sociosDt.push({
            'cnpj': this.emprElkData['x_socio_cnpj'][contItens],
            'nome': this.emprElkData['x_socio_nome'][contItens],
            'entrada': moment(this.emprElkData['x_socio_entrada'][contItens]).format('DD/MM/YYYY'),
            'faixaEtaria': this.emprElkData['x_socio_faixa_etaria'][contItens],
            'qualif': this.emprElkData['x_socio_qualif'][contItens],
            'repLegal': this.emprElkData['x_socio_repres_legal'][contItens],
          })
          contItens++
        })
        this.emprElkDataSociosData = sociosDt
        this.loadingEmprDadPub = false
      })
    },

    rowDataBound(args) {
      console.log('rowDataBound')
      console.log(args)
      if (args.data["finanparc_status"] === 'QT') {
        args.row.classList.add("bg-info");
      } else if (args.data["finanparc_status"] === 'CA') {
        args.row.classList.add("bg-danger");
      }
      // } else {
      //   args.row.classList.add("above-80");
      // }
    },

    redirecionarfinanparc(event) {
      console.log('redirecionarfinanparc')
      if (event.rowData.financeiro_tipo === "P") {
        console.log('pagar')
        this.$router.push(`/cpagar/editar/${event.rowData.financeiro_id}`)
      } else if (event.rowData.financeiro_tipo === "R") {
        console.log('receber')
        this.$router.push(`/creceber/editar/${event.rowData.financeiro_id}`)
      }
    },

    consVizinhos(){
      console.log('consVizinhos')
      this.loadingEmprsDadPub = true
      this.visibleAcord1DaPub = false
      this.visibleAcord2DaPub = true
      const paramsReq = {
        'cidade': this.emprElkData.cidade,
        'cnae': this.emprElkData.cnae,
      }
      api.get(`${getBaseUrl()}api/elkvizinho`, {
        params: paramsReq,
      }).then(response => {
        console.log('response.data_0')
        // console.log(response.data[0])
        let dtList0 = []
        response.data[0].forEach((value) => {
          value['_source']['@timestamp'] = moment(value['_source']['@timestamp']).format('DD/MM/YYYY')
          value['_source']['id'] = value['_id']
          dtList0.push(value['_source'])
        })
        this.empresasElkData = dtList0
        this.loadingEmprsDadPub = false
      })
    },


    consDadosPublicos(){
      console.log('consDadosPublicos')
      this.loadingEmprDadPub = true
      this.showModalDadosPublicos = true
      const paramsReq = {
        'cnpj': this.clienteData.cnpj,
      }
      api.get(`${getBaseUrl()}api/elkempresa`, {
        params: paramsReq,
      }).then(response => {
        console.log('response.data_0')
        console.log(response.data[0][0]['_source'])
        this.emprElkData = response.data[0][0]['_source']
        this.emprElkData['id'] = response.data[0][0]['_id']
        let contItens = 0
        let sociosDt = []
        this.emprElkData['x_socio_cnpj'].forEach((socio) => {
          console.log(socio)
          sociosDt.push({
            'cnpj': this.emprElkData['x_socio_cnpj'][contItens],
            'nome': this.emprElkData['x_socio_nome'][contItens],
            'entrada': moment(this.emprElkData['x_socio_entrada'][contItens]).format('DD/MM/YYYY'),
            'faixaEtaria': this.emprElkData['x_socio_faixa_etaria'][contItens],
            'qualif': this.emprElkData['x_socio_qualif'][contItens],
            'repLegal': this.emprElkData['x_socio_repres_legal'][contItens],
          })
          contItens++
        })
        this.emprElkDataSociosData = sociosDt
        this.loadingEmprDadPub = false
      })
    },


    editarTaxaFrete(data){
      console.log('editarTaxaFrete')
      this.pessoaFreteAdicData = data

      this.dtListPesqFreteAdicBase = [
        {
          'id': data.fretecotabase_id,
          'transpnome': data.transpnome
        },
      ]

      this.showFormFreteAdic = true
    },


    deletarTaxaFrete(idData){
      console.log('deletarTaxaFrete')
      console.log('deletar_0: ' + idData)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/pestaxafrete`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
            this.carregarDados()
          })
        }
      })
    },



    criarNovaTaxa(){
      console.log('criarNovaTaxa')
      this.pessoaFreteAdicData = {}
      this.submmitedFreteAdic = false
      this.showFormFreteAdic = true
    },



    confFreteAdic(){
      console.log('confFreteAdic')
      this.submmitedFreteAdic = true

      this.pessoaFreteAdicData.pessoa_id = this.idData
      api.post(`${getBaseUrl()}api/pestaxafrete`, {
        pessoaFreteAdicData: this.pessoaFreteAdicData
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        this.showFormFreteAdic = false
        // this.usuarioData = res.data[0]
        // this.updating = false
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
        this.carregarDados()
        // this.$router.push('/usuarios/list')
      })

    },

    validarFormula() {
      console.log('validarFormula')
      this.loadingCotarFrete = true
      this.cotaFreteInternoListData = {}

      api.get(`${getBaseUrl()}api/validformfrete`, {
        params: {
          pessoaFormulaData: this.pessoaFormulaData
        }
      }).then((res) => {
        console.log('res cotarFrete')
        console.log(res.data)
        this.cotaFreteInternoListData = res.data[0]
        this.errosValidFormula = res.data[1]
        this.loadingCotarFrete = false
      })

    },

    confFormula() {
      console.log('confFormula')
      this.submmitedFormula = true
      if (this.pessoaFormulaData.formula && this.pessoaFormulaData.status) {
        this.pessoaFormulaData.pessoa_id = this.idData
        api.post(`${getBaseUrl()}api/pesformula`, {
          pessoaFormulaData: this.pessoaFormulaData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.showFormFormulaFrete = false
          // this.usuarioData = res.data[0]
          // this.updating = false
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.carregarDados()
          // this.$router.push('/usuarios/list')
        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
        })
      }

    },


    novoFinanceiro(){
      console.log('novoFinanceiro')
      const routeData = this.$router.resolve(`/creceber/editar/0`)
      window.open(routeData.href, '_blank')
    },



    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    handleEmailInput(event) {
      if (event.key === ',' || event.key === 'Enter') {
        event.preventDefault();
        this.finalizeEmailInput();
      }
    },

    finalizeEmailInput() {
      const email = this.emailInput.trim().replace(/,/g, '');
      if (email.length > 0) {
        if (this.validEmail(email)) {
          const currentEmails = this.clienteData.mailsredir 
            ? this.clienteData.mailsredir.split(',').map(e => e.trim()).filter(e => e.length > 0)
            : [];
          if (!currentEmails.includes(email)) {
            currentEmails.push(email);
            this.clienteData.mailsredir = currentEmails.join(', ');
          }
          this.emailInput = '';
        } else {
          this.emailInput = '';
        }
      }
    },

    deleteEmailRedir(index) {
      const emails = this.parsedEmails;
      emails.splice(index, 1);
      this.clienteData.mailsredir = emails.join(', ');
    },

    handlePasteEmails(event) {
      event.preventDefault();
      
      const pastedText = event.clipboardData.getData('text');
      
      const emailsFromPaste = pastedText
        .split(/[,;\n\r]/)
        .map(email => email.trim())
        .filter(email => email.length > 0);
      
      const currentEmails = this.clienteData.mailsredir 
        ? this.clienteData.mailsredir.split(',').map(e => e.trim()).filter(e => e.length > 0)
        : [];
      
      emailsFromPaste.forEach(email => {
        if (this.validEmail(email) && !currentEmails.includes(email)) {
          currentEmails.push(email);
        }
      });
      
      this.clienteData.mailsredir = currentEmails.join(', ');
      this.emailInput = '';
    },

    editarMailCota(mailCota){
      console.log('editarMailCota')
      this.pessoaMailCotaData = mailCota
      this.showFormMailCota = true
    },

    deletarMailCota(idData){
      console.log('deletarMailCota')
      console.log('deletar_0: ' + idData)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true

          api.delete(`${getBaseUrl()}api/pesmailcota`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })

            this.carregarDados()
          })


        }
      })
    },

    carregarDados(){

      api.get(`${getBaseUrl()}api/cliente`, {
        params: { iddata: this.idData }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)

        let cliData = res.data[0]

        let tipoDesc = ''
        if (cliData.classe){


          if (cliData.classe.includes('CL')) {
            tipoDesc = ' | Cliente'
          }

          if (cliData.classe.includes('FO')) {
            tipoDesc += ' | Fornecedor'
          }

          if (cliData.classe.includes('MO')) {
            tipoDesc += ' | Motorista'
          }

          if (cliData.classe.includes('RE')) {
            tipoDesc += ' | Representante'
          }

          if (cliData.classe.includes('TR')) {
            tipoDesc += ' | Transportador'
          }

          // switch (cliData.classe){
          //   case 'CL':
          //     tipoDesc = 'Cliente'
          //     break
          //   case 'FO':
          //     tipoDesc = 'Fornecedor'
          //     break
          //   case 'TR':
          //     tipoDesc = 'Transportador'
          //     break
          //   case 'CL,FO':
          //     tipoDesc = 'Cliente / Fornecedor'
          //     break
          //   case 'FO,CL':
          //     tipoDesc = 'Cliente / Fornecedor'
          //     break
          //   default:
          //     tipoDesc = 'Tipo Não Definido'
          //     break
          //
          // }

          const strToArr = cliData.classe.split(',').map(s => s.trim())
          // console.log('strToArr')
          // console.log(strToArr)
          // console.log(this.naturegraData.destino)
          cliData.classeForm = strToArr
        }

        this.clienteData = cliData
        if (!this.clienteData.ddi_tel1) this.clienteData.ddi_tel1 = ''
        if (!this.clienteData.ddi_tel2) this.clienteData.ddi_tel2 = ''
        if (!this.clienteData.prgordcol) this.clienteData.prgordcol = 'NEN'

        if (res.data[1]){
          this.enderecosData = res.data[1]
        }
        if (res.data[2]){
          this.mediasData = res.data[2]
        }

        if (res.data[3]){
          this.pessoaRepresComissao = res.data[3]
          this.pessoaRepresComissao.pessoa_id = cliData.id
          this.pessoaRepresComissao.represfx_ids = this.pessoaRepresComissao.represfx_ids ?
          this.pessoaRepresComissao.represfx_ids.split(',').map(Number) : [];

        } else if(cliData.id > 0) {
          this.pessoaRepresComissao.pessoa_id = cliData.id
          this.pessoaRepresComissao.codigo = cliData.codigo
          this.pessoaRepresComissao.descricao = cliData.nome
          this.pessoaRepresComissao.contacpf = cliData.cnpj
          this.pessoaRepresComissao.nomefavorecido = cliData.nome
        }

        if (res.data[4]){
          this.dtListPesqCidade = [
            {
              'codigo': res.data[4].codigo,
              'descricao': res.data[4].descricao
            },
          ]
        }

        if (res.data[5]){
          this.dtListPesqCidade1 = [
            {
              'codigo': res.data[5].codigo,
              'descricao': res.data[5].descricao
            },
          ]
        }

        if (res.data[6]){
          this.dtListPesqCidade2 = [
            {
              'codigo': res.data[6].codigo,
              'descricao': res.data[6].descricao
            },
          ]
        }

        if (res.data[7]){
          this.dtListPesqTabPreco = [
            {
              'codigo': res.data[7].codigo,
              'descricao': res.data[7].descricao
            },
          ]
        }

        if (res.data[12]) {
          this.cpagar = res.data[12]
        }

        if (res.data[13]) {
          this.creceber = res.data[13]
        }

        this.pessoaTokensData = res.data[8]
        this.pessoaMailsCotaData = res.data[9]
        this.pessoaFreteAdicsData = res.data[10]
        this.pessoaEmailsData = res.data[11]

        if (res.data[14]){
          this.pessoaVeiCoDedsData = res.data[14]
        }

        if (res.data[15]){
          this.pessoaVeicsData = res.data[15]
        }

        if (res.data[16]){
          this.dtListEquipesRepres = res.data[16]
        }

        if (res.data[17]){
          this.contaData = res.data[17]
          if (this.contaData && this.contaData.id){
            this.dtListPesqConta = [
              {
                id: this.contaData.id,
                banco: this.contaData.banco,
                descricao: this.contaData.descricao,
              }
            ]
            this.pessoaRepresComissao.banco = this.contaData.banco
          }
        }

        this.optionsRepresFx = res.data[18];

        this.idData = this.clienteData.id
        this.title = `Editar ${tipoDesc} (${this.clienteData.id}) ${this.clienteData.nome}`
        this.updating = false
        this.loadingFiles = false

        if(this.clienteData.servtransp){
          // console.log('pesquisa serviço correios')
          this.pesqCorreioServico(this.clienteData.servtransp)
        }

        if (res.data[19]) {
          this.fiscalData = res.data[19]
        }
      });
    },

    editarToken(data){
      this.pessoaTokenData = data
      this.showFormToken = true
    },

    editarEmail(data) {
      console.log('editarEmail')
      this.pessoaEmailData = data
      this.showFormMail = true

    },

    deletarMail(idData) {
      console.log('deletarMail')
      console.log('deletar_0: ' + idData)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true

          api.delete(`${getBaseUrl()}api/DeletarRedirecionamento`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })

            this.carregarDados()
          })
        }
      })
    },

    confToken() {
      console.log('confToken')
      this.submittedToken = true
      this.pessoaTokenData.pessoa_id = this.idData
      if (this.pessoaTokenData.hub && this.pessoaTokenData.validade) {
        api.post(`${getBaseUrl()}api/pestoken`, {
          pessoaTokenData: this.pessoaTokenData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.showFormToken = false
          // this.usuarioData = res.data[0]
          // this.updating = false
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.carregarDados()
          // this.$router.push('/usuarios/list')
        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
          this.activeTab = 0
        })
      }
    },

    confMail() {
      console.log('confMail')
      this.submittedMail = true
      this.pessoaEmailData.pessoa_id = this.idData
      if (this.pessoaEmailData.nome && this.pessoaEmailData.email && this.validEmail(this.pessoaEmailData.email)) {
        this.showFormMail = false
        this.updating = true
        api.post(`${getBaseUrl()}api/GravarRedirecionamento`, {
          pessoaEmailData: this.pessoaEmailData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.carregarDados()
          this.pessoaEmailData = {}
          // this.$router.push('/usuarios/list')
        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
          this.activeTab = 0
        })
      }
    },

    confMailCota() {
      console.log('confMailCota')

      // console.log(this.validEmail(this.pessoaMailCotaData.email))
      // obrigatório e válido, favor corrigir.

      this.submittedMailCota = true
      this.pessoaMailCotaData.pessoa_id = this.idData
      if (this.pessoaMailCotaData.nome && this.pessoaMailCotaData.email && this.validEmail(this.pessoaMailCotaData.email)) {
        this.showFormMailCota = false
        this.updating = true
        api.post(`${getBaseUrl()}api/pesmailcota`, {
          pessoaMailCotaData: this.pessoaMailCotaData
        }).then((res) => {
          console.log('then axios confMailCota')
          console.log(res)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.carregarDados()
          this.pessoaMailCotaData = {}
          // this.$router.push('/usuarios/list')
        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
          this.activeTab = 0
        })
      }
    },


    consultarSPC() {
      const cnpjTratado = this.clienteData.cnpj.replaceAll('.','').replaceAll('/','').replaceAll('-','')
      const tamanhoEsperado = this.clienteData.tipo === 'PJ' ? 14 : 11
      if (cnpjTratado.length !== tamanhoEsperado) {
        Swal.fire({
          position: 'top-end', icon: 'warning',
          title: tamanhoEsperado === 14 ? 'CNPJ deve ter 14 dígitos.' : 'CPF deve ter 11 dígitos.',
          showConfirmButton: false, timer: 1800
        })
        return
      }

      this.spcData          = null
      this.showModalConsSPC = true
      this.loadingDadosSPC  = true

      api.get(`${getBaseUrl()}api/consspc`, { params: { cnpj: cnpjTratado } })
        .then((res) => {
          this.spcData = res.data
        })
        .catch((err) => {
          console.error('consultarSPC erro:', err)
          Swal.fire({ icon: 'error', title: 'Erro ao consultar SPC Brasil.', text: err?.response?.data?.error ?? err.message })
          this.showModalConsSPC = false
        })
        .finally(() => {
          this.loadingDadosSPC = false
        })
    },

    // ------------------------------------------------------------------
    // SPC Brasil – Inclusão / Exclusão
    // ------------------------------------------------------------------
    abrirModalIncExcSPC() {
      this.xmlIncExcSPC      = ''
      this.spcNumContrato    = ''
      this.spcValorDivida    = ''
      this.spcDataCompra     = ''
      this.spcDataVencimento = ''
      this.spcNaturezaDivida = '01'
      this.spcMotivoExclusao = '01'
      this.spcOperacao       = 'incluir'
      this.showModalIncExcSPC = true
    },

    enviarIncExcSPC() {
      const cnpjTratado = this.clienteData.cnpj
        .replaceAll('.', '').replaceAll('/', '').replaceAll('-', '')

      if (!this.spcNumContrato) {
        Swal.fire({ icon: 'warning', title: 'Informe o número do contrato / NF.', timer: 2000, showConfirmButton: false })
        return
      }

        if (!this.spcValorDivida || parseFloat(this.spcValorDivida) <= 0) {
          Swal.fire({ icon: 'warning', title: 'Informe um valor de dívida válido.', timer: 2000, showConfirmButton: false })
          return
        }
        if (!this.spcDataCompra) {
          Swal.fire({ icon: 'warning', title: 'Informe a data de compra.', timer: 2000, showConfirmButton: false })
          return
        }
        if (!this.spcDataVencimento) {
          Swal.fire({ icon: 'warning', title: 'Informe a data de vencimento.', timer: 2000, showConfirmButton: false })
          return
        }

      const label = this.spcOperacao === 'incluir' ? 'Inclusão' : 'Exclusão'
      const confirmText = this.spcOperacao === 'incluir'
        ? `Confirma a INCLUSÃO de "${this.clienteData.nome}" no SPC?\n\nContrato: ${this.spcNumContrato}\nValor: R$ ${this.spcValorDivida}`
        : `Confirma a EXCLUSÃO de "${this.clienteData.nome}" do SPC?\n\nContrato: ${this.spcNumContrato}`

      Swal.fire({
        icon: 'question',
        title: `Confirmar ${label} SPC`,
        text: confirmText,
        showCancelButton: true,
        confirmButtonText: `Sim, ${this.spcOperacao === 'incluir' ? 'incluir' : 'excluir'}`,
        cancelButtonText: 'Cancelar',
        confirmButtonColor: this.spcOperacao === 'incluir' ? '#dc3545' : '#198754',
      }).then((result) => {
        if (!result.isConfirmed) return

        this.loadingIncExcSPC = true
        this.xmlIncExcSPC     = ''

        const endpoint = this.spcOperacao === 'incluir'
          ? `${getBaseUrl()}api/spc-brasil/incluir`
          : `${getBaseUrl()}api/spc-brasil/excluir`

        const payload = {
          cnpj:             cnpjTratado,
          nome_devedor:     this.clienteData.nome,
          numero_contrato:  this.spcNumContrato,
          valor_divida:     this.spcValorDivida,
          data_compra:      this.spcDataCompra,
          data_vencimento:  this.spcDataVencimento,
          natureza_id:      parseInt(this.spcNaturezaDivida, 10),
          motivo_id:        this.spcOperacao === 'excluir' ? parseInt(this.spcMotivoExclusao, 10) : undefined,
        }

        api.post(endpoint, payload, { responseType: 'blob' })
          .then((res) => {
            const reader = new FileReader()
            reader.addEventListener('loadend', (e) => {
              const text = e.srcElement.result
              try {
                this.xmlIncExcSPC = xmlFormat(text, {
                  indentation: '  ',
                  filter: (node) => node.type !== 'Comment',
                  collapseContent: true,
                  lineSeparator: '\n'
                })
              } catch (_) {
                this.xmlIncExcSPC = text
              }

              // Verifica se a resposta SOAP contém Fault (erro)
              if (text.includes('Fault') || text.includes('fault') || text.includes('erro') || text.includes('Erro')) {
                const msgMatch = text.match(/<faultstring[^>]*>([^<]+)<\/faultstring>/i)
                const detalheMatch = text.match(/<mensagem[^>]*>([^<]+)<\/mensagem>/i)
                const erroMsg = msgMatch ? msgMatch[1] : (detalheMatch ? detalheMatch[1] : 'Verifique a resposta XML abaixo.')
                Swal.fire({ icon: 'error', title: `Erro na ${label} SPC`, text: erroMsg })
              } else {
                Swal.fire({ icon: 'success', title: `${label} SPC enviada com sucesso!`, timer: 2500, showConfirmButton: false })
              }
            })
            reader.readAsText(res.data)
          })
          .catch((err) => {
            console.error('SPC incluir/excluir erro:', err)
            Swal.fire({ icon: 'error', title: 'Erro ao comunicar com SPC Brasil.', text: err?.response?.data?.error ?? err.message })
          })
          .finally(() => {
            this.loadingIncExcSPC = false
          })
      })
    },

    // ------------------------------------------------------------------

    auditoria(){
      console.log('auditoria')
      this.showModalAuditoria = true
    },

    pesqConta(evt){
      console.log('pesqFinConta')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/ccontapesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqConta = res.data
          this.dtListPesqConta.sort((a,b) => a.codigo - b.codigo);
        });
      }
    },

    escolheuConta() {
      console.log('selected contaData')
      this.loadingConta = true;
      console.log(this.pessoaRepresComissao.banco_id);
      api.get(`${getBaseUrl()}api/cconta`, {
        params: { iddata: this.pessoaRepresComissao.banco_id },
      }).then((res) => {
        console.log("then axios");
        // console.log(res.data);
        this.contaData = res.data[0];

        this.loadingConta = false;
        this.pessoaRepresComissao.banco_id = this.contaData.id;
        this.pessoaRepresComissao.banco = this.contaData.banco;
        this.pessoaRepresComissao.agencia = this.contaData.agencia;
        this.pessoaRepresComissao.conta = this.contaData.numero;

      });
    },

    consultarCEP(){
      console.log('consultarCEP')
      const cepTratado = this.clienteData.cep.replaceAll('.','').replaceAll('-','')
      if (cepTratado.length !== 8){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "O campo CEP deve possuir no mínimo 8 caracteres, favor corrigir.",
          showConfirmButton: false,
          timer: 1500
        })
      }else{
        console.log(cepTratado)
        console.log(cepTratado.length)
        this.showModalConsCEP = true
        this.loadingDadosCep = true

        api.get(`${getBaseUrl()}api/conscep`, {
          params: { cep: cepTratado }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)

          const dataCep = res.data[0]

          this.consCnpjEndereco = dataCep.logradouro
          this.consCnpjCompl = dataCep.complemento
          this.consCnpjBairro = dataCep.bairro
          this.consCnpjCidade = dataCep.localidade
          this.consCnpjEstado = dataCep.uf
          this.consCnpjCodMun = dataCep.ibge
          this.consCnpjLatLong = dataCep.latitude?`lat.: ${dataCep.latitude} / long.: ${dataCep.longitude}`: ''
          this.consCnpjLat = dataCep.latitude
          this.consCnpjLong = dataCep.longitude

          if (res.data[1]){
            console.log('res.data[1]')
            console.log(res.data[1])
            this.cidadeData = res.data[1]
          }

          this.consCnpjImpEndereco = this.clienteData.rua !== this.consCnpjEndereco
          this.consCnpjImpCompl = this.clienteData.compl !== this.consCnpjCompl
          this.consCnpjImpBairro = this.clienteData.bairro !== this.consCnpjBairro
          this.consCnpjImpCidade = this.clienteData.cidade !== this.consCnpjCidade



          this.loadingDadosCep = false
        });
      }
    },


    confirmarImpCep(){
      console.log('confirmarImpCep: ')
      if (this.consCnpjImpEndereco){
        this.clienteData.rua = this.consCnpjEndereco
      }
      if (this.consCnpjImpBairro){
        this.clienteData.bairro = this.consCnpjBairro
      }
      if (this.consCnpjImpCidade){
        this.clienteData.cidade = this.consCnpjCidade
        this.clienteData.estado = this.consCnpjEstado
        this.clienteData.codmun = this.consCnpjCodMun
        this.clienteData.latitude = this.consCnpjLat
        this.clienteData.longitude = this.consCnpjLong
        this.dtListPesqCidade = [
          {
            'codigo': this.cidadeData.codigo,
            'descricao': this.cidadeData.descricao
          },
        ]

      }
      if (this.consCnpjImpCompl){
        this.clienteData.compl = this.consCnpjCompl
      }

      this.showModalConsCEP = false

    },


    pesqCidade(evt){
      console.log('pesqCidade')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/cidpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqCidade = res.data
        });
      }
    },

    escolheuCidade(){
      console.log('escolheuCidade')
      // console.log(this.clienteData.cidade)
      api.get(`${getBaseUrl()}api/cidade`, {
        params: { coddata: this.clienteData.codmun }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.clienteData.cidade = res.data.descricao
        this.clienteData.estado = res.data.estado

      })
    },


    pesqCidade1(evt){
      console.log('pesqCidade1')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/cidpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqCidade1 = res.data
        });
      }
    },

    escolheuCidade1(){
      console.log('escolheuCidade1')
      // console.log(this.clienteData.cidade)
      api.get(`${getBaseUrl()}api/cidade`, {
        params: { coddata: this.enderecosData.codmun1 }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.enderecosData.cidade1 = res.data.descricao
        this.enderecosData.estado1 = res.data.estado

      })
    },

    pesqCidade2(evt){
      console.log('pesqCidade2')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/cidpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqCidade2 = res.data
        });
      }
    },

    escolheuCidade2(){
      console.log('escolheuCidade2')
      // console.log(this.clienteData.cidade)
      api.get(`${getBaseUrl()}api/cidade`, {
        params: { coddata: this.enderecosData.codmun2 }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.enderecosData.cidade2 = res.data.descricao
        this.enderecosData.estado2 = res.data.estado

      })
    },



    /*pesqRepres(evt){
      console.log('pesqRepres')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.loadingRepres = true
        this.clienteData.repres = ''
        api.get(`${getBaseUrl()}api/reprpesq`, {
          params: { q: query, t: 'S' }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqRepres = res.data
        })
      }
    },*/


    /*escolheuRepres(){
      console.log('escolheuRepres')
      this.loadingRepres = true
      console.log(this.clienteData.repres)
      api.get(`${getBaseUrl()}api/reprcod`, {
        params: { coddata: this.clienteData.repres }
      }).then((res) => {
        console.log('then axios_escolheu_repres')
        console.log(res.data)
        this.represData = res.data[0]
        this.loadingRepres = false
      })
    },*/


    pesqTabPreco(evt){
      console.log('pesqTabPreco')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.clienteData.tabpreco = ''
        api.get(`${getBaseUrl()}api/tabprpesq`, {
          params: { q: query, t: 'S' }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqTabPreco = res.data
        })
      }
    },


    escolheuTabPreco(){
      console.log('escolheuTabPreco')
      console.log(this.clienteData.tabpreco)
      api.get(`${getBaseUrl()}api/tabprcod`, {
        params: { coddata: this.clienteData.tabpreco }
      }).then((res) => {
        console.log('then axios_escolheu_tabpreco')
        console.log(res.data)
        this.tabPrecoData = res.data[0]
      })
    },

    pesqFreteCotaBase(evt){
      console.log('pesqFreteCotaBase')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.clienteData.tabpreco = ''
        api.get(`${getBaseUrl()}api/pesqfretecotabase`, {
          params: { q: query, t: 'S' }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqFreteAdicBase = res.data
        })
      }
    },

    confirmarImpCnpj(){
      console.log('confirmarImpCnpj: ' + this.idData)
      if (this.consCnpjImpNome){
        this.clienteData.nome = this.consCnpjNome
      }
      if (this.consCnpjImpFantasia){
        this.clienteData.fantasia = this.consCnpjFantasia
      }
      if (this.consCnpjImpEndereco){
        this.clienteData.rua = this.consCnpjEndereco
      }
      if (this.consCnpjImpNumero){
        this.clienteData.numero = this.consCnpjNumero
      }
      if (this.consCnpjImpBairro){
        this.clienteData.bairro = this.consCnpjBairro
      }
      if (this.consCnpjImpCidade){
        this.clienteData.cidade = this.consCnpjCidade
        this.clienteData.estado = this.consCnpjEstado
        this.clienteData.codmun = this.consCnpjCodMun

        this.dtListPesqCidade = [
          {
            'codigo': this.cidadeData.codigo,
            'descricao': this.cidadeData.descricao
          },
        ]

      }
      if (this.consCnpjImpCep){
        this.clienteData.cep = this.consCnpjCep
      }
      if (this.consCnpjImpEmail){
        this.clienteData.email = this.consCnpjEmail
      }
      if (this.consCnpjImpTel){
        this.clienteData.tel1 = this.consCnpjTel
      }
      if (this.consCnpjImpCnpj){
        this.clienteData.cnpj = this.consCnpjCnpj
      }
      if (this.consCnpjImpCompl){
        this.clienteData.compl = this.consCnpjCompl
      }
      this.showModalConsCNPJ = false

    },


    consultarCNPJ(){
      console.log('consultarCNPJ')
      const cnpjTratado = this.clienteData.cnpj.replaceAll('.','').replaceAll('/','').replaceAll('-','')
      if ( this.clienteData.tipo === 'PJ' && cnpjTratado.length !== 14){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "O campo CNPJ deve possuir no mínimo 14 caracteres, favor corrigir.",
          showConfirmButton: false,
          timer: 1500
        })
      }else{
        console.log(cnpjTratado)
        console.log(cnpjTratado.length)
        this.showModalConsCNPJ = true
        this.loadingDadosCnpj = true

        api.get(`${getBaseUrl()}api/conscnpj`, {
          params: { cnpj: cnpjTratado }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)

          const dadosCnpj = res.data[0]

          this.consCnpjSituacao = dadosCnpj.situacao
          this.consCnpjDAbe = dadosCnpj.abertura
          this.consCnpjSocio1 = dadosCnpj.qsa[0] ? dadosCnpj.qsa[0].nome : ''
          this.consCnpjSocio2 = dadosCnpj.qsa[1] ? dadosCnpj.qsa[1].nome : ''

          this.consCnpjFantasia = dadosCnpj.fantasia
          this.consCnpjNome = dadosCnpj.nome
          this.consCnpjCnpj = dadosCnpj.cnpj
          this.consCnpjCep = dadosCnpj.cep
          this.consCnpjEndereco = dadosCnpj.logradouro
          this.consCnpjNumero = dadosCnpj.numero
          this.consCnpjCompl = dadosCnpj.compl
          this.consCnpjBairro = dadosCnpj.bairro
          this.consCnpjCidade = dadosCnpj.municipio
          this.consCnpjEstado = dadosCnpj.uf
          this.consCnpjEmail = dadosCnpj.email
          this.consCnpjTel = dadosCnpj.telefone

          if (res.data[1]){
            console.log('res.data[1]')
            console.log(res.data[1])
            this.cidadeData = res.data[1]
            this.consCnpjCodMun = res.data[1].codigo
          }


          console.log(this.clienteData.fantasia)
          console.log(this.consCnpjFantasia)

          this.consCnpjImpFantasia = this.clienteData.fantasia !== this.consCnpjFantasia
          this.consCnpjImpNome = this.clienteData.nome !== this.consCnpjNome
          this.consCnpjImpCnpj = this.clienteData.cnpj !== this.consCnpjCnpj
          this.consCnpjImpCep = this.clienteData.cep !== this.consCnpjCep
          this.consCnpjImpEndereco = this.clienteData.rua !== this.consCnpjEndereco
          this.consCnpjImpNumero = this.clienteData.numero !== this.consCnpjNumero
          this.consCnpjImpCompl = this.clienteData.compl !== this.consCnpjCompl
          this.consCnpjImpBairro = this.clienteData.bairro !== this.consCnpjBairro
          this.consCnpjImpCidade = this.clienteData.cidade !== this.consCnpjCidade
          this.consCnpjImpEstado = this.clienteData.estado !== this.consCnpjEstado
          this.consCnpjImpEmail = this.clienteData.email !== this.consCnpjEmail
          this.consCnpjImpTel = this.clienteData.tel1 !== this.consCnpjTel



          this.loadingDadosCnpj = false
        });
      }
    },

    pesqCorreioServico(evt){
      console.log('pesqCorreioServico')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.loadingTransp = true
        api.get(`${getBaseUrl()}api/corservpesq`, {
          params: { q: query, emp: this.empresa }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqCorreioServico = res.data
        })
      }
    },


    novoAnexo(){
      console.log('novoAnexo')
      this.descranexo = ''
      this.submittedAnexo = false
      this.showModalAnexo = true
      this.activeTab = 2
    },

    delFile(dataID){
      console.log('deletar: ' + dataID)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          this.loadingFiles = true

          api.delete(`${getBaseUrl()}api/media`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })

            this.loadingFiles = false
            this.mediasData = res.data[0]
          })


        }
      })
    },


    downFile(path, nomeArq){
      console.log('downFile: ' + path)
      //console.log('downFile: ' + path.split('.').pop())

      this.loadingFiles = true
      api.get(`${getBaseUrl()}api/getfile`, {
        responseType: 'blob',
        params: { pathData: path }
      }).then((res) => {
        console.log('res down')
        console.log(res)

        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', nomeArq);
        document.body.appendChild(fileLink);

        console.log('fileLink')
        console.log(fileURL)

        fileLink.click();
        this.loadingFiles = false
      })



    },



    confAnexo(){
      console.log('confAnexo')
      this.submittedAnexo = true
      if (this.descranexo !== '' && this.dropzoneFile.name){
        this.showModalAnexo = false
        this.loadingFiles = true

        let arquivo = document.querySelector(".dropzoneFile").files[0]
        console.log(arquivo)
        let formData = new FormData()
        formData.append("iddata", this.idData)
        formData.append("descranexo", this.descranexo)
        formData.append("filename", arquivo.name)
        formData.append("file", arquivo)

        api.post(`${getBaseUrl()}api/clifile`,formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.mediasData = res.data[0]
          this.loadingFiles = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })

        }).catch((err) => {

          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.loadingFiles = false
        })
      }
    },


    selectedFile(){
      console.log('selectedFile')
      this.dropzoneFile = document.querySelector(".dropzoneFile").files[0]
      console.log('selectedFile')

    },



    avancarSeg(){
      console.log('avancarSeg')
      this.activeTab = 1

    },

    formSubmit(){
      console.log('formSubmit')
      this.submitted = true;

      console.log(this.clienteData)
      console.log(this.enderecosData)

      if (this.clienteData.classeForm){
        this.clienteData.classe = this.clienteData.classeForm.toString()
      }else{
        this.clienteData.classe = ''
      }

      if ((this.clienteData.tel1 && this.clienteData.tel1.length > 15) || (this.clienteData.tel2 && this.clienteData.tel2.length > 15)) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Campo número(s) de telefone(s) deve possuir no máximo 15 caracteres, favor corrigir.",
          showConfirmButton: false,
          timer: 3000
        })
      } else if (this.clienteData.tipoestab === 'DT' && this.clienteData.tipo === 'PF') {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Pessoa Física não pode ser Tipo Estabelecimento Distribuidor, favor corrigir.",
          showConfirmButton: false,
          timer: 3000
        })
      } else if (this.clienteData.matriz === 'S' && !this.clienteData.classe.includes('TR')) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Se estiver preenchido como matriz então obrigatoriamente tipo pessoa deve ser transportadora, favor corrigir.",
          showConfirmButton: false,
          timer: 3000
        })
      } else {
        this.updating = true
        this.errosValid = []
        api.post(`${getBaseUrl()}api/cliente`, {
          clienteData: this.clienteData,
          fiscalData: this.fiscalData,
          enderData: this.enderecosData
        }).then((res) => {
          console.log('then axios')
          console.log(res)

          this.updating = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })

          if (this.idData === 0){
            this.idData = res.data[0].id
            this.clienteData.codigo = res.data[0].codigo
            this.$router.replace('/cliente/editar/' + this.idData)
          }


        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
          this.activeTab = 0
        })
      }
    },

    nomeStatus(strEntr){
      let result = 'Não Definido'
      switch (strEntr) {
        case 'A':
          result = 'Ativo'
          break
        default:
          result = 'Inativo'
          break
      }
      return result
    },


    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      // console.log(dateTime1)
      return moment(date).format(format)
    },

    formatDate(value){
      const format = "DD/MM/YYYY"
      var date = new Date(value)
      return moment(date).format(format)
    },

    formatDecimal(value) {
      // return parseFloat(value).toFixed(2)
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value).toFixed(2)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2})
      }
      return "0,00"
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    }

  },
  mounted() {
    console.log('mounted_cliente_editar_0')
    let rota = this.$route.path

    this.userLogged = JSON.parse(localStorage.getItem('user'))

    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)
    if (this.idData > 0){

      this.carregarDados()

    }else{

      this.title = `Criando Novo Cliente / Fornecedor`
      this.updating = false
      let emprAtu = localStorage.getItem('empratu')

      if (emprAtu) {
        this.empresa = emprAtu
      } else {
        this.empresa = '01'
      }

    }


  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>


    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`" show dismissible variant="danger">
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>


    <div class="checkout-tabs" v-if="!updating">

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">

              <b-button variant="outline-primary" class="mx-2" @click="formSubmit">
                <i class="bx bx-save font-size-16 align-middle me-2"></i>
                Salvar Alterações
              </b-button>

              <!--              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="imprimirOrcamento">-->
              <!--                <i class="bx bx-printer font-size-16 align-middle me-2"></i>-->
              <!--                Imprimir-->
              <!--              </b-button>-->

              <!--              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="copiarOrcamento">-->
              <!--                <i class="bx bx-copy font-size-16 align-middle me-2" ></i>-->
              <!--                Copiar-->
              <!--              </b-button>-->

              <b-button variant="outline-danger" class="mx-2" @click="consultarSPC">
                <i class="bx bx-book-content font-size-16 align-middle me-2"></i>
                Consultar SPC
              </b-button>

              <b-button variant="outline-dark" class="mx-2" @click="abrirModalIncExcSPC" :disabled="clienteData.id === 0">
                <i class="bx bx-user-x font-size-16 align-middle me-2"></i>
                Incluir / Excluir SPC
              </b-button>

              <b-button variant="outline-warning" class="mx-2" @click="novoAnexo" :disabled="clienteData.id === 0">
                <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                Novo Anexo
              </b-button>

              <b-button variant="outline-primary" class="mx-2" @click="auditoria" :disabled="clienteData.id === 0">
                <i class="bx bx-search-alt font-size-16 align-middle me-2"></i>
                Auditoria
              </b-button>

              <b-button variant="outline-success" class="mx-2" @click="consDadosPublicos" :disabled="clienteData.id === 0">
                <i class="bx bx-building font-size-16 align-middle me-2"></i>
                Dados Públicos (TESTES)
              </b-button>


            </div>
          </div>
        </div>
      </div>



      <b-tabs v-model="activeTab" pills vertical nav-class="p-0" nav-wrapper-class="col-xl-2 col-sm-3"
        content-class="w-100">
        <b-tab>
          <template v-slot:title>
            <i class="bx bxs-briefcase d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Principal</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="d-flex justify-content-between mb-4">
                  <div class="col-8">
                    <h4 class="card-title">Informações Principais</h4>
                  </div>
                  <!--                <p class="card-title-desc">Favor preencher corretamente os campos abaixo</p>-->

                  <div class="d-flex justify-content-end col-sm-4" style="position: relative; left: 8ch">
                    <div class="mx-4" style="width: 150px">
                      <label for="tipo"> Tipo ( PF/PJ )</label>
                      <div class="d-flex align-items-center justify-content-between" style="margin-top: -12px">
                        <b-form-checkbox
                            id="tipo"
                            switch
                            size="md"
                            value="PF"
                            unchecked-value="PJ"
                            v-model="clienteData.tipo">
                          {{ clienteData.tipo === 'PF' ? 'Pessoa Física' : 'Pessoa Jurídica' }}
                        </b-form-checkbox>
                      </div>
                    </div>

                    <div class="mx-4" style="width: 150px">
                      <label for="inadimplente"> Inadimplente </label>
                      <div class="d-flex align-items-center justify-content-between" style="margin-top: -12px">
                        <b-form-checkbox
                            id="inadimplente"
                            switch
                            size="md"
                            value="S"
                            unchecked-value="N"
                            v-model="clienteData.inadimplente">
                          {{ clienteData.inadimplente === 'S' ? 'Sim' : 'Não' }}
                        </b-form-checkbox>
                      </div>
                    </div>

                    <div class="mx-4" style="width: 150px">
                      <label for="statusPessoa"> Status </label>
                      <!--                    <div class="mb-3 align-items-end align-content-end float-end">-->
                      <!--                      <h5 class="font-size-14">Status</h5>-->
                      <div class="d-flex align-items-center justify-content-between" style="margin-top: -12px">
                        <b-form-checkbox
                            id="statusPessoa"
                            switch
                            size="md"
                            value="A"
                            unchecked-value="I"
                            v-model="clienteData.status">
                          {{ clienteData.status === 'A' ? 'Ativo' : 'Inativo' }}
                        </b-form-checkbox>
                      </div>
                    </div>
                  </div>

                </div>

                <form class="needs-validation">
                  <div class="row">

                    <div class="col-md-4">
                      <label for="cnpj" v-if="clienteData.tipo === 'PJ'">CNPJ</label>
                      <label for="cnpj" v-else>CPF</label>
                      <div class="position-relative">
                        <input v-if="clienteData.tipo === 'PJ'" id="cnpj" v-maska="'##.###.###/####-##'"
                          type="text" v-model="clienteData.cnpj" class="form-control" placeholder="CNPJ"
                          :class="{'is-invalid': submitted && !clienteData.cnpj}" />
                        <input v-else id="cnpj" v-maska="'###.###.###-##'"
                               type="text" v-model="clienteData.cnpj" class="form-control" placeholder="CPF"
                               :class="{'is-invalid': submitted && !clienteData.cnpj}" />
                        <div v-if="submitted && !clienteData.cnpj" class="invalid-feedback">
                          <span>Campo CNPJ obrigatório, favor preencher.</span>
                        </div>
                        <div class="chat-input-links" v-if="clienteData.cnpj && clienteData.tipo === 'PJ'">
                          <ul class="list-inline mb-0">
                            <li class="list-inline-item">
                              <a @click="consultarCNPJ" href="javascript: void(0);" v-b-tooltip.hover placement="top"
                                title="Consultar CNPJ">
                                <i class="mdi mdi-cloud-search-outline"></i>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>



                    <div class="col-sm-4">
                      <div class="mb-3">
                        <label for="nome">Nome</label>
                        <input id="nome" v-model="clienteData.nome" type="text" class="form-control" placeholder="Nome"
                          :class="{'is-invalid': submitted && !clienteData.nome}" />
                        <div v-if="submitted && !clienteData.nome" class="invalid-feedback">
                          <span>Campo nome obrigatório, favor preencher.</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-4">
                      <div class="mb-3">
                        <label for="fantasia">Nome Fantasia</label>
                        <input id="fantasia" v-model="clienteData.fantasia" type="text" class="form-control"
                          placeholder="Nome fantasia" />
                      </div>
                    </div>

                    <div class="col-sm-4">
                      <div class="">

                        <span class="text-black">Tipo Pessoa </span>
                        <multiselect v-model="clienteData.classeForm" :mode="'tags'" class="mt-2"
                          :options="optionsClasse" placeholder="Selecionar tipo de pessoa" label="cod" track-by="cod"
                          value-prop="cod">
                          <template #option="slotProps">
                            <div style="min-width: 50px;">
                              <span class="text-info">
                                {{ slotProps.option.cod }}
                              </span>
                            </div>
                            <div style="min-width: 300px;">
                              <span class="mx-4">
                                {{ slotProps.option.desc }}
                              </span>
                            </div>
                          </template>
                        </multiselect>

                      </div>
                    </div>


                    <div class="col-sm-4">
                      <div class="mb-3">
                        <label for="codigo">Código</label>
                        <input id="codigo" v-model="clienteData.codigo" type="text" class="form-control"
                          placeholder="Código" :disabled="true" />
                      </div>
                    </div>


                    <div class="col-sm-4">
                      <div class="mb-3">
                        <label for="tipo">Tipo</label>
                        <select id="tipo" v-model="clienteData.tipo" class="form-control"
                          :class="{'is-invalid': submitted && !clienteData.tipo}">
                          <option value="PF">Pessoa Física</option>
                          <option value="PJ">Pessoa Jurídica</option>
                        </select>
                        <div v-if="submitted && !clienteData.tipo" class="invalid-feedback">
                          <span>Campo tipo obrigatório, favor preencher.</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-4">
                      <div class="mb-3">
                        <label for="inscricao">Inscrição Estadual</label>
                        <input id="inscricao" v-model="clienteData.inscricao" type="text" class="form-control"
                          placeholder="Inscrição Estadual" />
                      </div>
                    </div>

                    <div class="col-sm-4">
                      <div class="mb-3">
                        <label for="tipoestab">Tipo Estabelecimento</label>
                        <select id="tipoestab" v-model="clienteData.tipoestab" class="form-control">
                          <option value="DT">Distribuidor</option>
                          <option value="VR">Varejista</option>
                          <option value="CF">Consumidor</option>
                          <option value="IN">Industrial</option>
                          <option value="IM">Importador</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-sm-4">
                      <div class="mb-3">
                        <label for="nascim">Data Início Atividade / Nascimento</label>
                        <input id="nascim" v-model="clienteData.nascim" type="date" class="form-control"
                          placeholder="Data Início Atividade / Nascimento" />
                      </div>
                    </div>

                    <div class="col-sm-3">
                      <div class="mb-3">
                        <label for="regtrib">Regime Tributário</label>
                        <select id="regtrib" v-model="clienteData.regtrib" class="form-control">
                          <option value="NM">Normal</option>
                          <option value="SN">Simples Nacional</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-sm-3">
                      <div class="mb-3">
                        <label for="apirastreio">API Tracking</label>
                        <select id="apirastreio" v-model="clienteData.apirastreio" class="form-control">
                          <!-- 2 Listas, atualizar as duas            -->

                          <option value="ACX">Acerta Express</option>
                          <option value="ANJUN">Anjum Express </option>
                          <option value="AMAZON">Amazon</option>
                          <option value="ANYMARKET">Any Market</option>
                          <option value="ALFA">Alfa</option>
                          <option value="AZLCRG">Azul Cargo</option>
                          <option value="B2WNOVA">B2W Nova Api</option>
                          <option value="BERTOLINI">Bertolini</option>
                          <option value="BLING">Bling</option>
                          <option value="BRP">Braspres</option>
                          <option value="BRUDAM">Brudam</option>
                          <option value="CORREIOS">Correios</option>
                          <option value="ESLC">ESL Cloud</option>
                          <option value="ESLD">ESL Desktop</option>
                          <option value="ESM">Expresso São Miguel</option>
                          <option value="FOCUSNFE">Focus NFe</option>
                          <option value="JAMEF">Jamef</option>
                          <option value="JDL">JadLog</option>
                          <option value="JET">J&T Express</option>
                          <option value="LEROYMER">Leroy Merlin</option>
                          <option value="LOGGI">Loggi</option>
                          <option value="LOGMED">Logmed</option>
                          <option value="LJTO">LogJato</option>
                          <option value="LOJAMEC">Loja do Mecânico</option>
                          <option value="MANDAE">Mandaê</option>
                          <option value="MAGALU">Magazine Luiza</option>
                          <option value="SEMRAST">Marketplace (SEM RASTREIO)</option>
                          <option value="MIRA">Mira</option>
                          <option value="MOBILE">Mobile</option>
                          <option value="MOVVI">Movvi</option>
                          <option value="MODULAR">Modular</option>
                          <option value="OURNGR">Ouro Negro transportes</option>
                          <option value="OCO">OCOREN</option>
                          <option value="QLTY">Quality</option>
                          <option value="PATR">Patrus</option>
                          <option value="RBEXP">RBExpress</option>
                          <option value="RDV">Rodonavis</option>
                          <option value="RELM">Realmed</option>
                          <option value="SKYHUB">SkyHub</option>
                          <option value="SOL">Solistica</option>
                          <option value="SSW">SSW</option>
                          <option value="TECMAR">Tecmar</option>
                          <option value="TOTEXP">Total Express</option>
                          <option value="TOTAL">Total Express 2</option>
                          <option value="TRAYCORP">TrayCorp</option>
                          <option value="TNT">TNT</option>
                          <option value="TRCO">Transcourier</option>
                          <option value="TRV">Translovato</option>
                          <option value="VTEX">Vtex</option>
                        </select>
                      </div>
                    </div>


                    <div class="col-sm-2">
                      <div class="mb-3">
                        <label for="livre1">Livre1</label>
                        <input id="livre1" v-model="clienteData.livre1" type="text" class="form-control"
                               placeholder="Livre1" />
                      </div>
                    </div>

                    <div class="col-sm-2">
                      <div class="mb-3">
                        <span>Serviço</span>
                        <multiselect id="servtransp"
                                     class="mt-2"
                                     @search-change="pesqCorreioServico"
                                     v-model="clienteData.servtransp"
                                     placeholder="Pesquisar serviços"
                                     :options="dtListPesqCorreioServico"
                                     :searchable="true"
                                     label="descricao"
                                     track-by="descricao"
                                     value-prop="codigo">
                          <template #option="slotProps">
                            <div class="row">
                              <div>
                          <span class="text-info">
                            {{ slotProps.option.codigo }}
                          </span>
                                <span class="mx-4" >
                          </span>
                              </div>
                              <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                            </div>
                          </template>
                        </multiselect>
                      </div>
                    </div>

                    <div class="col-sm-2">
                      <div class="mb-3">
                        <label for="prgordcol">Ordem de Coleta</label>
                        <select id="prgordcol" v-model="clienteData.prgordcol" class="form-control">
                          <option value="NEN">Não Enviar</option>
                          <option value="ENI">Enviar Imediatamente</option>
                          <option value="ENL">Enviar até limite</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-sm-2" v-if="clienteData.prgordcol === 'ENL'">
                      <div class="mb-3">
                        <label for="horlimcol">Hora lim. Ordem Coleta</label>
                        <input id="horlimcol" v-model="clienteData.horlimcol" type="number" class="form-control"
                          placeholder="Hora" />
                      </div>
                    </div>

                    <div class="col-sm-2">
                      <div class="mb-3">
                        <label for="diascoleta">Dias para Coleta</label>
                        <input id="diascoleta" v-model="clienteData.diascoleta" type="number" class="form-control"
                          placeholder="Dias para Coleta" />
                      </div>
                    </div>

                    <div class="col-sm-2" v-if="clienteData.classeForm && clienteData.classeForm.includes('TR')"
                      title="Cadastro será utilizado para disparar o email da transportadora">
                      <div class="mb-3">
                        <label for="transpfreteapi">Cadastro principal cotações API</label>
                        <div class="d-flex align-items-center justify-content-between" style="margin-top: -12px">
                          <b-form-checkbox id="transpfreteapi" switch size="lg" v-model="clienteData.transpfreteapi">
                            {{ clienteData.transpfreteapi === true ? 'Sim' : 'Não' }}
                          </b-form-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>


                  <hr>
                  <h4>Dados Contatos e Emails</h4>
                  <div class="row mt-2">

                    <div class="col-sm-4">
                      <div class="mb-3">
                        <label for="contato">Contato</label>
                        <input id="contato" v-model="clienteData.contato" type="text" class="form-control"
                          placeholder="Contato" />
                      </div>
                    </div>



                    <div class="col-sm-4">
                      <label for="inputEmail">Email</label>
                      <div class="position-relative">
                        <input id="inputEmail" type="text" :maxlength="100" v-model="clienteData.email"
                          class="form-control" placeholder="E-mail" />

                        <div class="chat-input-links" v-if="clienteData.email">
                          <ul class="list-inline mb-0">
                            <li class="list-inline-item">
                              <a :href="`mailto:${clienteData.email}`" v-b-tooltip.hover placement="top"
                                title="Enviar e-mail">
                                <i class="mdi mdi-email-send-outline"></i>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>



                    <div class="col-sm-2">
                      <label for="tel1">Telefone 1</label>
                      <div class="position-relative d-flex">
                        <input id="ddi_tel1" v-model="clienteData.ddi_tel1" type="text" class="form-control me-1"
                               placeholder="+DDI" v-maska="'+###'" maxlength="4" style="width: 70px;" />
                        <div class="position-relative w-100">
                          <input id="tel1" v-maska="'##.#####-####'" type="tel" :maxlength="15" v-model="clienteData.tel1"
                                 class="form-control" placeholder="Telefone 1" />

                          <div class="chat-input-links" v-if="clienteData.tel1">
                            <ul class="list-inline mb-0">
                              <li class="list-inline-item">
                                <a :href="`https://api.whatsapp.com/send?phone=${(clienteData.ddi_tel1 || '').replace('+', '')}${clienteData.tel1}`" target="_blank"
                                   v-b-tooltip.hover placement="top" title="Abrir Whatsapp">
                                  <i class="mdi mdi-phone"></i>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>


                    <div class="col-sm-2">
                      <label for="tel2">Telefone 2</label>
                      <div class="position-relative d-flex">
                        <input id="ddi_tel2" v-model="clienteData.ddi_tel2" type="text" class="form-control me-1"
                               placeholder="+DDI" v-maska="'+###'" maxlength="4" style="width: 70px;" />
                        <div class="position-relative w-100">
                          <input id="tel2" v-maska="'##.#####-####'" type="tel" :maxlength="15" v-model="clienteData.tel2"
                                 class="form-control" placeholder="Telefone 2" />

                          <div class="chat-input-links" v-if="clienteData.tel2">
                            <ul class="list-inline mb-0">
                              <li class="list-inline-item">
                                <a :href="`https://api.whatsapp.com/send?phone=${(clienteData.ddi_tel2 || '').replace('+', '')}${clienteData.tel2}`" target="_blank"
                                   v-b-tooltip.hover placement="top" title="Abrir Whatsapp">
                                  <i class="mdi mdi-phone"></i>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>


                  </div>


                  <div class="row mt-2">

                    <div class="col-sm-4">
                      <div class="mb-3">
                        <label for="mailsbol">E-mail's Boleto</label>
                        <input id="mailsbol" v-model="clienteData.mailsbol" type="text" class="form-control"
                          placeholder="E-mail's Boleto" />
                      </div>
                    </div>

                    <div class="col-sm-4">
                      <div class="mb-3">
                        <label for="mailsdfe">E-mail's Danfe</label>
                        <input id="mailsdfe" v-model="clienteData.mailsdfe" type="text" class="form-control"
                          placeholder="E-mail's Danfe" />
                      </div>
                    </div>

                    <div class="col-sm-4">
                      <div class="mb-3">
                        <label for="mailsxml">E-mail's XML</label>
                        <input id="mailsxml" v-model="clienteData.mailsxml" type="text" class="form-control"
                          placeholder="E-mail's XML NF-e" />
                      </div>
                    </div>

                    <div class="col-sm-12">
                      <div class="mb-3">
                        <label for="mailsxml">E-mail's redirecionamento XML<span class="text-muted">(Separado por vírgula)</span></label>
                        <div class="email-input-container">
                          <div class="email-tags-wrapper mb-1">
                            <span v-for="(email, index) in parsedEmails" :key="`email-${index}`" 
                              class="email-tag" 
                              :class="{ 'email-tag-invalid': !validEmail(email) }">
                              {{ email }}
                              <i class="mdi mdi-close ms-1" style="cursor: pointer;" @click="deleteEmailRedir(index)"></i>
                            </span>
                            <input 
                              id="mailsxml" 
                              v-model="emailInput" 
                              type="text" 
                              class="email-input-field"
                              placeholder="E-mail's para redirecionamento de XML de NF-e"
                              @keydown="handleEmailInput"
                              @blur="finalizeEmailInput"
                              @paste="handlePasteEmails"
                            />
                          </div>
                          
                          <label for="redirmail">Ativar redirecionamento e-mail arquivo de XML NF-e</label>
                          <div class="d-flex align-items-center" style="margin-top: -12px">
                            <b-form-checkbox
                                id="redirmail"
                                switch
                                size="lg"
                                @change="avisoRedirEmail"
                                v-model="clienteData.redirmail">
                              {{ clienteData.redirmail === true ? 'Sim' : 'Não' }}
                            </b-form-checkbox>
                            <div>
                              <b-button pill variant="light" size="sm" @click="showModalDataReprocessamento = true">Reprocessar</b-button>
                            </div>
                          </div>
                        </div>
                        <small v-if="invalidEmails.length > 0" class="text-danger d-block mt-2">
                          <i class="mdi mdi-alert-circle"></i> Email(s) inválido(s): {{ invalidEmails.join(', ') }}
                        </small>
                      </div>
                    </div>
                  </div>

                  <hr>

                  <div class="row mt-4">

                    <div class="col-sm-4">
                      <div class="mb-3">
                        <span class="font-size-13">Tabela de Preço</span>
                        <multiselect id="inputTabPreco" @search-change="pesqTabPreco" @select="escolheuTabPreco"
                          v-model="clienteData.tabpreco" placeholder="pesquisar tabela de preço..."
                          :options="dtListPesqTabPreco" :searchable="true" label="descricao" track-by="descricao"
                          value-prop="codigo" class="mt-2">
                          <template #option="slotProps">
                            <div style="min-width: 10%;">
                              <span class="text-info">
                                {{ slotProps.option.codigo }}
                              </span>
                            </div>
                            <div style="min-width: 250px;">
                              <span class="mx-4">
                                {{ slotProps.option.descricao }}
                              </span>
                            </div>
                          </template>
                        </multiselect>
                      </div>
                    </div>

                    <div class="col-sm-4">
                      <div class="mb-3">
                        <label for="espec">Especialidade</label>
                        <input id="espec" v-model="clienteData.espec" type="text" class="form-control"
                          placeholder="Especialidade" />
                      </div>
                    </div>

                    <div class="col-sm-4">
                      <div v-if="clienteData.classe?.includes('RE')" class="mb-3">

                        <label class="font-size-13">Representante</label>
                        <input id="inputRepres" v-model="pessoaRepresComissao.descricao" type="text" class="form-control" disabled/>
<!--                        <multiselect id="inputRepres" @search-change="pesqRepres" @select="escolheuRepres"
                                     v-model="clienteData.repres" placeholder="pesquisar representante..."
                                     :options="dtListPesqRepres" :searchable="true" label="descricao" track-by="descricao"
                                     value-prop="codigo" class="mt-2">
                          <template #option="slotProps">
                            <div style="min-width: 10%;">
                              <span class="text-info">
                                {{ slotProps.option.codigo }}
                              </span>
                            </div>
                            <div style="min-width: 250px;">
                              <span class="mx-4">
                                {{ slotProps.option.descricao }}
                              </span>
                            </div>
                          </template>
                        </multiselect>-->

                      </div>
                    </div>

                  </div>


                  <div class="row mt-2">

                    <div class="col-sm-4">
                      <div class="mb-3">
                        <label for="limite">Limite de Crédito</label>
                        <input id="limite" v-model="clienteData.limite" type="number" class="form-control"
                          placeholder="Limite de crédito" />
                      </div>
                    </div>

                    <div class="row justify-content-between col-sm-8">
                      <div class="mb-3" style="width: 250px">
                        <label for="autocredito"> Autorizado Crédito </label>
                        <div class="d-flex align-items-center justify-content-between" style="margin-top: -12px">
                          <b-form-checkbox
                              id="autocredito"
                              switch
                              size="lg"
                              value="S"
                              unchecked-value="N"
                              v-model="clienteData.autcred">
                            {{ clienteData.autcred === 'S' ? 'Sim' : 'Não' }}
                          </b-form-checkbox>
                        </div>
                      </div>

                      <div class="mb-3" style="width: 250px">
                        <label for="doccobmatriz"> O doccob chega pela matriz </label>
                        <div class="d-flex align-items-center justify-content-between" style="margin-top: -12px">
                          <b-form-checkbox
                              id="doccobmatriz"
                              switch
                              size="lg"
                              value="S"
                              unchecked-value="N"
                              v-model="clienteData.matriz">
                            {{ clienteData.matriz === 'S' ? 'Sim' : 'Não' }}
                          </b-form-checkbox>
                          <span class="text-danger" v-if="clienteData.matriz === 'S'">
                          É necessário que o campo Tipo Pessoa seja selecionado
                        </span>
                        </div>
                      </div>

                      <div class="mb-3" style="width: 250px">
                        <label for="contrib"> Contribuinte </label>
                        <div class="d-flex align-items-center justify-content-between" style="margin-top: -12px">
                          <b-form-checkbox
                              id="contrib"
                              switch
                              size="lg"
                              value="S"
                              unchecked-value="N"
                              v-model="clienteData.contrib">
                            {{ clienteData.contrib === 'S' ? 'Sim' : 'Não' }}
                          </b-form-checkbox>
                        </div>
                      </div>

                      <div class="mb-3" style="width: 250px">
                        <label for="autofinan"> Gerar financeiro automático</label>
                        <div class="d-flex align-items-center justify-content-between" style="margin-top: -12px">
                          <b-form-checkbox
                              id="autofinan"
                              switch
                              size="lg"
                              value="S"
                              unchecked-value="N"
                            v-model="fiscalData.autofinan">
                            {{ fiscalData.autofinan === 'S' ? 'Sim' : 'Não' }}
                          </b-form-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>



                  <div class="row mt-2">


                    <div class="col-sm-12">
                      <div class="mb-3">
                        <label for="obs">Observações</label>
                        <textarea id="obs" v-model="clienteData.obs" type="text" rows="3" class="form-control"
                          placeholder="Observações" />
                      </div>
                    </div>

                  </div>


                  <div class="row mt-2">

                    <div class="col-sm-6">
                      <div class="mb-3">
                        <label for="updated_by">Última Alteração</label>
                        <input id="updated_by" v-model="clienteData.updated_by" type="text" class="form-control"
                          :disabled="true" placeholder="Última Alteração" />
                      </div>
                    </div>

                    <div class="col-sm-6">
                      <div class="mb-3">
                        <label for="updated_at">Última Alteração</label>
                        <input id="updated_at" v-model="clienteData.updated_at" type="text" class="form-control"
                          :disabled="true" placeholder="Última Alteração" />
                      </div>
                    </div>

                  </div>

                </form>

              </div>
            </div>

          </b-card-text>
        </b-tab>


        <b-tab>
          <template v-slot:title>
            <i class="bx bxs-truck d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Fretes</p>
          </template>


          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="card shadow-none border mb-0">
                  <div class="card-body">
                    <h4 class="card-title mb-4">Veículos Drop Shipping</h4>

                    <div class="col-2">
                      <div class="mb-3">

                        <b-button variant="outline-success" class="mx-2" @click="novoVeic">
                          <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                          Novo Veículo
                        </b-button>

                      </div>
                    </div>


                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Descrição</th>
                          <th scope="col">Placa</th>
                          <th scope="col">Status</th>
                          <th scope="col">Tipo</th>
                          <th scope="col" class="text-end">Data</th>
                          <th scope="col" class="text-end">Ações</th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr v-for="data of pessoaVeicsData" :key="data.id">
                          <td>
                            <a href="javascript: void(0);" @click="editarVeic(data)" class="text-body fw-bold">
                              {{ data.id }}
                            </a>
                          </td>
                          <td> {{ data.descricao }} </td>
                          <td> {{ data.placa }} </td>
                          <td> {{ data.status }} </td>
                          <td> {{ data.tipo }} </td>
                          <td class="text-end"> {{ formatDateTime(data.created_at) }} </td>
                          <td class="text-end">
                            <div class="button-items">
                              <b-button variant="outline-warning" @click="editarVeic(data)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-danger" @click="deletarVeic(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>
                        </tr>

                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </b-card-text>



          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="card shadow-none border mb-0">
                  <div class="card-body">
                    <h4 class="card-title mb-4">Veículos Cotação Dedicada</h4>

                    <div class="col-2">
                      <div class="mb-3">

                        <b-button variant="outline-success" class="mx-2" @click="novoVeiCoDed">
                          <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                          Novo Veículo
                        </b-button>

                      </div>
                    </div>


                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Descrição</th>
                          <th scope="col">Placa</th>
                          <th scope="col">Status</th>
                          <th scope="col">Tipo</th>
                          <th scope="col" class="text-end">Peso Máx.</th>
                          <th scope="col" class="text-end">Data</th>
                          <th scope="col" class="text-end">Ações</th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr v-for="data of pessoaVeiCoDedsData" :key="data.id">
                          <td>
                            <a href="javascript: void(0);" @click="editarVeiCoDed(data)" class="text-body fw-bold">
                              {{ data.id }}
                            </a>
                          </td>
                          <td> {{ data.descricao }} </td>
                          <td> {{ data.placa }} </td>
                          <td> {{ data.status }} </td>
                          <td> {{ data.type_vehicle }} </td>
                          <td class="text-end"> {{ data.pesomax }} </td>
                          <td class="text-end"> {{ formatDateTime(data.created_at) }} </td>
                          <td class="text-end">
                            <div class="button-items">
                              <b-button variant="outline-warning" @click="editarVeiCoDed(data)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-danger" @click="deletarVeiCoDed(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>
                        </tr>

                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </b-card-text>



          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="card shadow-none border mb-0">
                  <div class="card-body">
                    <h4 class="card-title mb-4">Endereços de e-mail para solicitação de coleta</h4>
                    <!--                    <p class="card-title-desc">Selecione os usuários que são supervisionados por este usuário</p>-->

                    <div class="col-2">
                      <div class="mb-3">

                        <b-button variant="outline-success" class="mx-2" @click="showFormMailCota = true">
                          <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                          Novo Endereço
                        </b-button>


                        <!--                        <input-->
                        <!--                            id="periodo"-->
                        <!--                            v-model="periodo"-->
                        <!--                            type="month"-->
                        <!--                            @change="mudouPeriodo"-->
                        <!--                            class="form-control text-end"-->
                        <!--                            style="max-width: 200px;"-->
                        <!--                            placeholder="Período"/>  -->
                      </div>
                    </div>


                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Nome</th>
                          <th scope="col">E-mail</th>
                          <th scope="col" class="text-end">Data</th>
                          <th scope="col" class="text-end">Ações</th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr v-for="data of pessoaMailsCotaData" :key="data.id">
                          <td>
                            <a href="javascript: void(0);" @click="editarToken(data)" class="text-body fw-bold">
                              {{ data.id }}
                            </a>
                          </td>
                          <td> {{ data.nome }} </td>
                          <td> {{ data.email }} </td>
                          <td class="text-end"> {{ formatDateTime(data.created_at) }} </td>
                          <td class="text-end">
                            <div class="button-items">
                              <b-button variant="outline-warning" @click="editarMailCota(data)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-danger" @click="deletarMailCota(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>
                        </tr>

                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </b-card-text>



          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="card shadow-none border mb-0">
                  <div class="card-body">
                    <h4 class="card-title mb-4">Fórmula(s) Calculo de Frete</h4>
                    <!--                    <p class="card-title-desc">Selecione os usuários que são supervisionados por este usuário</p>-->

                    <div class="col-2">
                      <div class="mb-3">

                        <b-button variant="outline-success" class="mx-2" @click="showFormFormulaFrete = true">
                          <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                          Nova Fórmula
                        </b-button>


                        <!--                        <input-->
                        <!--                            id="periodo"-->
                        <!--                            v-model="periodo"-->
                        <!--                            type="month"-->
                        <!--                            @change="mudouPeriodo"-->
                        <!--                            class="form-control text-end"-->
                        <!--                            style="max-width: 200px;"-->
                        <!--                            placeholder="Período"/>  -->
                      </div>
                    </div>


                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Nome</th>
                          <th scope="col">E-mail</th>
                          <th scope="col" class="text-end">Data</th>
                          <th scope="col" class="text-end">Ações</th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr v-for="data of pessoaMailsCotaData" :key="data.id">
                          <td>
                            <a href="javascript: void(0);" @click="editarToken(data)" class="text-body fw-bold">
                              {{ data.id }}
                            </a>
                          </td>
                          <td> {{ data.nome }} </td>
                          <td> {{ data.email }} </td>
                          <td class="text-end"> {{ formatDateTime(data.created_at) }} </td>
                          <td class="text-end">
                            <div class="button-items">
                              <b-button variant="outline-warning" @click="editarMailCota(data)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-danger" @click="deletarMailCota(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>
                        </tr>

                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </b-card-text>





          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="card shadow-none border mb-0">
                  <div class="card-body">
                    <h4 class="card-title mb-4">Taxas Adicionais Cálculo de Frete</h4>
                    <!--                    <p class="card-title-desc">Selecione os usuários que são supervisionados por este usuário</p>-->

                    <div class="col-2">
                      <div class="mb-3">

                        <b-button variant="outline-success" class="mx-2" @click="criarNovaTaxa">
                          <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                          Nova Taxa
                        </b-button>

                      </div>
                    </div>


                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Observação</th>
                          <th scope="col">Base Cálculo</th>
                          <th scope="col">Transportadora</th>
                          <th scope="col" class="text-end">Percentual</th>
                          <th scope="col" class="text-end">Vlr.Mín.</th>
                          <th scope="col" class="text-end">Vlr.Máx.</th>
                          <th scope="col" class="text-end">Vlr.Fixo</th>
                          <th scope="col" class="text-end">Data</th>
                          <th scope="col" class="text-end">Ações</th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr v-for="data of pessoaFreteAdicsData" :key="data.id">
                          <td>
                            <a href="javascript: void(0);" @click="editarToken(data)" class="text-body fw-bold">
                              {{ data.id }}
                            </a>
                          </td>
                          <td> {{ data.obs }} </td>
                          <td> {{ data.fretecotabase_id }} </td>
                          <td> {{ data.transpnome }} </td>
                          <td class="text-end"> {{ formatDecimal(data.perc) }} </td>
                          <td class="text-end"> {{ formatDecimal(data.vlrmin) }} </td>
                          <td class="text-end"> {{ formatDecimal(data.vlrmax) }} </td>
                          <td class="text-end"> {{ formatDecimal(data.vlrfixo) }} </td>
                          <td class="text-end"> {{ formatDateTime(data.created_at) }} </td>
                          <td class="text-end">
                            <div class="button-items">
                              <b-button variant="outline-warning" @click="editarTaxaFrete(data)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-danger" @click="deletarTaxaFrete(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>
                        </tr>

                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </b-card-text>

          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="card shadow-none border mb-0">
                  <div class="card-body">
                    <h4 class="card-title mb-4">Redirecionamento de email</h4>
                    <!--                    <p class="card-title-desc">Selecione os usuários que são supervisionados por este usuário</p>-->

                    <div class="col-2">
                      <div class="mb-3">

                        <!-- Preciso editar-->
                        <b-button variant="outline-success" class="mx-2" @click="showFormMail = true">
                          <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                          Novo email
                        </b-button>


                        <!--                        <input-->
                        <!--                            id="periodo"-->
                        <!--                            v-model="periodo"-->
                        <!--                            type="month"-->
                        <!--                            @change="mudouPeriodo"-->
                        <!--                            class="form-control text-end"-->
                        <!--                            style="max-width: 200px;"-->
                        <!--                            placeholder="Período"/>  -->
                      </div>
                    </div>


                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Email</th>
                          <th scope="col">Nome</th>
                          <th scope="col">Ações</th>
                          <!-- <th scope="col">Data</th> -->
                        </tr>
                        </thead>
                        <tbody>

                        <tr v-for="data of pessoaEmailsData" :key="data.id">
                          <td>
                            <a href="javascript: void(0);" @click="editarToken(data)" class="text-body fw-bold">
                              {{ data.id }}
                            </a>

                          </td>
                          <td> {{ data.email }} </td>
                          <td> {{ data.nome }} </td>
                          <td class="text-end">
                            <div class="button-items">
                              <b-button variant="outline-warning" @click="editarEmail(data)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-danger" @click="deletarMail(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>
                          <!-- <td class="text-end"> {{ formatDateTime(data.created_at) }} </td> -->
                        </tr>

                        <!--                        <tr>-->
                        <!--                          <th scope="row">-->
                        <!--                            <img-->
                        <!--                                src="@/assets/images/users/avatar-2.jpg"-->
                        <!--                                alt="product-img"-->
                        <!--                                title="product-img"-->
                        <!--                                class="avatar-md"-->
                        <!--                            />-->
                        <!--                          </th>-->
                        <!--                          <td>-->
                        <!--                            <h5 class="font-size-14 text-truncate">-->
                        <!--                              <router-link-->
                        <!--                                  to="/ecommerce/product-detail"-->
                        <!--                                  class="text-dark"-->
                        <!--                              >Usuário Testes 003</router-link-->
                        <!--                              >-->
                        <!--                            </h5>-->
                        <!--                            <p class="text-muted mb-0">003</p>-->
                        <!--                          </td>-->
                        <!--                          <td>01/04/2023</td>-->
                        <!--                        </tr>-->

                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </b-card-text>

        </b-tab>




        <b-tab>
          <template v-slot:title>
            <i class="bx bx-map-pin d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Endereços</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div>
                  <h4 class="card-title">Endereços</h4>
                  <!--                  <p class="card-title-desc">Favor preencher corretamente os campos abaixo</p>-->

                  <h5 class="font-size-15 text-end">Endereço de Entrega</h5>
                  <div class="p-4 border">
                    <form>
                      <div class="row">
                        <div class="col-sm-4">
                          <label for="cep">CEP</label>
                          <div class="position-relative">
                            <input id="cep" v-maska="'##.###-###'" type="text" v-model="clienteData.cep"
                              class="form-control" placeholder="CEP"
                              :class="{'is-invalid': submitted && !clienteData.cep}" />
                            <div v-if="submitted && !clienteData.cep" class="invalid-feedback">
                              <span>Campo CEP obrigatório, favor preencher.</span>
                            </div>
                            <div class="chat-input-links" v-if="clienteData.cep">
                              <ul class="list-inline mb-0">
                                <li class="list-inline-item">
                                  <a @click="consultarCEP" href="javascript: void(0);" v-b-tooltip.hover placement="top"
                                    title="Consultar CEP">
                                    <i class="mdi mdi-cloud-search-outline"></i>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div class="col-sm-4">
                          <div class="mb-3">
                            <label for="rua">Logradouro</label>
                            <input id="rua" v-model="clienteData.rua" type="text" class="form-control"
                              placeholder="Logradouro" :class="{'is-invalid': submitted && !clienteData.rua}" />
                            <div v-if="submitted && !clienteData.rua" class="invalid-feedback">
                              <span>Campo logradouro obrigatório, favor preencher.</span>
                            </div>
                          </div>
                        </div>

                        <div class="col-sm-4">
                          <div class="mb-3">
                            <label for="numero">Número</label>
                            <input id="numero" v-model="clienteData.numero" type="text" class="form-control"
                              placeholder="Número" :class="{'is-invalid': submitted && !clienteData.numero}" />
                            <div v-if="submitted && !clienteData.numero" class="invalid-feedback">
                              <span>Campo número obrigatório, favor preencher.</span>
                            </div>
                          </div>
                        </div>

                        <div class="col-sm-4">
                          <div class="mb-3">
                            <label for="compl">Complemento</label>
                            <input id="compl" v-model="clienteData.compl" type="text" maxlength="60"
                              class="form-control" placeholder="Complemento" />
                          </div>
                        </div>

                        <div class="col-sm-4">
                          <div class="mb-3">
                            <label for="bairro">Bairro</label>
                            <input id="bairro" v-model="clienteData.bairro" type="text" class="form-control"
                              placeholder="Bairro" :class="{'is-invalid': submitted && !clienteData.bairro}" />
                            <div v-if="submitted && !clienteData.bairro" class="invalid-feedback">
                              <span>Campo bairro obrigatório, favor preencher.</span>
                            </div>
                          </div>
                        </div>


                        <div class="col-sm-4">
                          <div class="mb-3">
                            <label for="codmun">Código Cidade</label>
                            <input id="codmun" v-model="clienteData.codmun" type="text" class="form-control"
                              :disabled="true" placeholder="Código cidade" />
                          </div>
                        </div>

                        <div class="col-sm-4">
                          <div class="mb-3">

                            <span class="font-size-13">Cidade </span>
                            <multiselect id="inputCidade" @search-change="pesqCidade" @select="escolheuCidade"
                              v-model="clienteData.codmun" placeholder="Selecionar cidade" :options="dtListPesqCidade"
                              :searchable="true" label="descricao" track-by="descricao" value-prop="codigo"
                              class="mt-2">
                              <template #option="slotProps">
                                <div style="min-width: 25%;">
                                  <span class="text-info">
                                    {{ slotProps.option.estado }}
                                  </span>
                                </div>
                                <div style="min-width: 300px;">
                                  <span class="mx-4">
                                    {{ slotProps.option.descricao }}
                                  </span>
                                </div>
                              </template>
                            </multiselect>

                          </div>
                        </div>



                        <div class="col-sm-4">
                          <div class="mb-3">
                            <label for="estado">Estado</label>
                            <input id="estado" v-model="clienteData.estado" type="text" class="form-control"
                              placeholder="Estado" />
                          </div>
                        </div>




                        <div class="col-sm-4">
                          <div class="mb-3">
                            <label for="refer">Ponto de Referência</label>
                            <input id="refer" v-model="clienteData.refer" type="text" class="form-control"
                              placeholder="Ponto de Referência" />
                          </div>
                        </div>



                        <div class="col-sm-4">
                          <div class="mb-3">
                            <label for="refer">Latitude</label>
                            <input id="refer" v-model="clienteData.latitude" type="text" class="form-control"
                              :disabled="true" placeholder="Latitude" />
                          </div>
                        </div>




                        <div class="col-sm-4">
                          <div class="mb-3">
                            <label for="refer">Longitude</label>
                            <input id="refer" v-model="clienteData.longitude" type="text" class="form-control"
                              :disabled="true" placeholder="Longitude" />
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>


                  <h5 class="mt-3 font-size-15 text-end">Endereço Comercial 2</h5>
                  <div class="p-4 border">
                    <form>
                      <div class="row">
                        <div class="col-sm-4">
                          <label for="cep1">CEP</label>
                          <div class="position-relative">
                            <input id="cep1" v-maska="'##.###-###'" type="text" v-model="enderecosData.cep1"
                              class="form-control" placeholder="CEP" />

                            <div class="chat-input-links" v-if="enderecosData.cep1">
                              <ul class="list-inline mb-0">
                                <li class="list-inline-item">
                                  <a href="javascript: void(0);" v-b-tooltip.hover placement="top"
                                    title="Consultar CEP">
                                    <i class="mdi mdi-cloud-search-outline"></i>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div class="col-sm-4">
                          <div class="mb-3">
                            <label for="rua1">Logradouro</label>
                            <input id="rua1" v-model="enderecosData.rua1" type="text" class="form-control"
                              placeholder="Logradouro" />

                          </div>
                        </div>

                        <div class="col-sm-4">
                          <div class="mb-3">
                            <label for="numero1">Número</label>
                            <input id="numero1" v-model="enderecosData.numero1" type="text" class="form-control"
                              placeholder="Número" />

                          </div>
                        </div>

                        <div class="col-sm-4">
                          <div class="mb-3">
                            <label for="compl1">Complemento</label>
                            <input id="compl1" v-model="enderecosData.compl1" type="text" maxlength="60"
                              class="form-control" placeholder="Complemento" />
                          </div>
                        </div>

                        <div class="col-sm-4">
                          <div class="mb-3">
                            <label for="bairro1">Bairro</label>
                            <input id="bairro1" v-model="enderecosData.bairro1" type="text" class="form-control"
                              placeholder="Bairro" />

                          </div>
                        </div>

                        <div class="col-sm-4">
                          <div class="mb-3">
                            <label for="codmun1">Código Cidade</label>
                            <input id="codmun1" v-model="enderecosData.codmun1" type="text" class="form-control"
                              :disabled="true" placeholder="Código cidade" />
                          </div>
                        </div>

                        <div class="col-sm-4">
                          <div class="mb-3">

                            <span class="font-size-13">Cidade </span>
                            <multiselect id="inputCidade1" @search-change="pesqCidade1" @select="escolheuCidade1"
                              v-model="enderecosData.codmun1" placeholder="Selecionar cidade"
                              :options="dtListPesqCidade1" :searchable="true" label="descricao" track-by="descricao"
                              value-prop="codigo" class="mt-2">
                              <template #option="slotProps">
                                <div style="min-width: 25%;">
                                  <span class="text-info">
                                    {{ slotProps.option.estado }}
                                  </span>
                                </div>
                                <div style="min-width: 300px;">
                                  <span class="mx-4">
                                    {{ slotProps.option.descricao }}
                                  </span>
                                </div>
                              </template>
                            </multiselect>

                          </div>
                        </div>


                        <div class="col-sm-4">
                          <div class="mb-3">
                            <label for="estado1">Estado</label>
                            <input id="estado1" v-model="enderecosData.estado1" type="text" class="form-control"
                              placeholder="Estado" />
                          </div>
                        </div>


                        <div class="col-sm-4">
                          <div class="mb-3">
                            <label for="refer">Ponto de Referência</label>
                            <input id="refer1" v-model="enderecosData.refer1" type="text" class="form-control"
                              placeholder="Ponto de Referência" />
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>



                  <h5 class="mt-3 font-size-15 text-end">Endereço Residencial</h5>
                  <div class="p-4 border">
                    <form>
                      <div class="row">
                        <div class="col-sm-4">
                          <label for="cep2">CEP</label>
                          <div class="position-relative">
                            <input id="cep2" v-maska="'##.###-###'" type="text" v-model="enderecosData.cep2"
                              class="form-control" placeholder="CEP" />

                            <div class="chat-input-links" v-if="enderecosData.cep2">
                              <ul class="list-inline mb-0">
                                <li class="list-inline-item">
                                  <a href="javascript: void(0);" v-b-tooltip.hover placement="top"
                                    title="Consultar CEP">
                                    <i class="mdi mdi-cloud-search-outline"></i>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div class="col-sm-4">
                          <div class="mb-3">
                            <label for="rua2">Logradouro</label>
                            <input id="rua2" v-model="enderecosData.rua2" type="text" class="form-control"
                              placeholder="Logradouro" />

                          </div>
                        </div>

                        <div class="col-sm-4">
                          <div class="mb-3">
                            <label for="numero2">Número</label>
                            <input id="numero2" v-model="enderecosData.numero2" type="text" class="form-control"
                              placeholder="Número" />

                          </div>
                        </div>

                        <div class="col-sm-4">
                          <div class="mb-3">
                            <label for="compl2">Complemento</label>
                            <input id="compl2" v-model="enderecosData.compl2" type="text" maxlength="60"
                              class="form-control" placeholder="Complemento" />
                          </div>
                        </div>

                        <div class="col-sm-4">
                          <div class="mb-3">
                            <label for="bairro2">Bairro</label>
                            <input id="bairro2" v-model="enderecosData.bairro2" type="text" class="form-control"
                              placeholder="Bairro" />

                          </div>
                        </div>

                        <div class="col-sm-4">
                          <div class="mb-3">
                            <label for="codmun2">Código Cidade</label>
                            <input id="codmun2" v-model="enderecosData.codmun2" type="text" class="form-control"
                              :disabled="true" placeholder="Código cidade" />
                          </div>
                        </div>

                        <div class="col-sm-4">
                          <div class="mb-3">

                            <span class="font-size-13">Cidade </span>
                            <multiselect id="inputCidade2" @search-change="pesqCidade2" @select="escolheuCidade2"
                              v-model="enderecosData.codmun2" placeholder="Selecionar cidade"
                              :options="dtListPesqCidade2" :searchable="true" label="descricao" track-by="descricao"
                              value-prop="codigo" class="mt-2">
                              <template #option="slotProps">
                                <div style="min-width: 25%;">
                                  <span class="text-info">
                                    {{ slotProps.option.estado }}
                                  </span>
                                </div>
                                <div style="min-width: 300px;">
                                  <span class="mx-4">
                                    {{ slotProps.option.descricao }}
                                  </span>
                                </div>
                              </template>
                            </multiselect>

                          </div>
                        </div>

                        <div class="col-sm-4">
                          <div class="mb-3">
                            <label for="estado2">Estado</label>
                            <input id="estado2" v-model="enderecosData.estado2" type="text" class="form-control"
                              placeholder="Estado" />
                          </div>
                        </div>



                        <div class="col-sm-4">
                          <div class="mb-3">
                            <label for="refer">Ponto de Referência</label>
                            <input id="refer2" v-model="enderecosData.refer2" type="text" class="form-control"
                              placeholder="Ponto de Referência" />
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>


                </div>
              </div>
            </div>



          </b-card-text>

        </b-tab>


        <b-tab>
          <template v-slot:title>
            <i class="bx bxs-dollar-circle d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Financeiro</p>
          </template>

          <b-card-text v-if="clienteData.classe?.includes('RE')">
            <div class="card">
              <div class="card-body">
                <div class="card shadow-none border mb-0">
                  <div class="card-body">
                    <h4 class="card-title mb-4">Parâmetro para Comissão de Representantes</h4>

                    <div v-if="!pessoaRepresComissao.id" class="col-2">
                      <div class="mb-3">
                        <b-button variant="outline-success" class="mx-2" @click="novoParam">
                          <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                          Novo Parâmetro
                        </b-button>
                      </div>
                    </div>

                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Código</th>
                          <th scope="col">Descrição</th>
                          <th scope="col">Pessoa_id</th>
                          <th scope="col">Equipe_id</th>
                          <th scope="col" class="text-center">Status</th>
                          <th scope="col" class="text-center">Tipo Repres.</th>
                          <th scope="col" class="text-end">Dt. Criação</th>
                          <th scope="col" class="text-center">Ações</th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr v-if="pessoaRepresComissao.id">
                          <td>
                            <a href="javascript: void(0);" @click="editarRepres(pessoaRepresComissao)" class="text-body fw-bold">
                              {{ pessoaRepresComissao.id }}
                            </a>
                          </td>
                          <td> {{ pessoaRepresComissao.codigo }} </td>
                          <td> {{ pessoaRepresComissao.descricao }} </td>
                          <td> {{ pessoaRepresComissao.pessoa_id }} </td>
                          <td> {{ pessoaRepresComissao.represtime_id }} </td>
                          <td class="text-center">
                            <span
                                class="badge badge-pill badge-soft-success font-size-11"
                                :class="pessoaRepresComissao.status === 'A' ? 'badge-soft-success' : 'badge-soft-danger'">
                              {{ nomeStatus(pessoaRepresComissao.status)  }}
                            </span>
                          </td>
                          <td class="text-center"> {{ pessoaRepresComissao.lider === false ? "Padrão" : "Líder" }} </td>
                          <td class="text-end"> {{ formatDate(pessoaRepresComissao.created_at) }} </td>
                          <td class="text-center">
                            <div class="button-items">
                              <b-button variant="outline-warning" @click="editarRepres(pessoaRepresComissao)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-danger" @click="deletarRepres(pessoaRepresComissao.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>
                        </tr>

                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-card-text>

          <b-card-text v-if="Array.isArray(cpagar) && cpagar.length > 0">
            <div class="card">
              <div class="card-body">
                <div class="card shadow-none border mb-0">
                  <div class="card-body">
                    <h4 class="card-title mb-4">Contas a pagar</h4>

                    <div class="col-2">
                      <div class="mb-3">
                        <b-button variant="outline-success" class="mx-2" @click="novoFinanceiro">
                          <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                          Nova conta a pagar
                        </b-button>
                      </div>
                    </div>

                    <ejs-grid
                        ref='financeiroGrid'
                        :toolbar='toolbarOptions'
                        :dataSource="cpagar"
                        :allowSorting="true"
                        :allowFiltering="true"
                        :filterSettings='filterSettings'
                        :rowDataBound="rowDataBound"
                        :recordDoubleClick="redirecionarfinanparc"
                        :allowRowDragAndDrop='true'
                        :allowPdfExport='true'
                        :allowExcelExport="true"
                        :toolbarClick='toolbarClick'
                    >
                      <e-columns>
                        <e-column field="financeiro_id" headerText="Financeiro ID" textAlign="Right" width="auto"></e-column>
                        <e-column field="finanparc_id" headerText="Parcela ID" textAlign="Right" width="auto"></e-column>
                        <e-column field="financeiro_valortotal" format="0.00" headerText="Valor Total" textAlign="Right" width="auto"></e-column>
                        <e-column field="finanparc_valor" format="0.00" headerText="Valor Parcela" textAlign="Right" width="auto"></e-column>
                        <e-column :template="'parcelaTemplate'" headerText="Parcela" textAlign="Right" width="auto"></e-column>
                        <e-column :template="'statusTemplate'" headerText="Status" textAlign="Right" width="auto"></e-column>
                        <e-column field="finanparc_vencimento" headerText="Vencimento da parcela" type="date" format="dd/MM/yyyy" textAlign="Right" width="auto"></e-column>
                      </e-columns>
                      <template v-slot:parcelaTemplate="{ data }">
                        <span>{{ data.finanparc_parcela }}/{{ data.totalparcela }}</span>
                      </template>

                      <template v-slot:statusTemplate="{ data }">
                        <span v-if="data.finanparc_status === 'QT'">Quitado</span>
                        <span v-if="data.finanparc_status === 'CA'">Cancelado</span>
                        <span v-if="data.finanparc_status === 'AB'">Aberto</span>
                      </template>
                    </ejs-grid>



                  </div>
                </div>
              </div>
            </div>
          </b-card-text>

          <b-card-text v-if="Array.isArray(creceber) && creceber.length > 0">
            <div class="card">
              <div class="card-body">
                <div class="card shadow-none border mb-0">
                  <div class="card-body">
                    <h4 class="card-title mb-4">Contas a receber</h4>

                    <div class="col-2">
                      <div class="mb-3">
                        <b-button variant="outline-success" class="mx-2" @click="novoFinanceiro">
                          <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                          Nova conta a receber
                        </b-button>
                      </div>
                    </div>

                    <ejs-grid
                        ref='financeiroGrid'
                        exportDetailTemplate: exportDetailTemplate
                        :toolbar='toolbarOptions'
                        :dataSource="creceber"
                        :allowSorting="true"
                        :allowFiltering="true"
                        :filterSettings='filterSettings'
                        :rowDataBound="rowDataBound"
                        :recordDoubleClick="redirecionarfinanparc"
                        :allowRowDragAndDrop='true'
                        :allowPdfExport='true'
                        :allowExcelExport="true"
                        :toolbarClick='toolbarClick'
                    >
                      <e-columns>
                        <e-column field="financeiro_id" headerText="Financeiro ID" textAlign="Right" width="auto"></e-column>
                        <e-column field="finanparc_id" headerText="Parcela ID" textAlign="Right" width="auto"></e-column>
                        <e-column field="financeiro_valortotal" format="0.00" headerText="Valor Total" textAlign="Right" width="auto"></e-column>
                        <e-column field="finanparc_valor" format="0.00" headerText="Valor Parcela" textAlign="Right" width="auto"></e-column>
                        <e-column :template="'parcelaTemplate'" headerText="Parcela" textAlign="Right" width="auto"></e-column>
                        <e-column :template="'statusTemplate'" headerText="Status" textAlign="Right" width="auto"></e-column>
                        <e-column field="finanparc_vencimento" headerText="Vencimento da parcela" type="date" format="dd/MM/yyyy" textAlign="Right" width="auto"></e-column>
                      </e-columns>
                      <template v-slot:parcelaTemplate="{ data }">
                        <span>{{ data.finanparc_parcela }}/{{ data.totalparcela }}</span>
                      </template>

                      <template v-slot:statusTemplate="{ data }">
                        <span v-if="data.finanparc_status === 'QT'">Quitado</span>
                        <span v-if="data.finanparc_status === 'CA'">Cancelado</span>
                        <span v-if="data.finanparc_status === 'AB'">Aberto</span>
                      </template>
                    </ejs-grid>



                  </div>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>

        <b-tab>
          <template v-slot:title>
            <i class="bx bxs-file-find d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Fiscal</p>
          </template>

          <b-card-text>
            <div class="card">
              <div class="card-body">
                <h4 class="card-title mb-4">Informações Fiscais</h4>

                <div class="card shadow-none border mb-3">
                  <div class="card-body">
                    <h5 class="card-title mb-3">Seção: Informações Fiscais Essenciais</h5>
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="mb-3">
                          <div class="d-flex">
                            <i class="bx bx-help-circle font-size-16 align-middle me-2" style="cursor:pointer"
                              @click="mostrarHelp('ind_ie_dest')"></i>
                            <label for="ind_ie_dest">Indicador de Inscrição Estadual (IndIEDest)</label>
                          </div>
                          <multiselect id="ind_ie_dest" v-model="fiscalData.ind_ie_dest" :options="optionsIndIEDest"
                            placeholder="Selecione o indicador" label="label" track-by="value" value-prop="value" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card shadow-none border mb-3">
                  <div class="card-body">
                    <h5 class="card-title mb-3">Seção: Regime Tributário e Retenções</h5>
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="mb-3">
                          <div class="d-flex">
                            <i class="bx bx-help-circle font-size-16 align-middle me-2" style="cursor:pointer"
                              @click="mostrarHelp('regime_tributario')"></i>
                            <label for="regime_tributario">Regime Tributário do Cliente (Destinatário)</label>
                          </div>
                          <multiselect id="regime_tributario" v-model="fiscalData.regime_tributario"
                            :options="optionsRegimeTributario" placeholder="Selecione o regime" label="label"
                            track-by="value" value-prop="value" />
                        </div>
                      </div>
                    </div>

                    <div class="d-flex align-items-center mt-4 mb-3">
                      <i class="bx bx-help-circle font-size-16 align-middle me-2" style="cursor:pointer"
                        @click="mostrarHelp('retencoes')"></i>
                      <h6 class="mb-0">Retenção de impostos?</h6>
                    </div>

                    <div class="row border p-3 mb-3 bg-light rounded">
                      <div class="col-sm-12">
                        <b-form-checkbox id="reter_irrf" v-model="fiscalData.reter_irrf" class="mb-2">
                          Imposto de Renda Retido na Fonte (IRRF)
                        </b-form-checkbox>
                        <div v-if="fiscalData.reter_irrf" class="row ms-3 mb-3">
                          <div class="col-sm-3">
                            <label class="font-size-12">Alíquota Padrão IRRF (%)</label>
                            <input v-model="fiscalData.aliquota_irrf" type="number" step="0.01"
                              class="form-control form-control-sm" />
                          </div>
                          <div class="col-sm-3">
                            <label class="font-size-12">Valor Mínimo Retenção IRRF</label>
                            <input v-model="fiscalData.vlr_min_irrf" type="number" step="0.01"
                              class="form-control form-control-sm" />
                          </div>
                        </div>

                        <b-form-checkbox id="reter_csrf" v-model="fiscalData.reter_csrf" class="mb-2">
                          Contribuições Sociais Retidas na Fonte (CSRF / PCC)
                        </b-form-checkbox>
                        <div v-if="fiscalData.reter_csrf" class="row ms-3 mb-3">
                          <div class="col-sm-3">
                            <label class="font-size-12">Alíquota Padrão CSRF (%)</label>
                            <input v-model="fiscalData.aliquota_csrf" type="number" step="0.01"
                              class="form-control form-control-sm" />
                          </div>
                          <div class="col-sm-3">
                            <label class="font-size-12">Valor Mínimo Retenção CSRF</label>
                            <input v-model="fiscalData.vlr_min_csrf" type="number" step="0.01"
                              class="form-control form-control-sm" />
                          </div>
                        </div>

                        <b-form-checkbox id="reter_issqn" v-model="fiscalData.reter_issqn" class="mb-2">
                          Imposto Sobre Serviços (ISSQN)
                        </b-form-checkbox>
                        <div v-if="fiscalData.reter_issqn" class="row ms-3 mb-3 border-start ps-3">
                          <div class="col-sm-3">
                            <label class="font-size-12">Alíquota ISSQN (%)</label>
                            <input v-model="fiscalData.aliquota_issqn" type="number" step="0.01"
                              class="form-control form-control-sm" />
                          </div>
                          <div class="col-sm-6">
                            <label class="font-size-12">Critério de Retenção ISSQN</label>
                            <multiselect v-model="fiscalData.criterio_issqn" :options="optionsCriterioISSQN"
                              placeholder="Selecione o critério" label="label" track-by="value" value-prop="value"
                              class="multiselect-sm" />
                          </div>
                          <div class="col-sm-3 d-flex align-items-end mb-2">
                            <b-form-checkbox id="iss_subst_trib" v-model="fiscalData.iss_subst_trib" switch>
                              Substituto Tributário?
                            </b-form-checkbox>
                          </div>
                        </div>

                        <b-form-checkbox id="reter_inss" v-model="fiscalData.reter_inss" class="mb-2">
                          Contribuição Previdenciária Retida (INSS)
                        </b-form-checkbox>
                        <div v-if="fiscalData.reter_inss" class="row ms-3 mb-3">
                          <div class="col-sm-3">
                            <label class="font-size-12">Alíquota INSS (%)</label>
                            <input v-model="fiscalData.aliquota_inss" type="number" step="0.01"
                              class="form-control form-control-sm" />
                          </div>
                          <div class="col-sm-3">
                            <label class="font-size-12">Base de Cálculo INSS (%)</label>
                            <input v-model="fiscalData.bc_inss_perc" type="number" step="0.01"
                              class="form-control form-control-sm" />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mt-4">
                      <div class="col-sm-12">
                        <label for="obs_fiscais">Observações Fiscais Específicas do Cliente</label>
                        <textarea id="obs_fiscais" v-model="fiscalData.obs_fiscais" rows="4" class="form-control"
                          placeholder="Peculiaridades fiscais acordadas..." />
                      </div>
                    </div>

                  </div>
                </div>
                <div class="card shadow-none border mb-3">
                  <div class="card-body">
                    <h5 class="card-title mb-3">Seção: Informações SUFRAMA</h5>

                    <div class="row">
                      <div class="col-sm-12">
                        <b-form-checkbox id="is_suframa" v-model="fiscalData.is_suframa" switch class="mb-3">
                          Cliente Localizado em Área SUFRAMA?
                        </b-form-checkbox>
                      </div>
                    </div>

                    <div v-if="fiscalData.is_suframa" class="row border p-3 bg-light rounded">
                      <div class="col-sm-4">
                        <div class="mb-3">
                          <label for="inscricao_suframa">Inscrição SUFRAMA do Cliente</label>
                          <input id="inscricao_suframa" v-model="fiscalData.inscricao_suframa" type="text"
                            class="form-control" placeholder="X.XXX.XXX-X" />
                        </div>
                      </div>

                      <div class="col-sm-4">
                        <div class="mb-3">
                          <label for="status_suframa">Status da Inscrição SUFRAMA</label>
                          <multiselect id="status_suframa" v-model="fiscalData.status_suframa"
                            :options="optionsStatusSUFRAMA" placeholder="Selecione o status" label="label"
                            track-by="value" value-prop="value" />
                        </div>
                      </div>

                      <div class="col-sm-4">
                        <div class="mb-3">
                          <label for="natureza_op_suframa">Natureza da Operação SUFRAMA</label>
                          <multiselect id="natureza_op_suframa" v-model="fiscalData.natureza_op_suframa"
                            :options="optionsNaturezaOpSUFRAMA" placeholder="Selecione a natureza" label="label"
                            track-by="value" value-prop="value" />
                        </div>
                      </div>

                      <div class="col-sm-12">
                        <b-form-checkbox id="gera_pin" v-model="fiscalData.gera_pin" switch class="mt-2">
                          Necessita Geração de PIN (Protocolo de Internamento)?
                        </b-form-checkbox>
                      </div>

                      <div class="col-sm-12 mt-3">
                        <b-button variant="outline-info" size="sm" @click="mostrarHelp('suframa')">
                          <i class="bx bx-help-circle me-1"></i> Saiba mais sobre SUFRAMA
                        </b-button>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </b-card-text>
        </b-tab>

        <b-tab>
          <template v-slot:title>
            <i class="bx bx bx-folder-open d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Anexos</p>
          </template>
          <b-card-text>
            <div class="card">


              <div class="card-body">
                <h4 class="card-title">Pasta de Anexos</h4>
                <p class="card-title-desc">
                  Pasta de Anexos do Cliente</p>

                <div class="row" v-if="loadingFiles">
                  <div class="col-12 text-center">
                    <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
                    </b-spinner>
                    <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
                    </b-spinner>
                    <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
                    </b-spinner>
                  </div>
                </div>



                <div class="table-responsive" v-if="!loadingFiles">
                  <table class="table align-middle mb-0 table-nowrap">
                    <thead class="table-light">
                    <tr>
                      <th scope="col">ID</th>
                      <th scope="col">Descrição</th>
                      <th scope="col">Arquivo</th>
                      <th scope="col">Data</th>
                      <th scope="col">Ações</th>
                    </tr>
                    </thead>
                    <tbody>

                    <tr v-for="data in mediasData" :key="data.id">

                      <td>
                        <h5 class="font-size-14 text-truncate">
                            <span class="text-dark">
                              {{ data.id }}
                            </span>
                        </h5>
                      </td>

                      <td>
                        {{ data.descricao }}
                      </td>

                      <td>
                          <span class="text-dark">
                            {{ data.nome }}
                          </span>
                      </td>

                      <td>
                        <h5 class="font-size-14 text-truncate">
                            <span class="text-dark">
                              {{ formatDateTime(data.created_at) }}
                            </span>
                        </h5>
                      </td>


                      <td>
                        <div class="button-items">

                          <b-button variant="outline-success" @click="downFile(data.path, data.nome)">
                            <i class="mdi mdi-download d-block font-size-16"></i>
                          </b-button>

                          <b-button variant="outline-danger" @click="delFile(data.id)"
                                    :disabled="data.email === 'admin@admin.com.br'">
                            <i class="mdi mdi-trash-can d-block font-size-16"></i>
                          </b-button>

                        </div>
                      </td>


                    </tr>

                    </tbody>
                  </table>
                </div>

              </div>


            </div>






          </b-card-text>

        </b-tab>


        <b-tab>
          <template v-slot:title>
            <i class="bx bxs-key d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Tokens</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="card shadow-none border mb-0">
                  <div class="card-body">
                    <h4 class="card-title mb-4">Tokens</h4>
                    <!--                    <p class="card-title-desc">Selecione os usuários que são supervisionados por este usuário</p>-->

                    <div class="col-2">
                      <div class="mb-3">

                        <b-button variant="outline-success" class="mx-2" @click="showFormToken = true">
                          <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                          Novo Token
                        </b-button>


                        <!--                        <input-->
                        <!--                            id="periodo"-->
                        <!--                            v-model="periodo"-->
                        <!--                            type="month"-->
                        <!--                            @change="mudouPeriodo"-->
                        <!--                            class="form-control text-end"-->
                        <!--                            style="max-width: 200px;"-->
                        <!--                            placeholder="Período"/>  -->
                      </div>
                    </div>


                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">HUB</th>
                          <th scope="col">Validade</th>
                          <th scope="col">Data</th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr v-for="data of pessoaTokensData" :key="data.id">
                          <td>
                            <a href="javascript: void(0);" @click="editarToken(data)" class="text-body fw-bold">
                              {{ data.id }}
                            </a>

                          </td>
                          <td> {{ data.hub }} </td>
                          <td> {{ data.validade }} </td>
                          <td class="text-end"> {{ formatDateTime(data.created_at) }} </td>
                        </tr>

                        <!--                        <tr>-->
                        <!--                          <th scope="row">-->
                        <!--                            <img-->
                        <!--                                src="@/assets/images/users/avatar-2.jpg"-->
                        <!--                                alt="product-img"-->
                        <!--                                title="product-img"-->
                        <!--                                class="avatar-md"-->
                        <!--                            />-->
                        <!--                          </th>-->
                        <!--                          <td>-->
                        <!--                            <h5 class="font-size-14 text-truncate">-->
                        <!--                              <router-link-->
                        <!--                                  to="/ecommerce/product-detail"-->
                        <!--                                  class="text-dark"-->
                        <!--                              >Usuário Testes 003</router-link-->
                        <!--                              >-->
                        <!--                            </h5>-->
                        <!--                            <p class="text-muted mb-0">003</p>-->
                        <!--                          </td>-->
                        <!--                          <td>01/04/2023</td>-->
                        <!--                        </tr>-->

                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </b-card-text>
        </b-tab>

      </b-tabs>
    </div>


    <b-modal title="Criar Novo Anexo" v-model="showModalAnexo" centered hide-footer>
      <div>

        <div class="card-body">
          <h4 class="card-title">Selecionar novo arquivo</h4>
          <DropZone @change="selectedFile" />
          <span class="file-info">Arquivo: {{ dropzoneFile.name }}</span>
          <div v-if="submittedAnexo && !dropzoneFile.name">
            <span class="text-danger font-size-11">Favor selecionar o arquivo e tentar novamente.</span>
          </div>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <label for="descranexo">Descrição</label>
              <div class="position-relative">
                <input id="descranexo" type="text" v-model="descranexo" class="form-control"
                       placeholder="Descrição do anexo" :class="{'is-invalid': submittedAnexo && !descranexo}" />
                <div v-if="submittedAnexo && !descranexo" class="invalid-feedback">
                  <span>Campo descrição obrigatório, favor preencher.</span>
                </div>

              </div>
            </div>
          </div>
        </div>


        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalAnexo = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confAnexo">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>

    <b-modal size="lg" title="Consultar CNPJ" v-model="showModalConsCNPJ" hide-footer>

      <div class="row" v-if="loadingDadosCnpj">
        <div class="col-12 text-center">
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
        </div>
      </div>


      <div v-if="!loadingDadosCnpj">
        <h5 class="card-title">Favor selecionar os campos que deseja importar</h5>

        <div class="row">
          <div class="col-lg-6">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="d-flex flex-wrap">
                  <div class="me-2">
                    <p class="text-muted mb-2">Situação Atual</p>
                    <h5 class="mb-0">{{ consCnpjSituacao }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="d-flex flex-wrap">
                  <div class="me-2">
                    <p class="text-muted mb-2">Data de Abertura</p>
                    <h5 class="mb-0"> {{ consCnpjDAbe }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-lg-6">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="d-flex flex-wrap">
                  <div class="me-2">
                    <p class="text-muted mb-2">Sócio 01</p>
                    <h5 class="mb-0">{{ consCnpjSocio1 }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="d-flex flex-wrap">
                  <div class="me-2">
                    <p class="text-muted mb-2">Sócio 02</p>
                    <h5 class="mb-0"> {{ consCnpjSocio2 }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>Nome Fantasia</span>
              <b-form-checkbox v-model="consCnpjImpFantasia" switch>
                {{ consCnpjFantasia }}
              </b-form-checkbox>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>Nome</span>
              <b-form-checkbox v-model="consCnpjImpNome" switch>
                {{ consCnpjNome }}
              </b-form-checkbox>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>CNPJ</span>
              <b-form-checkbox v-model="consCnpjImpCnpj" switch>
                {{ consCnpjCnpj }}
              </b-form-checkbox>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>CEP</span>
              <b-form-checkbox v-model="consCnpjImpCep" switch>
                {{ consCnpjCep }}
              </b-form-checkbox>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>Endereço</span>
              <b-form-checkbox v-model="consCnpjImpEndereco" switch>
                {{ consCnpjEndereco }}
              </b-form-checkbox>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>Número</span>
              <b-form-checkbox v-model="consCnpjImpNumero" switch>
                {{ consCnpjNumero }}
              </b-form-checkbox>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>Complemento</span>
              <b-form-checkbox v-model="consCnpjImpCompl" switch>
                {{ consCnpjCompl }}
              </b-form-checkbox>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>Bairro</span>
              <b-form-checkbox v-model="consCnpjImpBairro" switch>
                {{ consCnpjBairro }}
              </b-form-checkbox>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>Latitude e Longitude</span>
              <b-form-checkbox v-model="consCnpjImpLatLong" switch>
                lat.: {{ consCnpjLat }} / long.: {{ consCnpjLong }}
              </b-form-checkbox>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>Cidade</span>
              <b-form-checkbox v-model="consCnpjImpCidade" switch>
                {{ consCnpjCidade }}
              </b-form-checkbox>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>Estado</span>
              <b-form-checkbox v-model="consCnpjImpEstado" switch>
                {{ consCnpjEstado }}
              </b-form-checkbox>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>E-mail</span>
              <b-form-checkbox v-model="consCnpjImpEmail" switch>
                {{ consCnpjEmail }}
              </b-form-checkbox>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>Telefone 1</span>
              <b-form-checkbox v-model="consCnpjImpTel" switch>
                {{ consCnpjTel }}
              </b-form-checkbox>
            </div>
          </div>
        </div>



        <div v-if="!loadingDadosCnpj && clienteData">
          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalConsCNPJ = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>
            <b-button type="submit" variant="success" class="ms-1" @click="confirmarImpCnpj">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
          </div>
        </div>

      </div>

    </b-modal>


    <b-modal size="lg" title="Consultar CEP" v-model="showModalConsCEP" hide-footer>

      <div class="row" v-if="loadingDadosCep">
        <div class="col-12 text-center">
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
        </div>
      </div>


      <div v-if="!loadingDadosCep">
        <h5 class="card-title">Favor selecionar os campos que deseja importar</h5>


        <div class="row">
          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>Endereço</span>
              <b-form-checkbox v-model="consCnpjImpEndereco" switch>
                {{ consCnpjEndereco }}
              </b-form-checkbox>
            </div>
          </div>

          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>Complemento</span>
              <b-form-checkbox v-model="consCnpjImpCompl" switch>
                {{ consCnpjCompl }}
              </b-form-checkbox>
            </div>
          </div>

        </div>


        <div class="row">

          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>Bairro</span>
              <b-form-checkbox v-model="consCnpjImpBairro" switch>
                {{ consCnpjBairro }}
              </b-form-checkbox>
            </div>
          </div>

          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>Latitude e Longitude</span>
              <b-form-checkbox v-model="consCnpjImpLatLong" switch>
                lat.: {{ consCnpjLat }} / long.: {{ consCnpjLong }}
              </b-form-checkbox>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>Cidade</span>
              <b-form-checkbox v-model="consCnpjImpCidade" switch>
                {{ consCnpjCidade }}
              </b-form-checkbox>
            </div>
          </div>

        </div>


        <div v-if="!loadingDadosCep && clienteData">
          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalConsCEP = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>
            <b-button type="submit" variant="success" class="ms-1" @click="confirmarImpCep">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
          </div>
        </div>

      </div>

    </b-modal>


    <b-modal title="Auditoria" v-model="showModalAuditoria" centered hide-footer>

      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="created_by">Usuário Criação</label>
            <input id="created_by" v-model="clienteData.created_by" type="text" class="form-control" :disabled="true"
                   placeholder="Usuário Criação" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="created_at">Criado em</label>
            <input id="created_at" v-model="clienteData.created_at" type="datetime-local" class="form-control"
                   :disabled="true" placeholder="Criado em" />
          </div>
        </div>
      </div>


      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="updated_by">Usuário Atualização</label>
            <input id="updated_by" v-model="clienteData.updated_by" type="text" class="form-control" :disabled="true"
                   placeholder="Usuário Atualização" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="updated_at">Atualizado em</label>
            <input id="updated_at" v-model="clienteData.updated_at" type="datetime-local" class="form-control"
                   :disabled="true" placeholder="Atualizado em" />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">


          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalAuditoria = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Fechar
            </b-button>

          </div>
        </div>
      </div>

    </b-modal>




    <!-- ===== Modal: Inclusão / Exclusão SPC Brasil ===== -->
    <b-modal size="lg" title="Incluir / Excluir no SPC Brasil" v-model="showModalIncExcSPC" hide-footer>

      <!-- Loading -->
      <div class="row" v-if="loadingIncExcSPC">
        <div class="col-12 text-center">
          <b-spinner type="grow" class="m-6 mx-2" variant="dark" role="status"></b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="dark" role="status"></b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="dark" role="status"></b-spinner>
        </div>
      </div>

      <div v-if="!loadingIncExcSPC">

        <!-- Seleção da operação -->
        <div class="row mb-3">
          <div class="col-12">
            <label class="form-label fw-bold">Operação</label>
            <div class="btn-group w-100" role="group">
              <input type="radio" class="btn-check" id="spcOpIncluir" value="incluir" v-model="spcOperacao" autocomplete="off">
              <label class="btn btn-outline-danger" for="spcOpIncluir">
                <i class="bx bx-plus-circle me-1"></i> Incluir Devedor
              </label>
              <input type="radio" class="btn-check" id="spcOpExcluir" value="excluir" v-model="spcOperacao" autocomplete="off">
              <label class="btn btn-outline-success" for="spcOpExcluir">
                <i class="bx bx-minus-circle me-1"></i> Excluir Devedor
              </label>
            </div>
          </div>
        </div>

        <!-- Dados do devedor (somente leitura) -->
        <div class="row mb-3">
          <div class="col-md-6">
            <label class="form-label">Nome / Razão Social</label>
            <input type="text" class="form-control" :value="clienteData.nome" disabled>
          </div>
          <div class="col-md-6">
            <label class="form-label">CPF / CNPJ</label>
            <input type="text" class="form-control" :value="clienteData.cnpj" disabled>
          </div>
        </div>

        <!-- Número do contrato (sempre visível) -->
        <div class="row mb-3">
          <div class="col-md-6">
            <label class="form-label fw-bold">Número do Contrato / NF / Título <span class="text-danger">*</span></label>
            <input type="text" class="form-control" v-model="spcNumContrato" placeholder="Ex.: NF-00123 ou CT-2025-001">
          </div>
        </div>

        <!-- Detalhes da dívida (usados na Inclusão e Exclusão) -->
        <div>
          <div class="row mb-3">
            <div class="col-md-3">
              <label class="form-label fw-bold">Valor (R$) <span class="text-danger">*</span></label>
              <input type="number" min="0.01" step="0.01" class="form-control" v-model="spcValorDivida" placeholder="0.00">
            </div>
            <div class="col-md-3">
              <label class="form-label fw-bold">Data Compra <span class="text-danger">*</span></label>
              <input type="date" class="form-control" v-model="spcDataCompra">
            </div>
            <div class="col-md-3">
              <label class="form-label fw-bold">Vencimento <span class="text-danger">*</span></label>
              <input type="date" class="form-control" v-model="spcDataVencimento">
            </div>
            <div class="col-md-3">
              <label class="form-label fw-bold">Natureza</label>
              <select class="form-select" v-model="spcNaturezaDivida">
                <option v-for="op in optionsNaturezaSPC" :key="op.value" :value="op.value">{{ op.label }}</option>
              </select>
            </div>
          </div>
        </div>

        <!-- Campos exclusivos de exclusão -->
        <div v-if="spcOperacao === 'excluir'">
          <div class="row mb-3">
            <div class="col-md-6">
              <label class="form-label fw-bold">Motivo da Exclusão</label>
              <select class="form-select" v-model="spcMotivoExclusao">
                <option v-for="op in optionsMotivoExclusaoSPC" :key="op.value" :value="op.value">{{ op.label }}</option>
              </select>
            </div>
          </div>
        </div>

        <!-- Botão de envio -->
        <div class="row mt-3">
          <div class="col-12 text-end">
            <b-button variant="secondary" class="me-2" @click="showModalIncExcSPC = false">Cancelar</b-button>
            <b-button :variant="spcOperacao === 'incluir' ? 'danger' : 'success'" @click="enviarIncExcSPC">
              <i :class="spcOperacao === 'incluir' ? 'bx bx-user-x' : 'bx bx-user-check'" class="me-1"></i>
              {{ spcOperacao === 'incluir' ? 'Incluir no SPC' : 'Excluir do SPC' }}
            </b-button>
          </div>
        </div>

        <!-- Resposta XML -->
        <div class="row mt-4" v-if="xmlIncExcSPC">
          <div class="col-12">
            <label class="form-label fw-bold">Resposta SPC Brasil:</label>
            <pre class="bg-light p-3 rounded" style="max-height: 300px; overflow-y: auto; font-size: 12px;">{{ xmlIncExcSPC }}</pre>
          </div>
        </div>

      </div>
    </b-modal>
    <!-- ===== Fim Modal Inclusão/Exclusão SPC ===== -->


    <b-modal size="xl" title="Consultar SPC" v-model="showModalConsSPC" hide-footer>

      <div class="row" v-if="loadingDadosSPC">
        <div class="col-12 text-center">
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
        </div>
      </div>


      <!-- Dashboard SPC -->
      <div v-if="!loadingDadosSPC && spcData">

        <!-- ===== Faixa de restrição ===== -->
        <div :class="['alert', 'fw-bold', 'fs-5', 'text-center', spcData.restricao ? 'alert-danger' : 'alert-success']">
          <i :class="['bx', 'me-2', spcData.restricao ? 'bx-block' : 'bx-check-shield']"></i>
          {{ spcData.restricao ? '⚠️ POSSUI RESTRIÇÃO NO SPC' : '✅ SEM RESTRIÇÃO NO SPC' }}
        </div>

        <!-- ===== Cabeçalho: protocolo, data, operador ===== -->
        <div class="row g-2 mb-3">
          <div class="col-md-4">
            <div class="card border-0 bg-light h-100">
              <div class="card-body py-2">
                <p class="text-muted mb-1 small">Protocolo</p>
                <strong>{{ spcData.protocolo.numero }}-{{ spcData.protocolo.digito }}</strong>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card border-0 bg-light h-100">
              <div class="card-body py-2">
                <p class="text-muted mb-1 small">Data da Consulta</p>
                <strong>{{ spcData.data_consulta ? spcData.data_consulta.substring(0,10).split('-').reverse().join('/') : '—' }}</strong>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card border-0 bg-light h-100">
              <div class="card-body py-2">
                <p class="text-muted mb-1 small">Operador</p>
                <strong>{{ spcData.operador.nome || spcData.operador.codigo }}</strong>
              </div>
            </div>
          </div>
        </div>

        <!-- ===== Dados do consumidor ===== -->
        <div class="card mb-3 border-secondary">
          <div class="card-header bg-secondary text-white py-1">
            <i class="bx bx-user me-1"></i> Dados do Consumidor
          </div>
          <div class="card-body py-2">
            <div class="row">
              <div class="col-md-6">
                <span class="text-muted small">Razão Social / Nome</span><br>
                <strong>{{ spcData.consumidor.razao_social || spcData.consumidor.nome }}</strong>
              </div>
              <div class="col-md-3">
                <span class="text-muted small">Nome Comercial / Fantasia</span><br>
                <strong>{{ spcData.consumidor.nome_comercial || '—' }}</strong>
              </div>
              <div class="col-md-3">
                <span class="text-muted small">{{ spcData.consumidor.tipo === 'PJ' ? 'CNPJ' : 'CPF' }}</span><br>
                <strong>{{ spcData.consumidor.documento }}</strong>
              </div>
            </div>
          </div>
        </div>

        <!-- ===== Cards de resumo ===== -->
        <div class="row g-3 mb-3">
          <!-- SPC -->
          <div class="col-md-4">
            <div :class="['card', 'h-100', parseInt(spcData.spc.resumo.quantidade_total) > 0 ? 'border-danger' : 'border-success']">
              <div :class="['card-header', 'py-1', 'fw-bold', parseInt(spcData.spc.resumo.quantidade_total) > 0 ? 'bg-danger text-white' : 'bg-success text-white']">
                <i class="bx bx-list-ul me-1"></i> Ocorrências SPC
              </div>
              <div class="card-body text-center">
                <h2 class="mb-0">{{ spcData.spc.resumo.quantidade_total }}</h2>
                <p class="text-muted small mb-0">registros</p>
                <template v-if="parseInt(spcData.spc.resumo.quantidade_total) > 0">
                  <hr class="my-1">
                  <p class="mb-0 small">Total: <strong>R$ {{ parseFloat(spcData.spc.resumo.valor_total || 0).toLocaleString('pt-BR', {minimumFractionDigits:2}) }}</strong></p>
                  <p class="mb-0 small text-muted">Última: {{ spcData.spc.resumo.data_ultima_ocorrencia ? spcData.spc.resumo.data_ultima_ocorrencia.substring(0,10).split('-').reverse().join('/') : '—' }}</p>
                </template>
              </div>
            </div>
          </div>
          <!-- Cheque -->
          <div class="col-md-4">
            <div :class="['card', 'h-100', parseInt(spcData.cheque.resumo.quantidade_total) > 0 ? 'border-warning' : 'border-success']">
              <div :class="['card-header', 'py-1', 'fw-bold', parseInt(spcData.cheque.resumo.quantidade_total) > 0 ? 'bg-warning' : 'bg-success text-white']">
                <i class="bx bx-credit-card me-1"></i> Cheques s/ Fundo
              </div>
              <div class="card-body text-center">
                <h2 class="mb-0">{{ spcData.cheque.resumo.quantidade_total }}</h2>
                <p class="text-muted small mb-0">registros</p>
              </div>
            </div>
          </div>
          <!-- Protesto -->
          <div class="col-md-4">
            <div :class="['card', 'h-100', parseInt(spcData.protesto.resumo.quantidade_total) > 0 ? 'border-danger' : 'border-success']">
              <div :class="['card-header', 'py-1', 'fw-bold', parseInt(spcData.protesto.resumo.quantidade_total) > 0 ? 'bg-danger text-white' : 'bg-success text-white']">
                <i class="bx bx-file me-1"></i> Protestos
              </div>
              <div class="card-body text-center">
                <h2 class="mb-0">{{ spcData.protesto.resumo.quantidade_total }}</h2>
                <p class="text-muted small mb-0">registros</p>
                <template v-if="parseInt(spcData.protesto.resumo.quantidade_total) > 0">
                  <hr class="my-1">
                  <p class="mb-0 small">Total: <strong>R$ {{ parseFloat(spcData.protesto.resumo.valor_total || 0).toLocaleString('pt-BR', {minimumFractionDigits:2}) }}</strong></p>
                </template>
              </div>
            </div>
          </div>
        </div>

        <!-- ===== Detalhe de ocorrências SPC ===== -->
        <div v-if="spcData.spc.detalhes.length > 0" class="mb-3">
          <h6 class="fw-bold text-danger"><i class="bx bx-list-ul me-1"></i>Detalhe das Ocorrências SPC</h6>
          <div class="table-responsive">
            <table class="table table-sm table-bordered table-hover">
              <thead class="table-danger">
                <tr>
                  <th>Inclusão</th>
                  <th>Vencimento</th>
                  <th>Entidade</th>
                  <th>Contrato</th>
                  <th>Devedor / Fiador</th>
                  <th>Valor</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(d, i) in spcData.spc.detalhes" :key="'spc-'+i">
                  <td>{{ d.data_inclusao ? d.data_inclusao.substring(0,10).split('-').reverse().join('/') : '—' }}</td>
                  <td>{{ d.data_vencimento ? d.data_vencimento.substring(0,10).split('-').reverse().join('/') : '—' }}</td>
                  <td>{{ d.nome_entidade }}</td>
                  <td>{{ d.contrato }}</td>
                  <td>{{ d.comprador_fiador }}</td>
                  <td class="text-end">{{ d.valor ? 'R$ ' + parseFloat(d.valor).toLocaleString('pt-BR', {minimumFractionDigits:2}) : '—' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- ===== Detalhe de protestos ===== -->
        <div v-if="spcData.protesto.detalhes.length > 0" class="mb-3">
          <h6 class="fw-bold text-danger"><i class="bx bx-file me-1"></i>Detalhe dos Protestos</h6>
          <div class="table-responsive">
            <table class="table table-sm table-bordered table-hover">
              <thead class="table-danger">
                <tr>
                  <th>Data Protesto</th>
                  <th>Valor</th>
                  <th>Cartório</th>
                  <th>Cidade / UF</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(d, i) in spcData.protesto.detalhes" :key="'prot-'+i">
                  <td>{{ d.data_protesto ? d.data_protesto.substring(0,10).split('-').reverse().join('/') : '—' }}</td>
                  <td class="text-end">R$ {{ parseFloat(d.valor || 0).toLocaleString('pt-BR', {minimumFractionDigits:2}) }}</td>
                  <td>{{ d.cartorio }}</td>
                  <td>{{ d.cidade }} / {{ d.estado }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Botão fechar -->
        <div class="text-end">
          <b-button variant="secondary" @click="showModalConsSPC = false">
            <i class="bx bx-x me-1"></i> Fechar
          </b-button>
        </div>

      </div>

    </b-modal>


    <b-modal size="lg" title="Criar novo registro de token" v-model="showFormToken" centered hide-footer>
      <div class="row" id="div-principal">
        <div class="row" id="div-card">
          <div class="card-body" id="div-car-body">

            <form class="needs-validation">
              <div class="row">


                <div class="col-sm-6">
                  <div class="mb-3">
                    <label for="hub">Hub</label>
                    <select id="hub" v-model="pessoaTokenData.hub" class="form-control"
                            :class="{'is-invalid': submittedToken && !pessoaTokenData.hub}">

                      <!-- 2 Listas, atualizar as duas            -->

                      <option value="ACX">Acerta Express</option>
                      <option value="AMAZON">Amazon</option>
                      <option value="ANYMARKET">Any Market</option>
                      <option value="BERTOLINI">Bertolini</option>
                      <option value="B2WNOVA">B2W Nova Api</option>
                      <option value="BLING">Bling</option>
                      <option value="BRP">Braspres</option>
                      <option value="CORREIOS">Correios</option>
                      <option value="ESLC">ESL Cloud</option>
                      <option value="FOCUSNFE">Focus NFe</option>
                      <option value="JDL">JadLog</option>
                      <option value="LEROYMER">Leroy Merlin</option>
                      <option value="LJTO">LogJato</option>
                      <option value="LOJAMEC">Loja do Mecânico</option>
                      <option value="MAGALU">Magazine Luiza</option>
                      <option value="OCO">OCOREN</option>
                      <option value="QLTY">Quality</option>
                      <option value="PATR">Patrus</option>
                      <option value="RDV">Rodonavis</option>
                      <option value="RELM">Realmed</option>
                      <option value="SKYHUB">SkyHub</option>
                      <option value="SOL">Solistica</option>
                      <option value="SSW">SSW</option>
                      <option value="TRAYCORP">TrayCorp</option>
                      <option value="TRCO">Transcourier</option>
                      <option value="TRV">Translovato</option>
                      <option value="VTEX">Vtex</option>

                    </select>
                    <div v-if="submittedToken && !pessoaTokenData.hub" class="invalid-feedback">
                      <span>Campo hub obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>


                <div class="col-sm-6">
                  <div class="mb-3">
                    <label for="validade">Validade</label>
                    <input id="validade" v-model="pessoaTokenData.validade" type="number" class="form-control"
                           placeholder="Validade" :class="{'is-invalid': submittedToken && !pessoaTokenData.validade}" />
                    <div v-if="submittedToken && !pessoaTokenData.validade" class="invalid-feedback">
                      <span>Campo validade obrigatório, favor preencher.</span>
                    </div>

                  </div>
                </div>


                <div class="col-sm-6">
                  <div class="mb-3">
                    <label for="login">Login</label>
                    <input id="login" v-model="pessoaTokenData.login" type="text" class="form-control"
                           placeholder="Login" />

                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="mb-3">
                    <label for="senha">Senha</label>
                    <input id="senha" v-model="pessoaTokenData.senha" type="text" class="form-control"
                           placeholder="Senha" />

                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="mb-3">
                    <label for="token">Token</label>
                    <input id="token" v-model="pessoaTokenData.token" type="text" class="form-control"
                           placeholder="Token" />

                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="mb-3">
                    <label for="cliid">Client ID</label>
                    <input id="cliid" v-model="pessoaTokenData.cliid" type="text" class="form-control"
                           placeholder="Client ID" />

                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="mb-3">
                    <label for="clisecret">Client Secret</label>
                    <input id="clisecret" v-model="pessoaTokenData.clisecret" type="text" class="form-control"
                           placeholder="Client Secret" />

                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="mb-3">
                    <label for="actoken">Access Token</label>
                    <textarea id="actoken" v-model="pessoaTokenData.actoken" type="text" rows="2" :disabled="true"
                              class="form-control" placeholder="Access Token" />

                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="mb-3">
                    <label for="rftoken">Refresh Token</label>
                    <textarea id="rftoken" v-model="pessoaTokenData.rftoken" type="text" rows="2" :disabled="true"
                              class="form-control" placeholder="Refresh Token" />

                  </div>
                </div>

              </div>

              <div class="row">

                <div class="text-end mt-5">
                  <b-button variant="light" @click="showFormToken = false">
                    <i class="bx bx-block font-size-16 align-middle me-2"></i>
                    Cancelar
                  </b-button>
                  <b-button type="button" variant="success" class="ms-1" @click="confToken">
                    <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                    Confirmar
                  </b-button>
                </div>

              </div>

            </form>

          </div>
        </div>
      </div>
    </b-modal>



    <b-modal size="lg"
             :title="pessoaMailCotaData.id > 0 ? `Editar e-mail solicitação coleta (${pessoaMailCotaData.id})` : 'Criar novo e-mail solicitação coleta'"
             v-model="showFormMailCota" centered hide-footer>
      <div class="row" id="div-principal">
        <div class="row" id="div-card">
          <div class="card-body" id="div-car-body">

            <form class="needs-validation">
              <div class="row">

                <div class="col-sm-6">
                  <div class="mb-3">
                    <label for="nomemailcota">Nome</label>
                    <input id="nomemailcota" v-model="pessoaMailCotaData.nome" type="text" class="form-control"
                           placeholder="Nome" :class="{'is-invalid': submittedMailCota && !pessoaMailCotaData.nome}" />
                    <div v-if="submittedMailCota && !pessoaMailCotaData.nome" class="invalid-feedback">
                      <span>Campo nome obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>


                <div class="col-sm-6">
                  <div class="mb-3">
                    <label for="emailmailcota">E-mail</label>
                    <input id="emailmailcota" v-model="pessoaMailCotaData.email" type="email" class="form-control"
                           placeholder="E-mail" @blur="validateEmail"
                           :class="{'is-invalid': submittedMailCota && (!pessoaMailCotaData.email || !validEmail(pessoaMailCotaData.email)) }" />
                    <div
                        v-if="submittedMailCota && (!pessoaMailCotaData.email || !validEmail(pessoaMailCotaData.email))"
                        class="invalid-feedback">
                      <span>Campo e-mail obrigatório e válido, favor corrigir.</span>
                    </div>
                  </div>
                </div>


              </div>

              <div class="row">

                <div class="text-end mt-5">
                  <b-button variant="light" @click="showFormMailCota = false">
                    <i class="bx bx-block font-size-16 align-middle me-2"></i>
                    Cancelar
                  </b-button>
                  <b-button type="button" variant="success" class="ms-1" @click="confMailCota">
                    <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                    Confirmar
                  </b-button>
                </div>

              </div>

            </form>

          </div>
        </div>
      </div>
    </b-modal>


    <b-modal size="lg"
             :title="pessoaEmailData.id > 0 ? `Editar e-mail redirecionamento de xml (${pessoaEmailData.id})` : 'Criar novo e-mail redirecionamento de xml'"
             v-model="showFormMail" centered hide-footer>
      <div class="row" id="div-principal">
        <div class="row" id="div-card">
          <div class="card-body" id="div-car-body">

            <form class="needs-validation">
              <div class="row">

                <div class="col-sm-6">
                  <div class="mb-3">
                    <label for="nomemail">Nome</label>
                    <input id="nomemail" v-model="pessoaEmailData.nome" type="text" class="form-control"
                           placeholder="Nome" :class="{ 'is-invalid': submittedMail && !pessoaEmailData.nome }" />
                    <div v-if="submittedMail && !pessoaEmailData.nome" class="invalid-feedback">
                      <span>Campo nome obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>


                <div class="col-sm-6">
                  <div class="mb-3">
                    <label for="emailmail">E-mail</label>
                    <input id="emailmail" v-model="pessoaEmailData.email" type="email" class="form-control"
                           placeholder="E-mail" @blur="validateEmail"
                           :class="{ 'is-invalid': submittedMail && (!pessoaEmailData.email || !validEmail(pessoaEmailData.email)) }" />
                    <div v-if="submittedMail && (!pessoaEmailData.email || !validEmail(pessoaEmailData.email))"
                         class="invalid-feedback">
                      <span>Campo e-mail obrigatório e válido, favor corrigir.</span>
                    </div>
                  </div>
                </div>


              </div>

              <div class="row">

                <div class="text-end mt-5">
                  <b-button variant="light" @click="showFormMail = false">
                    <i class="bx bx-block font-size-16 align-middle me-2"></i>
                    Cancelar
                  </b-button>
                  <b-button type="button" variant="success" class="ms-1" @click="confMail">
                    <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                    Confirmar
                  </b-button>
                </div>

              </div>

            </form>

          </div>
        </div>
      </div>
    </b-modal>

    <b-modal size="xl" title="Criar Nova Fórmula Cálculo de Frete" v-model="showFormFormulaFrete" centered hide-footer>
      <div class="row" id="div-principal">
        <div class="row" id="div-card">
          <div class="card-body" id="div-car-body">

            <form class="needs-validation">

              <div class="row">

                <div class="col-sm-6">
                  <div class="mb-3">
                    <label for="descricao">Descrição</label>
                    <input id="descricao" v-model="pessoaFormulaData.descricao" type="text" class="form-control"
                           placeholder="Descrição"
                           :class="{'is-invalid': submmitedFormula && !pessoaFormulaData.descricao}" />
                    <div v-if="submmitedFormula && !pessoaFormulaData.descricao" class="invalid-feedback">
                      <span>Campo Fórmula obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>


                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="statusformula">Status</label>
                    <select id="statusformula" v-model="pessoaFormulaData.status" class="form-control"
                            :class="{'is-invalid': submmitedFormula && !pessoaFormulaData.status}">
                      <option value="A">Ativo</option>
                      <option value="I">Inativo</option>
                    </select>
                    <div v-if="submmitedFormula && !pessoaFormulaData.status" class="invalid-feedback">
                      <span>Campo status obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>

              </div>

              <div class="row">


                <div class="col-lg-12">
                  <div class="mb-3">
                    <label for="formula">Fórmula</label>
                    <div class="position-relative">
                      <textarea id="formula" v-model="pessoaFormulaData.formula" type="text" rows="5"
                                class="form-control" placeholder="Inserir variáveis de para cálculo"
                                :class="{'is-invalid': submmitedFormula && !pessoaFormulaData.formula }" />
                      <div v-if="submmitedFormula && !pessoaFormulaData.formula" class="invalid-feedback">
                        <span>Campo Fórmula obrigatório, favor preencher.</span>
                      </div>
                    </div>
                  </div>
                </div>



              </div>



              <div class="row mb-2">


                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a v-b-toggle.accordion-1 class="text-dark" href="javascript: void(0);">+ Variáveis Disponíveis</a>
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-1" accordion="my-accordion-1" role="tabpanel">
                  <b-card-body>


                    <div class="btn-group btn-group-sm mb-2" role="group" aria-label="Basic example"
                         style="min-width: 100%;">
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' fxpeso'"
                              class="btn btn-outline-danger">
                        FxPeso
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' fxvalor'"
                              class="btn btn-outline-danger">
                        FxValor
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' vlricms'"
                              class="btn btn-outline-warning">
                        VlrICMS
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' pesoexcedvlr'"
                              class="btn btn-outline-warning">
                        VlrPesoExced
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' pesoadicvlr'"
                              class="btn btn-outline-warning">
                        VlrPesoAdic
                      </button>
                    </div>


                    <div class="btn-group btn-group-sm mb-2" role="group" aria-label="Basic example"
                         style="min-width: 100%;">
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' fretevlrpercnota'"
                              class="btn btn-outline-secondary">
                        PercFreteNF
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' fretevlrmin'"
                              class="btn btn-outline-secondary">
                        FreteVlrMin
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' grispercnota'"
                              class="btn btn-outline-secondary">
                        GRISFreteNF
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' grisvlrmin'"
                              class="btn btn-outline-secondary">
                        GRISVlrMin
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' tasvlrfixo'"
                              class="btn btn-outline-secondary">
                        TASVlrFixo
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' despachovlrfixo'"
                              class="btn btn-outline-secondary">
                        DespacVlrMin
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' admrodopercfrete'"
                              class="btn btn-outline-secondary">
                        AdmRodoPerc
                      </button>

                    </div>

                    <div class="btn-group btn-group-sm mb-2" role="group" aria-label="Basic example"
                         style="min-width: 100%;">
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' tsbpercnota'"
                              class="btn btn-outline-secondary">
                        TSBPercNF
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' tsbvlrmin'"
                              class="btn btn-outline-secondary">
                        TSBVlrMin
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' tsbvlrmax'"
                              class="btn btn-outline-secondary">
                        TSBVlrMax
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' tsbvlrfixo'"
                              class="btn btn-outline-secondary">
                        TSBVlrFixo
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' suframavlrfixo'"
                              class="btn btn-outline-secondary">
                        SufrVlrFixo
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' segfluvperc'"
                              class="btn btn-outline-secondary">
                        SegFluvPercNF
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' segfluvvlrmin'"
                              class="btn btn-outline-secondary">
                        SegFluvVlrMin
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' segfluvvlrmax'"
                              class="btn btn-outline-secondary">
                        SegFluvVlrMax
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' segfluvvlrfixo'"
                              class="btn btn-outline-secondary">
                        SegFluvVlrFixo
                      </button>
                    </div>



                    <div class="btn-group btn-group-sm mb-2" role="group" aria-label="Basic example"
                         style="min-width: 100%;">
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' pedagiovlrfixo'"
                              class="btn btn-outline-secondary">
                        PedagVlrFixo
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' pedagiofrac100kg'"
                              class="btn btn-outline-secondary">
                        PedagFrac100kg
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' pedagiovlrkg'"
                              class="btn btn-outline-secondary">
                        PedagVlrKg
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' coletavlrfixo'"
                              class="btn btn-outline-secondary">
                        ColetaVlrFixo
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' coletavlrkg'"
                              class="btn btn-outline-secondary">
                        ColetaVlrKg
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' entregavlrfixo'"
                              class="btn btn-outline-secondary">
                        EntrVlrFixo
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' entregavlrkg'"
                              class="btn btn-outline-secondary">
                        EntrVlrKg
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' seccatvlrfixo'"
                              class="btn btn-outline-secondary">
                        SeccatVlrFixo
                      </button>
                    </div>

                    <div class="btn-group btn-group-sm mb-2" role="group" aria-label="Basic example"
                         style="min-width: 100%;">
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' ademeperc'"
                              class="btn btn-outline-secondary">
                        AdemePercNF
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' ademevlrmin'"
                              class="btn btn-outline-secondary">
                        AdemeVlrMin
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' ademevlrmax'"
                              class="btn btn-outline-secondary">
                        AdemeVlrMax
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' ademevlrfixo'"
                              class="btn btn-outline-secondary">
                        AdemeVlrFixo
                      </button>
                    </div>

                    <div class="btn-group btn-group-sm mb-2" role="group" aria-label="Basic example"
                         style="min-width: 100%;">
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' emexperc'"
                              class="btn btn-outline-secondary">
                        EmexPercNF
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' emexvlrmin'"
                              class="btn btn-outline-secondary">
                        EmexVlrMin
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' emexvlrmax'"
                              class="btn btn-outline-secondary">
                        EmexVlrMax
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' emexvlrfixo'"
                              class="btn btn-outline-secondary">
                        EmexVlrFixo
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' emexfrac100kg'"
                              class="btn btn-outline-secondary">
                        EmexFrac100kg
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' emexvlrkg'"
                              class="btn btn-outline-secondary">
                        EmexVlrKg
                      </button>
                    </div>

                    <div class="btn-group btn-group-sm mb-2" role="group" aria-label="Basic example"
                         style="min-width: 100%;">
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' taxaadic1vlrkg'"
                              class="btn btn-outline-secondary">
                        Taxa1VlrKg
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' taxaadic1vlrmin'"
                              class="btn btn-outline-secondary">
                        Taxa1VlrMin
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' taxaadic1vlrmax'"
                              class="btn btn-outline-secondary">
                        Taxa1VlrMax
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' taxaadic2vlrkg'"
                              class="btn btn-outline-secondary">
                        Taxa2VlrKg
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' taxaadic2vlrmin'"
                              class="btn btn-outline-secondary">
                        Taxa2VlrMin
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' taxaadic2vlrmax'"
                              class="btn btn-outline-secondary">
                        Taxa2VlrMax
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' taxaadic3vlrkg'"
                              class="btn btn-outline-secondary">
                        Taxa3VlrKg
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' taxaadic3vlrmin'"
                              class="btn btn-outline-secondary">
                        Taxa3VlrMin
                      </button>
                      <button type="button"
                              @click="this.pessoaFormulaData.formula = this.pessoaFormulaData.formula + ' taxaadic3vlrmax'"
                              class="btn btn-outline-secondary">
                        Taxa3VlrMax
                      </button>

                    </div>

                  </b-card-body>

                </b-collapse>

              </div>





              <b-alert v-for="(erro, i) in errosValidFormula" :key="`alerta-${i}`" show dismissible variant="danger">
                <i class="mdi mdi-alert me-2"></i>{{ erro }}
              </b-alert>



              <div class="row" v-if="loadingCotarFrete">
                <div class="col-12 text-center">
                  <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
                  </b-spinner>
                  <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
                  </b-spinner>
                  <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
                  </b-spinner>
                </div>
              </div>


              <div class="table-responsive" v-if="cotaFreteInternoListData">
                <table class="table table-centered table-nowrap">
                  <thead>
                  <tr>
                    <th scope="col">Ações</th>
                    <th scope="col">Transportador</th>
                    <th scope="col" class="text-end">Prazo</th>
                    <th scope="col" class="text-end">Frete R$</th>
                    <th scope="col" class="text-end">Expressão</th>
                    <th scope="col" class="text-end">Variáveis</th>

                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="data in cotaFreteInternoListData" :key="data.id">
                    <td>

                      <a href="javascript:void(0);" v-b-tooltip.hover class="action-icon text-info mx-2"
                         title="Escolher Transportadora">
                        <i class="mdi mdi-check-outline font-size-18"></i>
                      </a>


                    </td>

                    <td>
                      {{ data.transp_id }}
                    </td>

                    <td class="text-end">
                      <i class="bx bxs-calendar font-size-18 bx-fade-right text-info" v-if="data.menorprazo"></i>
                      {{ formatInteger(data.prazo) }}
                    </td>

                    <td class="text-end">
                      {{ formatDecimal(data.valorfrete) }}
                    </td>


                    <td class="text-end text-wrap">
                      <i class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success"
                         v-if="data.menorvalor"></i>
                      {{ data.expressao }}
                    </td>

                    <td class="text-end text-wrap">
                      <i class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success"
                         v-if="data.menorvalor"></i>
                      {{ data.variaveis }}
                    </td>

                  </tr>

                  </tbody>
                </table>
              </div>



              <div class="row">

                <div class="text-end mt-5">
                  <b-button variant="light" @click="showFormFormulaFrete = false">
                    <i class="bx bx-block font-size-16 align-middle me-2"></i>
                    Cancelar
                  </b-button>


                  <b-button type="button" variant="warning" class="ms-1" @click="validarFormula">
                    <i class="bx bx-check font-size-16 align-middle me-2"></i>
                    Validar
                  </b-button>

                  <b-button type="button" variant="success" class="ms-1" @click="confFormula">
                    <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                    Confirmar
                  </b-button>
                </div>

              </div>

            </form>

          </div>
        </div>
      </div>
    </b-modal>



    <b-modal size="xl"
             :title="pessoaFreteAdicData.id > 0 ? `Editar Taxa Base de Frete (${pessoaFreteAdicData.id})` : 'Criar Nova Taxa Base de Frete'"
             v-model="showFormFreteAdic" centered hide-footer>
      <div class="row" id="div-principal">
        <div class="row" id="div-card">
          <div class="card-body" id="div-car-body">

            <form class="needs-validation">

              <div class="row mb-2">

                <div class="col-sm-6">
                  <div class="mb-3">
                    <span class="font-size-13">Base de Cotação</span>


                    <!--  @select="escolheuTabPreco"
                    -->
                    <multiselect id="inputBaseCotacao" @search-change="pesqFreteCotaBase"
                                 v-model="pessoaFreteAdicData.fretecotabase_id" placeholder="pesquisar base de cotação..."
                                 :options="dtListPesqFreteAdicBase" :searchable="true" label="transpnome" track-by="transpnome"
                                 value-prop="id" class="mt-2">
                      <template #option="slotProps">
                        <div style="min-width: 10%;">
                          <span class="text-info">
                            {{ slotProps.option.id }}
                          </span>
                        </div>
                        <div style="min-width: 30%;">
                          <span>
                            {{ slotProps.option.descricao }}
                          </span>
                        </div>
                        <div style="min-width: 60%;">
                          <span>
                            {{ slotProps.option.transpnome }}
                          </span>
                        </div>
                      </template>
                    </multiselect>
                  </div>
                </div>


                <div class="col-sm-6">
                  <div class="mb-3">
                    <label for="obs">Observação</label>
                    <textarea id="obs" rows="1" v-model="pessoaFreteAdicData.obs" type="text" class="form-control"
                              placeholder="Observação" />
                  </div>
                </div>



              </div>

              <div class="row mb-2">

                <div class="col-sm-3">
                  <div class="mb-3">
                    <label for="perc">Percentual</label>
                    <input id="perc" v-model="pessoaFreteAdicData.perc" type="number" class="form-control text-end"
                           placeholder="Percentual" />
                  </div>
                </div>

                <div class="col-sm-3">
                  <div class="mb-3">
                    <label for="vlrmin">Valor Mínimo</label>
                    <input id="vlrmin" v-model="pessoaFreteAdicData.vlrmin" type="number" class="form-control text-end"
                           placeholder="Valor Mínimo" />
                  </div>
                </div>

                <div class="col-sm-3">
                  <div class="mb-3">
                    <label for="vlrmax">Valor Máximo</label>
                    <input id="vlrmax" v-model="pessoaFreteAdicData.vlrmax" type="number" class="form-control text-end"
                           placeholder="Valor Máximo" />
                  </div>
                </div>

                <div class="col-sm-3">
                  <div class="mb-3">
                    <label for="vlrfixo">Valor Fixo</label>
                    <input id="vlrfixo" v-model="pessoaFreteAdicData.vlrfixo" type="number"
                           class="form-control text-end" placeholder="Valor Fixo" />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="text-end mt-5">
                  <b-button variant="light" @click="showFormFreteAdic = false">
                    <i class="bx bx-block font-size-16 align-middle me-2"></i>
                    Cancelar
                  </b-button>

                  <b-button type="button" variant="success" class="ms-1" @click="confFreteAdic">
                    <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                    Confirmar
                  </b-button>
                </div>

              </div>

            </form>

          </div>
        </div>
      </div>
    </b-modal>



    <b-modal :title="'Detalhes Pessoa (' + emprElkData.id + ')'"
             size="xl"
             v-model="showModalDadosPublicos" centered hide-footer>

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">

            <b-card no-body class="mb-1 shadow-none">
              <b-card-header header-tag="header" role="tab">
                <h6 class="m-0">
                  <a v-b-toggle.accordion-2
                     class="text-dark"
                     href="javascript: void(0);">
                    Dados Principais</a>
                </h6>
              </b-card-header>
              <b-collapse id="accordion-2" v-model="visibleAcord1DaPub" accordion="my-accordion-2" role="tabpanel">

                <Loader v-if="loadingEmprDadPub" style="min-height: 200px;">
                </Loader>

                <b-card-body v-if="!loadingEmprDadPub">

                  <div class="row">

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="cnpj">CNPJ</label>
                        <input
                            id="cnpj"
                            v-model="emprElkData.cnpj"
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="CNPJ"/>
                      </div>
                    </div>

                    <div class="col-md-8">
                      <div class="mb-3">
                        <label for="nome">Nome</label>
                        <input
                            id="nome"
                            v-model="emprElkData.nome"
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="Nome"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="capital">Capital</label>
                        <input
                            id="capital"
                            v-model="emprElkData.capital"
                            type="number"
                            :disabled="true"
                            class="form-control text-end"
                            placeholder="Capital"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="matriz_filial">Matriz / Filial</label>
                        <input
                            id="matriz_filial"
                            v-model="emprElkData.matriz_filial"
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="Matriz / Filial"/>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="fantasia">Nome Fantasia</label>
                        <input
                            id="fantasia"
                            v-model="emprElkData.fantasia"
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="Nome Fantasia"/>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="endereco">Endereço</label>
                        <input
                            id="endereco"
                            v-model="emprElkData.endereco"
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="Endereço"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="numero">Número</label>
                        <input
                            id="numero"
                            v-model="emprElkData.numero"
                            type="text"
                            :disabled="true"
                            class="form-control text-end"
                            placeholder="Número"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="complemento">Complemento</label>
                        <input
                            id="complemento"
                            v-model="emprElkData.complemento"
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="Complemento"/>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="bairro">Bairro</label>
                        <input
                            id="bairro"
                            v-model="emprElkData.bairro"
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="Bairro"/>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="cidade">Cidade</label>
                        <input
                            id="cidade"
                            v-model="emprElkData.cidade"
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="Cidade"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="cep">CEP</label>
                        <input
                            id="cep"
                            v-model="emprElkData.cep"
                            type="text"
                            :disabled="true"
                            class="form-control text-end"
                            placeholder="CEP"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="estado">Estado</label>
                        <input
                            id="estado"
                            v-model="emprElkData.estado"
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="Estado"/>
                      </div>
                    </div>

                    <div class="col-md-10">
                      <div class="mb-3">
                        <label for="cnae">CNAE's</label>
                        <input
                            id="cnae"
                            v-model="emprElkData.cnae"
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="CNAE's"/>
                      </div>
                    </div>

                  </div>

                  <div class="row">

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="natureza_cod">Código Natureza</label>
                        <input
                            id="natureza_cod"
                            v-model="emprElkData.natureza_cod"
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="Código Natureza"/>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="natureza">Natureza</label>
                        <input
                            id="natureza"
                            v-model="emprElkData.natureza"
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="Natureza"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="motivo_cod">Código Motivo</label>
                        <input
                            id="motivo_cod"
                            v-model="emprElkData.motivo_cod"
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="Código Motivo"/>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="motivo">Motivo</label>
                        <input
                            id="motivo"
                            v-model="emprElkData.motivo"
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="Motivo"/>
                      </div>
                    </div>


                  </div>

                  <div class="row">

                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="email">E-mail</label>
                        <input
                            id="email"
                            v-model="emprElkData.email"
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="E-mail"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="telefone_1">Telefone 1</label>
                        <input
                            id="telefone_1"
                            v-model="emprElkData.telefone_1"
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="Telefone 1"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="telefone_2">Telefone 2</label>
                        <input
                            id="telefone_2"
                            v-model="emprElkData.telefone_2"
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="Telefone 2"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="telefone_3">Telefone 3</label>
                        <input
                            id="telefone_3"
                            v-model="emprElkData.telefone_3"
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="Telefone 3"/>
                      </div>
                    </div>

                  </div>
                  <hr>
                  <div class="row mt-2">

                    <table class="table align-middle table-nowrap" >
                      <thead class="table-light">
                      <tr>

                        <th class="align-middle">Nome</th>
                        <th class="align-middle">CPF/CNPJ</th>
                        <th class="align-middle">Entrada</th>
                        <th class="align-middle">Fx.Etária</th>
                        <th class="align-middle">Qualificação</th>
                        <th class="align-middle">Rep.Legal</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="data in emprElkDataSociosData" :key="data.nome">
                        <td>{{ data.nome }} </td>
                        <td>{{ data.cnpj }} </td>
                        <td>{{ data.entrada }} </td>
                        <td>{{ data.faixaEtaria }} </td>
                        <td>{{ data.qualif }} </td>
                        <td>{{ data.repLegal }} </td>

                      </tr>
                      </tbody>
                    </table>

                  </div>

                </b-card-body>
              </b-collapse>
            </b-card>



            <b-card no-body class="mb-1 shadow-none">
              <b-card-header header-tag="header" role="tab">
                <h6 class="m-0">
                  <a v-b-toggle.accordion-3
                     class="text-dark"
                     href="javascript: void(0);">
                    Vizinhos</a>
                </h6>
              </b-card-header>
              <b-collapse id="accordion-3" v-model="visibleAcord2DaPub" accordion="my-accordion-3" role="tabpanel">

                <Loader v-if="loadingEmprsDadPub" style="min-height: 200px;">
                </Loader>

                <b-card-body v-if="!loadingEmprsDadPub">

                  <ejs-grid :dataSource="empresasElkData"
                            ref="dataGridEmprsElk"
                            :allowFiltering="true"
                            :allowPdfExport="true"
                            :allowExcelExport="true"
                            :allowPaging="true"
                            :enableColumnVirtualization="true"
                            :recordDoubleClick="recordDoubleClick"
                            :dataBound="dataBound"
                            :pageSettings="{ pageSizes: ['30', '100', '200', '500', 'All'], pageSize: 30 }"
                            :selectionSettings="{ mode: 'Row', type: 'Multiple' }"
                            :scrollSettings="{enableColumnScrolling: true, enableRowScrolling: true}">
                    <e-columns>
                      <e-column headerText="MOVIMENTO" :columns="colsEmprs" textAlign="Center"></e-column>
                    </e-columns>

                    <template v-slot:templtcapital="{data}">
                      <div> {{formatDecimal(data.capital)}} </div>
                    </template>

                  </ejs-grid>


                </b-card-body>
              </b-collapse>
            </b-card>



          </div>
        </div>
      </div>



      <div class="text-end mt-5">

        <b-button variant="outline-info" class="me-2" @click="consVizinhos" v-if="emprElkData && emprElkData.id">
          <i class="bx bx-adjust font-size-16 align-middle me-2"></i>
          Vizinhos
        </b-button>

        <b-button variant="light" @click="showModalDadosPublicos = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Fechar
        </b-button>

      </div>
    </b-modal>



    <b-modal size="xl"
             :title="pessoaVeiCoDedData.id > 0 ? `Editar Veículo Cotação Dedicada (${pessoaVeiCoDedData.id})` : 'Criar Veículo Cotação Dedicada'"
             v-model="showFormVeiCotDed" centered hide-footer>
      <div class="row" id="div-principal">
        <div class="row" id="div-card">
          <div class="card-body" id="div-car-body">

            <form class="needs-validation">

              <h4 class="card-title">Dados Principais</h4>
              <hr>

              <div class="row">

                <div class="col-sm-4">
                  <div class="mb-3">
                    <label for="descricaoveiccotded">Descrição</label>
                    <input id="descricaoveiccotded"
                           v-model="pessoaVeiCoDedData.descricao"
                           type="text"
                           class="form-control"
                           :class="{ 'is-invalid': submmitedVeiCoDedData && !pessoaVeiCoDedData.descricao }"
                           placeholder="Descrição" />
                    <div v-if="submmitedVeiCoDedData && !pessoaVeiCoDedData.descricao" class="invalid-feedback">
                      <span>Campo descrição obrigatório e válido, favor corrigir.</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-2">
                  <div class="mb-3">
                    <label for="placaveiccotded">Placa</label>
                    <input id="placaveiccotded"
                           v-model="pessoaVeiCoDedData.placa"
                           type="text"
                           class="form-control"
                           placeholder="Placa" />
                  </div>
                </div>

                <div class="col-sm-3">
                  <div class="mb-3">
                    <label for="statusveiccotded">Status</label>
                    <select
                        id="statusveiccotded"
                        v-model="pessoaVeiCoDedData.status"
                        class="form-control"
                        :class="{'is-invalid': submmitedVeiCoDedData && !pessoaVeiCoDedData.status}">
                      <option value="A">Ativo (A)</option>
                      <option value="I">Inativo (I)</option>
                    </select>
                    <div v-if="submmitedVeiCoDedData && !pessoaVeiCoDedData.status" class="invalid-feedback">
                      <span>Campo status obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-3">
                  <div class="mb-3">
                    <label for="pesomaxcotded">Peso Máximo</label>
                    <input id="pesomaxcotded"
                           v-model="pessoaVeiCoDedData.pesomax"
                           type="number"
                           class="form-control"
                           :class="{ 'is-invalid': submmitedVeiCoDedData && !pessoaVeiCoDedData.pesomax }"
                           placeholder="Peso Máximo" />
                    <div v-if="submmitedVeiCoDedData && !pessoaVeiCoDedData.pesomax" class="invalid-feedback">
                      <span>Campo peso máximo obrigatório e válido, favor corrigir.</span>
                    </div>
                  </div>
                </div>

              </div>


              <div class="row">

                <div class="col-sm-4">
                  <div class="mb-3">
                    <label for="tipocalccotded">Tipo Cálculo</label>
                    <select
                        id="tipocalccotded"
                        v-model="pessoaVeiCoDedData.tipocalc"
                        class="form-control"
                        :class="{'is-invalid': submmitedVeiCoDedData && !pessoaVeiCoDedData.tipocalc}">
                      <option value="INT">Interno (INT)</option>
                      <option value="QLP">Qualp (QLP)</option>
                    </select>
                    <div v-if="submmitedVeiCoDedData && !pessoaVeiCoDedData.tipocalc" class="invalid-feedback">
                      <span>Campo tipo cálculo obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>



                <div class="col-sm-5">
                  <div class="mb-3">
                    <label for="tipoveiccotded">Tipo Veículo</label>
                    <select
                        id="tipoveiccotded"
                        v-model="pessoaVeiCoDedData.tipoveic"
                        @change="altTipoVeic"
                        class="form-control"
                        :class="{'is-invalid': submmitedVeiCoDedData && !pessoaVeiCoDedData.tipoveic}">
                      <option value="CAP">Carro de Passeio (Hatch/Sedan)</option>
                      <option value="FIV">Fiorino / Van</option>
                      <option value="MOT">Moto</option>
                      <option value="VUC">VUC (Veículo Urbano de Carga - 3/4)</option>
                      <option value="CT2">Toco (2 eixos)</option>
                      <option value="CT3">Toco (3 eixos)</option>
                      <option value="CAS">Carreta Simples</option>
                      <option value="CAL">Carreta LS (3 eixos)</option>
                      <option value="BIT">Bitrem (7 eixos)</option>
                    </select>
                    <div v-if="submmitedVeiCoDedData && !pessoaVeiCoDedData.tipoveic" class="invalid-feedback">
                      <span>Campo tipo veículo obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>


              </div>



              <h4 class="card-title">Parâmetros Calculo</h4>
              <hr>

              <div class="row mb-2">

                <div class="col-sm-2 text-end">
                  <label for="percadic">Percentagem Adicional</label>
                  <div class="position-relative">
                    <input id="percadic"
                           type="number"
                           v-model="pessoaVeiCoDedData.percadic"
                           class="form-control text-end"
                           placeholder="Percentagem Adicional"/>
                  </div>
                </div>

                <div class="col-sm-2 text-end">
                  <label for="valoradic">Valor Adicional</label>
                  <div class="position-relative">
                    <input id="valoradic"
                           type="number"
                           v-model="pessoaVeiCoDedData.valoradic"
                           class="form-control text-end"
                           placeholder="Valor Adicional"/>
                  </div>
                </div>

                <div class="col-sm-2 text-end">
                  <label for="gris">GRIS</label>
                  <div class="position-relative">
                    <input id="gris"
                           type="number"
                           v-model="pessoaVeiCoDedData.gris"
                           class="form-control text-end"
                           placeholder="GRIS"/>
                  </div>
                </div>

                <div class="col-sm-2 text-end">
                  <label for="advalorem">Ad.Valorem</label>
                  <div class="position-relative">
                    <input id="advalorem"
                           type="number"
                           v-model="pessoaVeiCoDedData.advalorem"
                           class="form-control text-end"
                           placeholder="Ad.Valorem"/>
                  </div>
                </div>

                <div class="col-sm-2 text-end">
                  <label for="icms">ICMS</label>
                  <div class="position-relative">
                    <input id="icms"
                           type="number"
                           v-model="pessoaVeiCoDedData.icms"
                           class="form-control text-end"
                           placeholder="ICMS"/>
                  </div>
                </div>

                <div class="col-sm-2 text-end">
                  <label for="valordesc">Valor por Descarga</label>
                  <div class="position-relative">
                    <input id="valordesc"
                           type="number"
                           v-model="pessoaVeiCoDedData.valordesc"
                           class="form-control text-end"
                           placeholder="Valor por Descarga"/>
                  </div>
                </div>

              </div>

              <div class="row mb-4">

                <div class="col-sm-2 text-end">
                  <label for="valorentr">Valor por Entrega</label>
                  <div class="position-relative">
                    <input id="valorentr"
                           type="number"
                           v-model="pessoaVeiCoDedData.valorentr"
                           class="form-control text-end"
                           placeholder="Valor por Entrega"/>
                  </div>
                </div>

                <div class="col-sm-2 text-end">
                  <label for="valormin">Valor Mínimo</label>
                  <div class="position-relative">
                    <input id="valormin"
                           type="number"
                           v-model="pessoaVeiCoDedData.valormin"
                           class="form-control text-end"
                           placeholder="Valor Mínimo"/>
                  </div>
                </div>

                <div class="col-sm-2 text-end">
                  <label for="valorkm">Valor KM</label>
                  <div class="position-relative">
                    <input id="valorkm"
                           type="number"
                           v-model="pessoaVeiCoDedData.valorkm"
                           :class="{ 'is-invalid': pessoaVeiCoDedData.tipocalc === 'INT' && submmitedVeiCoDedData && !pessoaVeiCoDedData.valorkm }"
                           class="form-control text-end"
                           placeholder="Valor por KM"/>
                    <div v-if="pessoaVeiCoDedData.tipocalc === 'INT' && submmitedVeiCoDedData && !pessoaVeiCoDedData.valorkm" class="invalid-feedback">
                      <span>Campo valor km obrigatório, favor corrigir.</span>
                    </div>
                  </div>
                </div>

              </div>




              <h4 class="card-title">Dados Cotação Qualp</h4>
              <hr>

              <div class="row mb-2">

                <div class="col-sm-2">
                  <div class="mb-3">
                    <label for="type_vehicle">Tipo Veículo Qualp</label>
                    <select
                        id="type_vehicle"
                        v-model="pessoaVeiCoDedData.type_vehicle"
                        class="form-control"
                        :class="{'is-invalid': submmitedVeiCoDedData && !pessoaVeiCoDedData.type_vehicle}">
                      <option value="truck">Caminhão</option>
                      <option value="car">Carro</option>
                      <option value="motorcycle">Moto</option>
                      <option value="bus">Ônibus</option>
                    </select>
                    <div v-if="submmitedVeiCoDedData && !pessoaVeiCoDedData.type_vehicle" class="invalid-feedback">
                      <span>Campo tipo veículo obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-2">
                  <div class="mb-3">
                    <label for="vehicle_axis">Eixos (Veículo)</label>
                    <select id="vehicle_axis" v-model="pessoaVeiCoDedData.vehicle_axis" class="form-control"
                            :class="{'is-invalid': submmitedVeiCoDedData && !pessoaVeiCoDedData.vehicle_axis}">
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                      <option value="8">8</option>
                      <option value="9">9</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                      <option value="13">13</option>
                      <option value="14">14</option>
                      <option value="15">15</option>
                    </select>
                    <div v-if="submmitedVeiCoDedData && !pessoaVeiCoDedData.vehicle_axis" class="invalid-feedback">
                      <span>Campo eixos veículo obrigatório, favor selecionar.</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-2">
                  <label for="top_speed">Velocidade Máxima</label>
                  <div class="position-relative">
                    <input id="top_speed"
                           type="number"
                           v-model="pessoaVeiCoDedData.top_speed"
                           class="form-control"
                           placeholder="Velocidade Máxima"/>
                  </div>
                </div>

                <div class="col-sm-2">
                  <div class="mb-3">
                    <label for="table_category">Categoria Tabela</label>
                    <select id="table_category" v-model="pessoaVeiCoDedData.table_category" class="form-control"
                            :class="{'is-invalid': submmitedVeiCoDedData && !pessoaVeiCoDedData.table_category}">
                      <option value="A">A</option>
                      <option value="B">B</option>
                      <option value="C">C</option>
                      <option value="D">D</option>
                    </select>
                    <div v-if="submmitedVeiCoDedData && !pessoaVeiCoDedData.table_category" class="invalid-feedback">
                      <span>Campo categoria tabela obrigatório, favor selecionar.</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-2">
                  <div class="mb-3">
                    <label for="freight_load">Tipo de Carga</label>
                    <select id="freight_load" v-model="pessoaVeiCoDedData.freight_load" class="form-control"
                            :class="{'is-invalid': submmitedVeiCoDedData && !pessoaVeiCoDedData.freight_load}">
                      <option value="granel_solido">Granel Sólido</option>
                      <option value="granel_liquido">Granel Líquido</option>
                      <option value="frigorificada">Frigorificada</option>
                      <option value="conteinerizada">Conteinerizada</option>
                      <option value="geral">Geral</option>
                      <option value="neogranel">Neogranel</option>
                      <option value="perigosa_granel_solido">Perigosa Granel Sólido</option>
                      <option value="perigosa_granel_liquido">Perigosa Granel Líquido</option>
                      <option value="perigosa_frigorificada">Perigosa Frigorificada</option>
                      <option value="perigosa_conteinerizada">Perigosa Conteinerizada</option>
                      <option value="perigosa_geral">Perigosa Geral</option>
                      <option value="Granel Pressurizada">Granel Pressurizada</option>
                    </select>
                    <div v-if="submmitedVeiCoDedData && !pessoaVeiCoDedData.freight_load" class="invalid-feedback">
                      <span>Campo tipo de carga obrigatório, favor selecionar.</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-2">
                  <div class="mb-3">
                    <label for="table_axis">Eixos (Tabela)</label>
                    <select id="table_axis"
                            v-model="pessoaVeiCoDedData.table_axis" class="form-control"
                            :class="{'is-invalid': submmitedVeiCoDedData && !pessoaVeiCoDedData.table_axis}">
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                      <option value="8">8</option>
                      <option value="9">9</option>
                    </select>
                    <div v-if="submmitedVeiCoDedData && !pessoaVeiCoDedData.table_axis" class="invalid-feedback">
                      <span>Campo eixos tabela obrigatório, favor selecionar.</span>
                    </div>
                  </div>
                </div>

              </div>

              <div class="row">
                <div class="text-end mt-5">
                  <b-button variant="light" @click="showFormVeiCotDed = false">
                    <i class="bx bx-block font-size-16 align-middle me-2"></i>
                    Cancelar
                  </b-button>

                  <b-button type="button" variant="success" class="ms-1" @click="confVeiCotDed">
                    <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                    Confirmar
                  </b-button>
                </div>
              </div>

            </form>

          </div>
        </div>
      </div>
    </b-modal>



    <b-modal size="xl"
             :title="pessoaVeicData.id > 0 ? `Editar Veículo (${pessoaVeicData.id})` : 'Criar Veículo'"
             v-model="showFormVeic" centered hide-footer>
      <div class="row" id="div-principal">
        <div class="row" id="div-card">
          <div class="card-body" id="div-car-body">

            <form class="needs-validation">


              <div class="row">

                <div class="col-sm-4">
                  <div class="mb-3">
                    <label for="descricaoveic">Descrição</label>
                    <input id="descricaoveic"
                           v-model="pessoaVeicData.descricao"
                           type="text"
                           class="form-control"
                           :class="{ 'is-invalid': submmitedVeicData && !pessoaVeicData.descricao }"
                           placeholder="Descrição" />
                    <div v-if="submmitedVeicData && !pessoaVeicData.descricao" class="invalid-feedback">
                      <span>Campo descrição obrigatório e válido, favor corrigir.</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-2">
                  <div class="mb-3">
                    <label for="placaveic">Placa</label>
                    <input id="placaveic"
                           v-model="pessoaVeicData.placa"
                           type="text"
                           class="form-control"
                           :class="{ 'is-invalid': submmitedVeicData && !pessoaVeicData.placa }"
                           placeholder="Placa" />
                    <div v-if="submmitedVeicData && !pessoaVeicData.placa" class="invalid-feedback">
                      <span>Campo placa obrigatório e válido, favor corrigir.</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-3">
                  <div class="mb-3">
                    <label for="statusveic">Status</label>
                    <select
                        id="statusveic"
                        v-model="pessoaVeicData.status"
                        class="form-control"
                        :class="{'is-invalid': submmitedVeicData && !pessoaVeicData.status}">
                      <option value="A">Ativo (A)</option>
                      <option value="I">Inativo (I)</option>
                    </select>
                    <div v-if="submmitedVeicData && !pessoaVeicData.status" class="invalid-feedback">
                      <span>Campo status obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-3">
                  <div class="mb-3">
                    <label for="tipoveic">Tipo</label>
                    <select
                        id="tipoveic"
                        v-model="pessoaVeicData.tipo"
                        class="form-control"
                        :class="{'is-invalid': submmitedVeicData && !pessoaVeicData.tipo}">
                      <option value="MOTO">Moto</option>
                      <option value="PASSEIO">Passeio</option>
                      <option value="UTILITARIO">Utilitário</option>
                      <option value="VUC">VUC</option>
                    </select>
                    <div v-if="submmitedVeicData && !pessoaVeicData.tipo" class="invalid-feedback">
                      <span>Campo tipo obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>

<!--                <div class="col-sm-4">-->
<!--                  <div class="mb-3">-->
<!--                    <label for="obspesveic">Observação</label>-->
<!--                    <select-->
<!--                        id="obspesveic"-->
<!--                        v-model="pessoaVeicData.obs"-->
<!--                        class="form-control">-->
<!--                      <option value="PACOTE">Pacote</option>-->
<!--                      <option value="MEIAROTA">Meia Rota</option>-->
<!--                      <option value="ROTACOMPLETA">Rota Completa</option>-->
<!--                    </select>-->
<!--                  </div>-->
<!--                </div>-->

<!--                <div class="col-sm-2">-->
<!--                  <div class="mb-3">-->
<!--                    <label for="pacoteveic">Pacote</label>-->
<!--                    <input id="pacoteveic"-->
<!--                           v-model="pessoaVeicData.pacote"-->
<!--                           type="number"-->
<!--                           class="form-control"-->
<!--                           placeholder="Pacote" />-->
<!--                  </div>-->
<!--                </div>-->


              </div>

              <div class="row">

                <div class="col-sm-2">
                  <div class="mb-3">
                    <label for="vlrrotacompl">Valor Rota Completa</label>
                    <input id="vlrrotacompl"
                           v-model="pessoaVeicData.vlrrotacompl"
                           type="number"
                           class="form-control"
                           placeholder="Valor Rota Completa" />
                  </div>
                </div>

<!--                <div class="col-sm-2">-->
<!--                  <div class="mb-3">-->
<!--                    <label for="vlrpacote">Valor Pacote</label>-->
<!--                    <input id="vlrpacote"-->
<!--                           v-model="pessoaVeicData.vlrpacote"-->
<!--                           type="number"-->
<!--                           class="form-control"-->
<!--                           placeholder="Valor Pacote" />-->
<!--                  </div>-->
<!--                </div>-->

                <div class="col-sm-2">
                  <div class="mb-3">
                    <label for="vlrmeiarota">Valor Meia Rota</label>
                    <input id="vlrmeiarota"
                           v-model="pessoaVeicData.vlrmeiarota"
                           type="number"
                           class="form-control"
                           placeholder="Valor Meia Rota" />
                  </div>
                </div>

                <div class="col-sm-2">
                  <div class="mb-3">
                    <label for="vlreficacia">Valor Eficácia</label>
                    <input id="vlreficacia"
                           v-model="pessoaVeicData.vlreficacia"
                           type="number"
                           class="form-control"
                           placeholder="Valor Eficácia" />
                  </div>
                </div>

<!--                <div class="col-sm-2">-->
<!--                  <div class="mb-3">-->
<!--                    <label for="qtdadicentr">Qtd.Adic.Entrega</label>-->
<!--                    <input id="qtdadicentr"-->
<!--                           v-model="pessoaVeicData.qtdadicentr"-->
<!--                           type="number"-->
<!--                           class="form-control"-->
<!--                           placeholder="Qtd.Adic.Entrega" />-->
<!--                  </div>-->
<!--                </div>-->


<!--                <div class="col-sm-2">-->
<!--                  <div class="mb-3">-->
<!--                    <label for="vlradicentr">Vlr.Adic.Entrega</label>-->
<!--                    <input id="vlradicentr"-->
<!--                           v-model="pessoaVeicData.vlradicentr"-->
<!--                           type="number"-->
<!--                           class="form-control"-->
<!--                           placeholder="Vlr.Adic.Entrega" />-->
<!--                  </div>-->
<!--                </div>-->

<!--                <div class="col-sm-2">-->
<!--                  <div class="mb-3">-->
<!--                    <label for="multvlreceb">Múlt.Vlr.Receb</label>-->
<!--                    <input id="multvlreceb"-->
<!--                           v-model="pessoaVeicData.multvlreceb"-->
<!--                           type="number"-->
<!--                           class="form-control"-->
<!--                           placeholder="Múlt.Vlr.Receb" />-->
<!--                  </div>-->
<!--                </div>-->


              </div>




              <hr />

              <h5>Faixas de Cálculo</h5>

              <Loader v-if="loadingVeicFxs" style="min-height: 200px;">
              </Loader>

              <div class="row" v-if="!loadingVeicFxs">

                <div class="table-responsive">
                  <table class="table align-middle mb-0 table-nowrap">
                    <thead class="table-light">
                    <tr>
                      <th scope="col">ID</th>
                      <th scope="col" class="text-end">Data</th>
                      <th scope="col" class="text-end">Mínimo</th>
                      <th scope="col" class="text-end">Máximo</th>
                      <th scope="col" class="text-end">Valor Mínimo</th>
                      <th scope="col" class="text-end">Valor</th>
                      <th scope="col" class="text-end">Ações</th>
                    </tr>
                    </thead>
                    <tbody>

                    <tr v-for="data of pessoaVeicFxsData" :key="data.id">
                      <td>
                        <a href="javascript: void(0);" @click="editarVeicFx(data)" class="text-body fw-bold">
                          {{ data.id }}
                        </a>
                      </td>
                      <td class="text-end"> {{ formatDateTime(data.created_at) }} </td>
                      <td class="text-end"> {{ data.minimo }} </td>
                      <td class="text-end"> {{ data.maximo }} </td>
                      <td class="text-end"> {{ data.valormin }} </td>
                      <td class="text-end"> {{ data.valor }} </td>
                      <td class="text-end">
                        <div class="button-items">
                          <b-button variant="outline-warning" @click="editarVeicFx(data)">
                            <i class="mdi mdi-pencil d-block font-size-16"></i>
                          </b-button>
                          <b-button variant="outline-danger" @click="deletarVeicFx(data.id)">
                            <i class="mdi mdi-trash-can d-block font-size-16"></i>
                          </b-button>
                        </div>
                      </td>
                    </tr>

                    </tbody>
                  </table>
                </div>




                <div class="row mt-3" v-if="novaFaixaVeic">

                  <h6 v-if="pessoaVeicFxData && pessoaVeicFxData.id > 0">Faixa de Cálculo {{ pessoaVeicFxData.id }}</h6>
                  <h6 v-else>Nova Faixa de Cálculo</h6>


                  <div class="col-sm-3">
                    <div class="mb-3">
                      <label for="pessoaveicfxmin">Mínimo</label>
                      <input id="pessoaveicfxmin"
                             v-model="pessoaVeicFxData.minimo"
                             type="number"
                             class="form-control"
                             :class="{ 'is-invalid': submmitedVeicFxData && !pessoaVeicFxData.minimo }"
                             placeholder="Mínimo" />
                      <div v-if="submmitedVeicFxData && !pessoaVeicFxData.minimo" class="invalid-feedback">
                        <span>Campo mínimo obrigatório e válido, favor corrigir.</span>
                      </div>
                    </div>
                  </div>


                  <div class="col-sm-3">
                    <div class="mb-3">
                      <label for="pessoaveicfxmax">Máximo</label>
                      <input id="pessoaveicfxmax"
                             v-model="pessoaVeicFxData.maximo"
                             type="number"
                             class="form-control"
                             :class="{ 'is-invalid': submmitedVeicFxData && !pessoaVeicFxData.maximo }"
                             placeholder="Máximo" />
                      <div v-if="submmitedVeicFxData && !pessoaVeicFxData.maximo" class="invalid-feedback">
                        <span>Campo máximo obrigatório e válido, favor corrigir.</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-3">
                    <div class="mb-3">
                      <label for="pessoaveicfxvalormin">Valor Mínimo</label>
                      <input id="pessoaveicfxvalormin"
                             v-model="pessoaVeicFxData.valormin"
                             type="number"
                             class="form-control"
                             placeholder="Valor Mínimo" />
                    </div>
                  </div>

                  <div class="col-sm-3">
                    <div class="mb-3">
                      <label for="pessoaveicfxvalor">Valor</label>
                      <input id="pessoaveicfxvalor"
                             v-model="pessoaVeicFxData.valor"
                             type="number"
                             class="form-control"
                             :class="{ 'is-invalid': submmitedVeicFxData && !pessoaVeicFxData.valor }"
                             placeholder="Valor" />
                      <div v-if="submmitedVeicFxData && !pessoaVeicFxData.valor" class="invalid-feedback">
                        <span>Campo valor obrigatório e válido, favor corrigir.</span>
                      </div>
                    </div>
                  </div>


                </div>



              </div>



              <div class="row">
                <div class="text-end mt-5">
                  <b-button variant="light" @click="showFormVeic = false">
                    <i class="bx bx-block font-size-16 align-middle me-2"></i>
                    Cancelar
                  </b-button>

                  <b-button type="button"
                            :disabled="novaFaixaVeic === true"
                            v-if="pessoaVeicData && pessoaVeicData.id > 0"
                            variant="warning"
                            class="ms-1" @click="novaFaixa" >
                    <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                    Nova Faixa
                  </b-button>



                  <b-button type="button"
                            v-if="novaFaixaVeic === true"
                            variant="outline-success"
                            class="ms-1" @click="confVeicFx">
                    <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                    Confirmar Faixa
                  </b-button>

                  <b-button type="button" variant="success" class="ms-1" @click="confVeic">
                    <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                    Confirmar
                  </b-button>
                </div>
              </div>

            </form>

          </div>
        </div>
      </div>
    </b-modal>


    <b-modal size="xl" :title="pessoaRepresComissao.id > 0 ? `Editar Parâmetro de Comissão (${pessoaRepresComissao.id})` :
      'Criar Parâmetro de Comissão'" v-model="showParamComissao" centered hide-footer>
      <div class="row" id="div-principal">
        <div class="row" id="div-card">
          <div class="card-body" id="div-car-body">

            <form class="needs-validation">


              <div class="row">
                <div class="col-sm-4">
                  <div class="mb-3">
                    <label for="descricaoveic">Descrição</label>
                    <input id="descricaoveic"
                           v-model="pessoaRepresComissao.descricao"
                           type="text"
                           class="form-control"
                           disabled
                           placeholder="Descrição" />
                  </div>
                </div>

                <div class="col-sm-2">
                  <div class="mb-3">
                    <label for="cnpjrepres">CPF/CNPJ</label>
                    <input id="cnpjrepres"
                           v-model="pessoaRepresComissao.contacpf"
                           type="text"
                           class="form-control"
                           disabled
                           placeholder="Código" />
                  </div>
                </div>

                <div class="col-sm-2">
                  <div class="mb-3">
                    <label for="statusveic">Status</label>
                    <select
                        id="statusveic"
                        v-model="pessoaRepresComissao.status"
                        class="form-control"
                        >
                      <option value="A">Ativo (A)</option>
                      <option value="I">Inativo (I)</option>
                    </select>
                  </div>
                </div>

                <div class="col-sm-2">
                  <div class="mb-3">
                    <label for="equiperepres">Equipe do Repres.</label>
                    <multiselect id="equiperepres"
                                 v-model="pessoaRepresComissao.represtime_id"
                                 placeholder="Seleciona equipe"
                                 :options="dtListEquipesRepres"
                                 label="nome"
                                 track-by="nome"
                                 value-prop="id">
                      <template #option="slotProps">
                        <div class="row">
                          <span class="" >
                            {{ slotProps.option.nome }}
                          </span>
                        </div>
                      </template>
                    </multiselect>
                  </div>
                </div>

                <div class="col-sm-2">
                  <div class="mb-3">
                    <label for="lider"> Tipo Repres.</label>
                    <b-form-checkbox switch size="lg" v-model="pessoaRepresComissao.lider" >
                      {{ pessoaRepresComissao.lider === false ? 'Padrão' : 'Líder' }}
                    </b-form-checkbox>
                  </div>
                </div>
              </div>

              <div class="mt-4">
                <b-tabs nav-class="bg-light rounded" pills content-class="mt-4">
                  <b-tab title="Dados Bancários" active>
                    <div class="row">
                      <div class="col-4">
                        <div class="mb-3">
                          <label for="nomefavorecido">Nome Favorecido</label>
                          <input
                              id="nomefavorecido"
                              v-model="pessoaRepresComissao.nomefavorecido"
                              type="text"
                              class="form-control"
                              placeholder="Inserir nome favorecido"
                              />
                        </div>
                      </div>

                      <div class="col-8"></div>

                      <div class="col-md-3">
                        <div class="mb-3">
                          <label for="inputFinConta">Instituição Bancária</label>
                          <input
                              id="inputFinConta"
                              v-model="pessoaRepresComissao.banco"
                              type="text"
                              class="form-control"
                              placeholder="Inserir Nome Inst. Bancária"
                          />
                        </div>
                      </div>

                      <div class="col-3">
                        <div class="mb-3">
                          <label for="banco">Nro Inst. Bancária</label>
                          <input
                              id="banco"
                              v-model="pessoaRepresComissao.banco_id"
                              type="text"
                              class="mb-3 form-control"
                              placeholder="Inserir Nro do Banco"
                          />
                        </div>
                      </div>

                      <div class="col-2">
                        <div class="mb-3">
                          <label for="agencia">Agência</label>
                          <input
                              id="agencia"
                              v-model="pessoaRepresComissao.agencia"
                              type="text"
                              class="mb-3 form-control"
                              placeholder="Inserir Agência"
                              />
                        </div>
                      </div>

                      <div class="col-2">
                        <div class="mb-3">
                          <label for="conta">Conta</label>
                          <input
                              id="conta"
                              v-model="pessoaRepresComissao.conta"
                              type="text"
                              class="form-control"
                              placeholder="Inserir Conta"/>
                        </div>
                      </div>

                      <div class="col-2">
                        <div class="mb-3">
                          <label for="selecttipo">Tipo da Operação</label>
                          <b-form-select
                              id="selecttipo"
                              v-model="pessoaRepresComissao.tipo"
                              class="form-select form-control"
                          >
                            <b-form-select-option value="PIX">PIX</b-form-select-option>
                            <b-form-select-option value="TED">TED</b-form-select-option>
                          </b-form-select>
                        </div>
                      </div>

                      <div class="col-2" v-if="pessoaRepresComissao.tipo === 'PIX'">
                        <div class="mb-3">
                          <label for="tipochavepix">Tipo Chave Pix</label>
                          <b-form-select
                              id="tipochavepix"
                              v-model="pessoaRepresComissao.tipochavepix"
                              class="mb-3 form-select form-control"
                              >
                            <b-form-select-option value="CPF">
                              CPF
                            </b-form-select-option>
                            <b-form-select-option value="EMAIL">
                              E-mail
                            </b-form-select-option>
                            <b-form-select-option value="TELEFONE">
                              Telefone
                            </b-form-select-option>
                            <b-form-select-option value="CHAVE ALEATORIA">
                              Chave Aleatória
                            </b-form-select-option>
                            <b-form-select-option value="NAO DEFINIDO">
                              Não Definido
                            </b-form-select-option>
                          </b-form-select>
                        </div>
                      </div>

                      <div class="col-4" v-if="pessoaRepresComissao.tipo === 'PIX'">
                        <div class="mb-3">
                          <label for="chavepix">Chave Pix</label>
                          <input
                              id="chavepix"
                              v-model="pessoaRepresComissao.chavepix"
                              type="text"
                              class="form-control"
                              placeholder="Inserir chave pix"
                              />
                        </div>
                      </div>
                    </div>
                  </b-tab>
                </b-tabs>
              </div>

              <hr />

              <h5 class="mb-4">Parâmetros de Retenção de Comissão</h5>

              <div class="row mb-4">
                <div class="col-sm-3">
                  <div class="mb-3">
                    <label for="totalSaldoRetido">Total Saldo Atual Retido</label>
                    <input
                        id="totalSaldoRetido"
                        v-model="pessoaRepresComissao.total_saldo_atual_retido"
                        type="number"
                        step="0.01"
                        class="form-control"
                        placeholder="0,00"/>
                  </div>
                </div>

                <div class="col-sm-3">
                  <div class="mb-3">
                    <label for="inadimplenciaAtual">Inadimplência Atual</label>
                    <input
                        id="inadimplenciaAtual"
                        v-model="pessoaRepresComissao.inadimplencia_atual"
                        type="number"
                        step="0.01"
                        class="form-control"
                        placeholder="0,00"/>
                  </div>
                </div>

                <div class="col-sm-3">
                  <div class="mb-3">
                    <label for="limiteDebito50">Limite de Débito 50% <small class="text-muted">(calculado)</small></label>
                    <input
                        id="limiteDebito50"
                        :value="((pessoaRepresComissao.inadimplencia_atual ?? 0) * 0.5).toFixed(2)"
                        type="text"
                        class="form-control bg-light"
                        disabled/>
                  </div>
                </div>

                <div class="col-sm-3">
                  <div class="mb-3">
                    <label for="percRetencaoPadrao">% Padrão de Retenção da Comissão</label>
                    <input
                        id="percRetencaoPadrao"
                        v-model="pessoaRepresComissao.perc_retencao_padrao"
                        type="number"
                        step="0.01"
                        min="0"
                        max="100"
                        class="form-control"
                        placeholder="20"/>
                  </div>
                </div>
              </div>

              <hr />

              <h5 class="mb-4">Parâmetros de Cálculo de Comissão </h5>

              <Loader v-if="loadingRepresFxs" style="min-height: 200px;">
              </Loader>

              <div class="row" v-if="!loadingRepresFxs">

                <div class="table-responsive col-8">
                  <label>Parâmetros Faixa Repres.</label>
                  <table class="table align-middle mb-0 table-nowrap">
                    <thead class="table-light">
                      <tr>
                        <th scope="col" class="text-center">ID</th>
                        <th scope="col" class="text-end">Mín. Fat.</th>
                        <th scope="col" class="text-end">Máx. Fat.</th>
                        <th scope="col" class="text-end">Vlr. Mín.</th>
                        <th scope="col" class="text-end">Vlr. Máx.</th>
                        <th scope="col" class="text-end">Mín. %</th>
                        <th scope="col" class="text-end">Máx. %</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="pessoaRepresFxData.length === 0">
                        <td class="text-center" colspan="7">Nenhum parâmetro de faixa selecionado.</td>
                      </tr>
                      <tr v-else v-for="data in pessoaRepresFxData" :key="data.id">
                        <td class="text-end"> {{ data.id }} </td>
                        <td class="text-end"> {{ data.minimofat }} </td>
                        <td class="text-end"> {{ data.maximofat }} </td>
                        <td class="text-end"> {{ data.valormin }} </td>
                        <td class="text-end"> {{ data.valormax }} </td>
                        <td class="text-end"> {{ data.percentmin }} </td>
                        <td class="text-end"> {{ data.percentmax }} </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="col-md-3 ms-auto">
                  <div class="mb-3">
                    <label for="represfx">Parâm. de Faixa Associado</label>
                    <multiselect
                        v-model="pessoaRepresComissao.represfx_ids"
                        :mode="'tags'"
                        class="mt-2"
                        :options="optionsRepresFx"
                        placeholder="Selecionar tipo de pessoa"
                        label="descricao"
                        track-by="id"
                        value-prop="id"
                    >
                      <template #option="slotProps">
                        <div style="min-width: 50px;">
                              <span class="text-info">
                                {{ slotProps.option.id }}
                              </span>
                        </div>
                        <div style="min-width: 300px;">
                              <span class="mx-4">
                                {{ slotProps.option.descricao }}
                              </span>
                        </div>
                      </template>
                    </multiselect>
                  </div>
                </div>

                <div class="mx-2 mt-4">
                  <span class="me-1"> Caso a faixa ou a equipe de representante não esta na lista click aqui: </span>
                  <a class="text-info" title="Redireciona para config. faixas/equipes representantes." @click="redirectFaixaRepres" style="cursor: pointer;">
                    <i class="mdi mdi-pencil font-size-16 align-middle mx1-"></i>
                    Criar faixa/equipe repres.
                  </a>
                </div>
              </div>

              <div class="row">
                <div class="text-end mt-5">
                  <b-button variant="light" @click="showParamComissao = false">
                    <i class="bx bx-block font-size-16 align-middle me-2"></i>
                    Cancelar
                  </b-button>

                  <b-button type="button" variant="success" class="ms-1" @click="confRepres">
                    <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                    Confirmar
                  </b-button>
                </div>
              </div>

            </form>

          </div>
        </div>
      </div>
    </b-modal>

    <b-modal title="Data para reprocessamento" v-model="showModalDataReprocessamento" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-1">
          <label for="dtReprocessamento">Selecionar Data:</label>
        </div>
      </div>
      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <input
                id="dtReprocessamento"
                v-model="dtReprocessamento"
                type="date"
                class="form-control"
                :class="{'is-invalid': submittedPeriodo && !dtReprocessamento,}"/>
            <div v-if="submittedPeriodo && !dtReprocessamento"
                 class="invalid-feedback">
              <span >Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalDataReprocessamento = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="reprocessarEmailsRedirecionamento">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>

    <b-modal v-model="showModalHelp" id="showModalHelp" size="lg" title="Descrição das funcionalidades"
      title-class="font-18" hide-footer>
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>Tipo</th>
                      <th>Descrição</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="data in dtListHelp" :key="data.id">
                      <td>{{ data.tipo }}</td>
                      <td>{{ data.descricao }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>

<style>
.quitado {
  background-color: rgb(51, 126, 255);
}

.aberto {
  background-color: rgb(163, 236, 217);
}

.cancelado {
  background-color: rgb(255, 90, 90);
}

/* Email Input Styles */
.email-input-container {
  width: 100%;
}

.email-tags-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px;
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  background-color: #fff;
  min-height: 42px;
  align-items: center;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.email-tags-wrapper:focus-within {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.email-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background-color: #e7f3ff;
  border: 1px solid #b3d9ff;
  color: #0056b3;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}

.email-tag i {
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.email-tag i:hover {
  color: #dc3545;
  transform: scale(1.2);
}

.email-tag-invalid {
  background-color: #ffe7e7;
  border-color: #ffb3b3;
  color: #dc3545;
}

.email-tag-invalid i:hover {
  color: #a02622;
}

.email-input-field {
  border: none;
  outline: none;
  background: transparent;
  flex: 1;
  min-width: 150px;
  font-size: 12px;
  padding: 4px 0;
}

.email-input-field::placeholder {
  color: #6c757d;
  font-style: italic;
}

/* Animation for email tag addition */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.email-tag {
  animation: slideIn 0.2s ease-out;
}
</style>
